// tslint:disable
/**
 * styletech api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AiFilterDTO
 */
export interface AiFilterDTO {
    /**
     * 
     * @type {string}
     * @memberof AiFilterDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AiFilterDTO
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface AiItemDTO
 */
export interface AiItemDTO {
    /**
     * 
     * @type {number}
     * @memberof AiItemDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AiItemDTO
     */
    aiType?: string;
    /**
     * 
     * @type {number}
     * @memberof AiItemDTO
     */
    scale?: number;
    /**
     * 
     * @type {string}
     * @memberof AiItemDTO
     */
    dimension?: string;
}
/**
 * 
 * @export
 * @interface AppSearchRequest
 */
export interface AppSearchRequest {
    /**
     * 
     * @type {Array<FilterIdsDTO>}
     * @memberof AppSearchRequest
     */
    filterIds: Array<FilterIdsDTO>;
    /**
     * 
     * @type {number}
     * @memberof AppSearchRequest
     */
    categoryId: number;
    /**
     * 
     * @type {string}
     * @memberof AppSearchRequest
     */
    gender: AppSearchRequestGenderEnum;
    /**
     * 
     * @type {number}
     * @memberof AppSearchRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof AppSearchRequest
     */
    length?: number;
    /**
     * 
     * @type {string}
     * @memberof AppSearchRequest
     */
    sortBy?: AppSearchRequestSortByEnum;
    /**
     * 
     * @type {string}
     * @memberof AppSearchRequest
     */
    sortOrder?: AppSearchRequestSortOrderEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AppSearchRequestGenderEnum {
    KID_BOY = 'KID_BOY',
    KID_GIRL = 'KID_GIRL',
    MAN = 'MAN',
    WOMAN = 'WOMAN',
    KID_UNISEX = 'KID_UNISEX',
    UNISEX = 'UNISEX',
    INFANT = 'INFANT'
}
/**
    * @export
    * @enum {string}
    */
export enum AppSearchRequestSortByEnum {
    DATE = 'DATE',
    PRICE = 'PRICE',
    SALE_PERCENT = 'SALE_PERCENT'
}
/**
    * @export
    * @enum {string}
    */
export enum AppSearchRequestSortOrderEnum {
    ASC = 'ASC',
    DESC = 'DESC'
}

/**
 * 
 * @export
 * @interface AuthorDTO
 */
export interface AuthorDTO {
    /**
     * 
     * @type {number}
     * @memberof AuthorDTO
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthorDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorDTO
     */
    surname?: string;
}
/**
 * 
 * @export
 * @interface BodyDTO
 */
export interface BodyDTO {
    /**
     * 
     * @type {number}
     * @memberof BodyDTO
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof BodyDTO
     */
    chest?: number;
    /**
     * 
     * @type {number}
     * @memberof BodyDTO
     */
    waist?: number;
    /**
     * 
     * @type {number}
     * @memberof BodyDTO
     */
    hips?: number;
}
/**
 * 
 * @export
 * @interface BucketItemDTO
 */
export interface BucketItemDTO {
    /**
     * 
     * @type {number}
     * @memberof BucketItemDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof BucketItemDTO
     */
    itemId?: number;
    /**
     * 
     * @type {string}
     * @memberof BucketItemDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BucketItemDTO
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof BucketItemDTO
     */
    priceId?: number;
    /**
     * 
     * @type {string}
     * @memberof BucketItemDTO
     */
    pictUrl?: string;
    /**
     * 
     * @type {Array<PriceDTO>}
     * @memberof BucketItemDTO
     */
    sizes?: Array<PriceDTO>;
    /**
     * 
     * @type {string}
     * @memberof BucketItemDTO
     */
    brandName?: string;
}
/**
 * 
 * @export
 * @interface BucketItemShortDTO
 */
export interface BucketItemShortDTO {
    /**
     * 
     * @type {number}
     * @memberof BucketItemShortDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof BucketItemShortDTO
     */
    itemId?: number;
    /**
     * 
     * @type {string}
     * @memberof BucketItemShortDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BucketItemShortDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof BucketItemShortDTO
     */
    size?: string;
    /**
     * 
     * @type {number}
     * @memberof BucketItemShortDTO
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof BucketItemShortDTO
     */
    pictUrl?: string;
}
/**
 * 
 * @export
 * @interface BucketOrderDTO
 */
export interface BucketOrderDTO {
    /**
     * 
     * @type {number}
     * @memberof BucketOrderDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BucketOrderDTO
     */
    status?: BucketOrderDTOStatusEnum;
    /**
     * 
     * @type {Array<BucketItemShortDTO>}
     * @memberof BucketOrderDTO
     */
    items?: Array<BucketItemShortDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum BucketOrderDTOStatusEnum {
    WAITING = 'WAITING',
    IN_PROGRESS = 'IN_PROGRESS',
    CANCELED = 'CANCELED',
    FINISHED = 'FINISHED'
}

/**
 * 
 * @export
 * @interface CartItemDTO
 */
export interface CartItemDTO {
    /**
     * 
     * @type {number}
     * @memberof CartItemDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemDTO
     */
    itemId?: number;
    /**
     * 
     * @type {PriceDTO}
     * @memberof CartItemDTO
     */
    price?: PriceDTO;
    /**
     * 
     * @type {string}
     * @memberof CartItemDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemDTO
     */
    brandName?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemDTO
     */
    pictUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemDTO
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemDTO
     */
    status?: CartItemDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof CartItemDTO
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof CartItemDTO
     */
    supplierName?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemDTO
     */
    colorName?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemDTO
     */
    productId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CartItemDTO
     */
    available?: boolean;
    /**
     * 
     * @type {Array<CartItemRejectInfoDTO>}
     * @memberof CartItemDTO
     */
    rejectStatus?: Array<CartItemRejectInfoDTO>;
    /**
     * 
     * @type {Array<CatalogItemShortDTO>}
     * @memberof CartItemDTO
     */
    suggestedReplacements?: Array<CatalogItemShortDTO>;
    /**
     * 
     * @type {string}
     * @memberof CartItemDTO
     */
    aiType?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CartItemDTOStatusEnum {
    SAND_BOX = 'SAND_BOX',
    BUYING = 'BUYING',
    FITTING = 'FITTING',
    BOUGHT = 'BOUGHT',
    REJECTED = 'REJECTED'
}

/**
 * 
 * @export
 * @interface CartItemRejectInfoDTO
 */
export interface CartItemRejectInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof CartItemRejectInfoDTO
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemRejectInfoDTO
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface CartItemShortDTO
 */
export interface CartItemShortDTO {
    /**
     * 
     * @type {number}
     * @memberof CartItemShortDTO
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemShortDTO
     */
    quantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CartItemShortDTO
     */
    available?: boolean;
    /**
     * 
     * @type {Array<CartItemRejectInfoDTO>}
     * @memberof CartItemShortDTO
     */
    rejectInfo?: Array<CartItemRejectInfoDTO>;
}
/**
 * 
 * @export
 * @interface CatalogItemFullDTO
 */
export interface CatalogItemFullDTO {
    /**
     * 
     * @type {number}
     * @memberof CatalogItemFullDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    type?: CatalogItemFullDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    brandName?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    categoryName?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    colorName?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    gender?: CatalogItemFullDTOGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    material?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    supplier?: string;
    /**
     * 
     * @type {Array<PriceDTO>}
     * @memberof CatalogItemFullDTO
     */
    prices?: Array<PriceDTO>;
    /**
     * 
     * @type {Array<PictureDTO>}
     * @memberof CatalogItemFullDTO
     */
    pictures?: Array<PictureDTO>;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    aiCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    originalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemFullDTO
     */
    source?: CatalogItemFullDTOSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogItemFullDTO
     */
    canDeliver?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogItemFullDTO
     */
    available?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogItemFullDTO
     */
    score?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum CatalogItemFullDTOTypeEnum {
    CLOTHES = 'CLOTHES',
    BAG = 'BAG',
    ACCESSORY = 'ACCESSORY',
    SHOES = 'SHOES',
    JEWEL = 'JEWEL'
}
/**
    * @export
    * @enum {string}
    */
export enum CatalogItemFullDTOGenderEnum {
    KID_BOY = 'KID_BOY',
    KID_GIRL = 'KID_GIRL',
    MAN = 'MAN',
    WOMAN = 'WOMAN',
    KID_UNISEX = 'KID_UNISEX',
    UNISEX = 'UNISEX',
    INFANT = 'INFANT'
}
/**
    * @export
    * @enum {string}
    */
export enum CatalogItemFullDTOSourceEnum {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL'
}

/**
 * 
 * @export
 * @interface CatalogItemShortDTO
 */
export interface CatalogItemShortDTO {
    /**
     * 
     * @type {number}
     * @memberof CatalogItemShortDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemShortDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemShortDTO
     */
    brandName: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemShortDTO
     */
    pictUrl: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogItemShortDTO
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemShortDTO
     */
    supplierName: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemShortDTO
     */
    aiCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemShortDTO
     */
    source?: CatalogItemShortDTOSourceEnum;
    /**
     * 
     * @type {Array<PriceShortDTO>}
     * @memberof CatalogItemShortDTO
     */
    prices?: Array<PriceShortDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogItemShortDTO
     */
    canDeliver?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogItemShortDTO
     */
    gender?: CatalogItemShortDTOGenderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogItemShortDTO
     */
    available: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogItemShortDTO
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogItemShortDTO
     */
    priceDiscount?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum CatalogItemShortDTOSourceEnum {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL'
}
/**
    * @export
    * @enum {string}
    */
export enum CatalogItemShortDTOGenderEnum {
    KID_BOY = 'KID_BOY',
    KID_GIRL = 'KID_GIRL',
    MAN = 'MAN',
    WOMAN = 'WOMAN',
    KID_UNISEX = 'KID_UNISEX',
    UNISEX = 'UNISEX',
    INFANT = 'INFANT'
}

/**
 * 
 * @export
 * @interface CategoryDTO
 */
export interface CategoryDTO {
    /**
     * 
     * @type {number}
     * @memberof CategoryDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryDTO
     */
    scale?: number;
}
/**
 * 
 * @export
 * @interface CheckItemDTO
 */
export interface CheckItemDTO {
    /**
     * 
     * @type {number}
     * @memberof CheckItemDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckItemDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CheckItemDTO
     */
    price: string;
    /**
     * 
     * @type {string}
     * @memberof CheckItemDTO
     */
    sum: string;
    /**
     * 
     * @type {number}
     * @memberof CheckItemDTO
     */
    quantity: number;
}
/**
 * 
 * @export
 * @interface ClientDTO
 */
export interface ClientDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDTO
     */
    stylistName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDTO
     */
    status?: ClientDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ClientDTO
     */
    thingsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientDTO
     */
    looksCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientDTO
     */
    createdAtMillis?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ClientDTOStatusEnum {
    ACTIVE = 'ACTIVE',
    NEW = 'NEW',
    FORMER = 'FORMER',
    WAITING = 'WAITING',
    STYLE_MATE = 'STYLE_MATE'
}

/**
 * 
 * @export
 * @interface ClientFilterDTO
 */
export interface ClientFilterDTO {
    /**
     * 
     * @type {string}
     * @memberof ClientFilterDTO
     */
    type: ClientFilterDTOTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientFilterDTO
     */
    ids: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum ClientFilterDTOTypeEnum {
    STYLIST = 'STYLIST',
    STATUS = 'STATUS'
}

/**
 * 
 * @export
 * @interface ClientInfoDTO
 */
export interface ClientInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientInfoDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    surname?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientInfoDTO
     */
    stylistId?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    birthday?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    gender: ClientInfoDTOGenderEnum;
    /**
     * 
     * @type {number}
     * @memberof ClientInfoDTO
     */
    cashBack?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    status: ClientInfoDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    styleComments?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    bodyComments?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    jobDetails?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    clientRequest?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    preferredStores?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    preferences?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    restrictions?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    category?: ClientInfoDTOCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    stylistNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    sourceFromInfo?: string;
    /**
     * 
     * @type {SizeDTO}
     * @memberof ClientInfoDTO
     */
    size?: SizeDTO;
    /**
     * 
     * @type {BodyDTO}
     * @memberof ClientInfoDTO
     */
    body?: BodyDTO;
    /**
     * 
     * @type {Array<ShoppingShortDTO>}
     * @memberof ClientInfoDTO
     */
    shoppingList?: Array<ShoppingShortDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    selfieUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoDTO
     */
    fullLengthPhotoUrl?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ClientInfoDTOGenderEnum {
    MAN = 'MAN',
    WOMAN = 'WOMAN'
}
/**
    * @export
    * @enum {string}
    */
export enum ClientInfoDTOStatusEnum {
    ACTIVE = 'ACTIVE',
    NEW = 'NEW',
    FORMER = 'FORMER',
    WAITING = 'WAITING',
    STYLE_MATE = 'STYLE_MATE'
}
/**
    * @export
    * @enum {string}
    */
export enum ClientInfoDTOCategoryEnum {
    MASS = 'MASS',
    MEDIUM = 'MEDIUM',
    LUX = 'LUX',
    PREMIUM = 'PREMIUM',
    MIX_26MATCH = 'MIX_26MATCH'
}

/**
 * 
 * @export
 * @interface ClientItemCatalogItemsDTO
 */
export interface ClientItemCatalogItemsDTO {
    /**
     * 
     * @type {ItemDTO}
     * @memberof ClientItemCatalogItemsDTO
     */
    clientItem?: ItemDTO;
    /**
     * 
     * @type {Array<CatalogItemShortDTO>}
     * @memberof ClientItemCatalogItemsDTO
     */
    catalogItems?: Array<CatalogItemShortDTO>;
}
/**
 * 
 * @export
 * @interface ClientPrivateInfoDTO
 */
export interface ClientPrivateInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientPrivateInfoDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientPrivateInfoDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPrivateInfoDTO
     */
    surname?: string;
    /**
     * 
     * @type {StylistDTO}
     * @memberof ClientPrivateInfoDTO
     */
    stylist?: StylistDTO;
    /**
     * 
     * @type {string}
     * @memberof ClientPrivateInfoDTO
     */
    birthday?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPrivateInfoDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPrivateInfoDTO
     */
    email?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientPrivateInfoDTO
     */
    cashback?: number;
    /**
     * 
     * @type {SizeDTO}
     * @memberof ClientPrivateInfoDTO
     */
    sizeDTO?: SizeDTO;
    /**
     * 
     * @type {BodyDTO}
     * @memberof ClientPrivateInfoDTO
     */
    bodyDTO?: BodyDTO;
    /**
     * 
     * @type {Array<ShoppingShortDTO>}
     * @memberof ClientPrivateInfoDTO
     */
    shopping?: Array<ShoppingShortDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClientPrivateInfoDTO
     */
    status?: ClientPrivateInfoDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientPrivateInfoDTO
     */
    gender?: ClientPrivateInfoDTOGenderEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientPrivateInfoDTO
     */
    preferedStores?: Array<string>;
    /**
     * 
     * @type {Array<UserStyleDTO>}
     * @memberof ClientPrivateInfoDTO
     */
    styles?: Array<UserStyleDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof ClientPrivateInfoDTO
     */
    styleFormFilled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientPrivateInfoDTO
     */
    anonymous?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum ClientPrivateInfoDTOStatusEnum {
    ACTIVE = 'ACTIVE',
    NEW = 'NEW',
    FORMER = 'FORMER',
    WAITING = 'WAITING',
    STYLE_MATE = 'STYLE_MATE'
}
/**
    * @export
    * @enum {string}
    */
export enum ClientPrivateInfoDTOGenderEnum {
    MAN = 'MAN',
    WOMAN = 'WOMAN'
}

/**
 * 
 * @export
 * @interface ClientPurchaseDTO
 */
export interface ClientPurchaseDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientPurchaseDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPurchaseDTO
     */
    realPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientPurchaseDTO
     */
    status?: ClientPurchaseDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ClientPurchaseDTO
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientPurchaseDTO
     */
    finishAt?: number;
    /**
     * 
     * @type {ProductShortDTO}
     * @memberof ClientPurchaseDTO
     */
    product?: ProductShortDTO;
    /**
     * 
     * @type {Array<ShoppingShortDTO>}
     * @memberof ClientPurchaseDTO
     */
    shoppings?: Array<ShoppingShortDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum ClientPurchaseDTOStatusEnum {
    CREATED = 'CREATED',
    BILL_SENT = 'BILL_SENT',
    PAID = 'PAID',
    CONFIRMED = 'CONFIRMED'
}

/**
 * 
 * @export
 * @interface ClientSelfInfoDTO
 */
export interface ClientSelfInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof ClientSelfInfoDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSelfInfoDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSelfInfoDTO
     */
    birthday?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSelfInfoDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSelfInfoDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSelfInfoDTO
     */
    gender?: ClientSelfInfoDTOGenderEnum;
    /**
     * 
     * @type {SizeDTO}
     * @memberof ClientSelfInfoDTO
     */
    size?: SizeDTO;
    /**
     * 
     * @type {Array<UserStyleDTO>}
     * @memberof ClientSelfInfoDTO
     */
    styles?: Array<UserStyleDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientSelfInfoDTO
     */
    preferedStores?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ClientSelfInfoDTO
     */
    maxItemPrice?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ClientSelfInfoDTOGenderEnum {
    MAN = 'MAN',
    WOMAN = 'WOMAN'
}

/**
 * 
 * @export
 * @interface ClientStyleFormDTO
 */
export interface ClientStyleFormDTO {
    /**
     * 
     * @type {string}
     * @memberof ClientStyleFormDTO
     */
    age?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientStyleFormDTO
     */
    jobDescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    dificulties?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    wrongPrints?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    wrongColors?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    wrongFurniture?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientStyleFormDTO
     */
    top?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientStyleFormDTO
     */
    bottom?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientStyleFormDTO
     */
    shoes?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientStyleFormDTO
     */
    bra?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientStyleFormDTO
     */
    clientHeight?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    skirtLength?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    trousersType?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    bagType?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    heelType?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    accessoriesType?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    preferredShops?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    shirtPriceRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    tshirtPriceRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    trousersPriceRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    dressSkirtPriceRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    outerwearPriceRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    bagsPriceRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    shoesPriceRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    accessoriesPriceRange?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ClientStyleFormDTO
     */
    casual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientStyleFormDTO
     */
    mini?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientStyleFormDTO
     */
    trendy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientStyleFormDTO
     */
    business?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientStyleFormDTO
     */
    avangard?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientStyleFormDTO
     */
    romantic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientStyleFormDTO
     */
    sport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientStyleFormDTO
     */
    sexy?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    selfeePicUrls?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientStyleFormDTO
     */
    fullLengthPicUrl?: Array<string>;
}
/**
 * 
 * @export
 * @interface ClientSubscriptionDTO
 */
export interface ClientSubscriptionDTO {
    /**
     * 
     * @type {number}
     * @memberof ClientSubscriptionDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientSubscriptionDTO
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientSubscriptionDTO
     */
    status?: ClientSubscriptionDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ClientSubscriptionDTO
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientSubscriptionDTO
     */
    finishAt?: number;
    /**
     * 
     * @type {ProductShortDTO}
     * @memberof ClientSubscriptionDTO
     */
    product?: ProductShortDTO;
    /**
     * 
     * @type {Array<ShoppingShortDTO>}
     * @memberof ClientSubscriptionDTO
     */
    shoppings?: Array<ShoppingShortDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum ClientSubscriptionDTOStatusEnum {
    CREATED = 'CREATED',
    BILL_SENT = 'BILL_SENT',
    PAID = 'PAID',
    CONFIRMED = 'CONFIRMED'
}

/**
 * 
 * @export
 * @interface CommentDTO
 */
export interface CommentDTO {
    /**
     * 
     * @type {number}
     * @memberof CommentDTO
     */
    id?: number;
    /**
     * 
     * @type {AuthorDTO}
     * @memberof CommentDTO
     */
    author?: AuthorDTO;
    /**
     * 
     * @type {string}
     * @memberof CommentDTO
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentDTO
     */
    createdAt?: number;
}
/**
 * 
 * @export
 * @interface CompilationDTO
 */
export interface CompilationDTO {
    /**
     * 
     * @type {number}
     * @memberof CompilationDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationDTO
     */
    orderDateMillis?: number;
    /**
     * 
     * @type {Array<CompilationLookDTO>}
     * @memberof CompilationDTO
     */
    looks?: Array<CompilationLookDTO>;
    /**
     * 
     * @type {Array<CompilationThingDTO>}
     * @memberof CompilationDTO
     */
    things?: Array<CompilationThingDTO>;
    /**
     * 
     * @type {string}
     * @memberof CompilationDTO
     */
    status?: CompilationDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CompilationDTO
     */
    userFeedbackText?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationDTO
     */
    userFeedbackRating?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationDTO
     */
    stylistComment?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationDTO
     */
    compilationForm?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CompilationDTOStatusEnum {
    NEW = 'NEW',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED'
}

/**
 * 
 * @export
 * @interface CompilationFullDTO
 */
export interface CompilationFullDTO {
    /**
     * 
     * @type {number}
     * @memberof CompilationFullDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationFullDTO
     */
    dueDateMillis?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationFullDTO
     */
    createdAtMillis?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationFullDTO
     */
    startedAtMillis?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationFullDTO
     */
    finishedAtMillis?: number;
    /**
     * 
     * @type {string}
     * @memberof CompilationFullDTO
     */
    status?: CompilationFullDTOStatusEnum;
    /**
     * 
     * @type {StylistDTO}
     * @memberof CompilationFullDTO
     */
    stylist?: StylistDTO;
    /**
     * 
     * @type {string}
     * @memberof CompilationFullDTO
     */
    userFeedbackRating?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationFullDTO
     */
    userFeedbackText?: string;
    /**
     * 
     * @type {Array<CompilationLookDTO>}
     * @memberof CompilationFullDTO
     */
    looks?: Array<CompilationLookDTO>;
    /**
     * 
     * @type {Array<CompilationThingDTO>}
     * @memberof CompilationFullDTO
     */
    things?: Array<CompilationThingDTO>;
    /**
     * 
     * @type {string}
     * @memberof CompilationFullDTO
     */
    info?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationFullDTO
     */
    stylistComment?: string;
    /**
     * 
     * @type {ClientDTO}
     * @memberof CompilationFullDTO
     */
    client?: ClientDTO;
    /**
     * 
     * @type {string}
     * @memberof CompilationFullDTO
     */
    paymentStatus?: CompilationFullDTOPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CompilationFullDTO
     */
    paidFrom?: CompilationFullDTOPaidFromEnum;
    /**
     * 
     * @type {string}
     * @memberof CompilationFullDTO
     */
    paymentId?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CompilationFullDTOStatusEnum {
    NEW = 'NEW',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED'
}
/**
    * @export
    * @enum {string}
    */
export enum CompilationFullDTOPaymentStatusEnum {
    WAITING = 'WAITING',
    PAYMENT_INFO_RECEIVED = 'PAYMENT_INFO_RECEIVED',
    PAID = 'PAID'
}
/**
    * @export
    * @enum {string}
    */
export enum CompilationFullDTOPaidFromEnum {
    APP = 'APP',
    WEB = 'WEB'
}

/**
 * 
 * @export
 * @interface CompilationLookDTO
 */
export interface CompilationLookDTO {
    /**
     * 
     * @type {number}
     * @memberof CompilationLookDTO
     */
    id?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CompilationLookDTO
     */
    thingIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof CompilationLookDTO
     */
    dislike?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompilationLookDTO
     */
    dislikeComment?: string;
    /**
     * 
     * @type {number}
     * @memberof CompilationLookDTO
     */
    wardrobeLookId?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationLookDTO
     */
    temperatureFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationLookDTO
     */
    temperatureTo?: number;
}
/**
 * 
 * @export
 * @interface CompilationOrderDTO
 */
export interface CompilationOrderDTO {
    /**
     * 
     * @type {string}
     * @memberof CompilationOrderDTO
     */
    taskType: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationOrderDTO
     */
    taskDescription: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationOrderDTO
     */
    styleComments: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationOrderDTO
     */
    seasons: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationOrderDTO
     */
    budget: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationOrderDTO
     */
    commentForStylist?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationOrderDTO
     */
    cardCryptogramPacket: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationOrderDTO
     */
    cardHolderName?: string;
    /**
     * 
     * @type {number}
     * @memberof CompilationOrderDTO
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface CompilationServicesDTO
 */
export interface CompilationServicesDTO {
    /**
     * 
     * @type {number}
     * @memberof CompilationServicesDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompilationServicesDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationServicesDTO
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationServicesDTO
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof CompilationServicesDTO
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationServicesDTO
     */
    salePrice?: number;
    /**
     * 
     * @type {string}
     * @memberof CompilationServicesDTO
     */
    amplitudeEventName?: string;
}
/**
 * 
 * @export
 * @interface CompilationThingDTO
 */
export interface CompilationThingDTO {
    /**
     * 
     * @type {number}
     * @memberof CompilationThingDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompilationThingDTO
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationThingDTO
     */
    store?: string;
    /**
     * 
     * @type {number}
     * @memberof CompilationThingDTO
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationThingDTO
     */
    priceDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationThingDTO
     */
    catalogItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof CompilationThingDTO
     */
    clientItemId?: number;
    /**
     * 
     * @type {Array<FileDTO>}
     * @memberof CompilationThingDTO
     */
    fileNames?: Array<FileDTO>;
    /**
     * 
     * @type {string}
     * @memberof CompilationThingDTO
     */
    link?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompilationThingDTO
     */
    inWardrobe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompilationThingDTO
     */
    aiType?: string;
    /**
     * 
     * @type {number}
     * @memberof CompilationThingDTO
     */
    aiScale?: number;
    /**
     * 
     * @type {string}
     * @memberof CompilationThingDTO
     */
    aiDimension?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompilationThingDTO
     */
    dislike?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompilationThingDTO
     */
    dislikeComment?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationThingDTO
     */
    temperatureFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof CompilationThingDTO
     */
    temperatureTo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompilationThingDTO
     */
    editable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompilationThingDTO
     */
    size?: string;
    /**
     * 
     * @type {number}
     * @memberof CompilationThingDTO
     */
    categoryId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompilationThingDTO
     */
    deleted?: boolean;
}
/**
 * 
 * @export
 * @interface CompilationsDTO
 */
export interface CompilationsDTO {
    /**
     * 
     * @type {Array<CompilationFullDTO>}
     * @memberof CompilationsDTO
     */
    compilations?: Array<CompilationFullDTO>;
    /**
     * 
     * @type {number}
     * @memberof CompilationsDTO
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface DeliveryAddressDTO
 */
export interface DeliveryAddressDTO {
    /**
     * 
     * @type {number}
     * @memberof DeliveryAddressDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressDTO
     */
    streetAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressDTO
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryAddressDTO
     */
    primary?: boolean;
}
/**
 * 
 * @export
 * @interface ErrorDTO
 */
export interface ErrorDTO {
    /**
     * 
     * @type {string}
     * @memberof ErrorDTO
     */
    exception?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorDTO
     */
    responseEmail?: string;
}
/**
 * 
 * @export
 * @interface FailDTO
 */
export interface FailDTO {
    /**
     * 
     * @type {string}
     * @memberof FailDTO
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof FailDTO
     */
    message?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FailDTO
     */
    params?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface FileDTO
 */
export interface FileDTO {
    /**
     * 
     * @type {string}
     * @memberof FileDTO
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof FileDTO
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof FileDTO
     */
    height?: number;
}
/**
 * 
 * @export
 * @interface FilterDTO
 */
export interface FilterDTO {
    /**
     * 
     * @type {string}
     * @memberof FilterDTO
     */
    type: FilterDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FilterDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FilterDTO
     */
    gender?: FilterDTOGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof FilterDTO
     */
    colorHex?: string;
    /**
     * 
     * @type {Array<FilterDTO>}
     * @memberof FilterDTO
     */
    children?: Array<FilterDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum FilterDTOTypeEnum {
    GENDER = 'GENDER',
    CATEGORY = 'CATEGORY',
    COLOR = 'COLOR',
    SUPPLIER = 'SUPPLIER',
    BRAND = 'BRAND',
    ITEM_NAME = 'ITEM_NAME',
    PRICE = 'PRICE',
    SUB_CATEGORY = 'SUB_CATEGORY',
    SIZE = 'SIZE'
}
/**
    * @export
    * @enum {string}
    */
export enum FilterDTOGenderEnum {
    WOMAN = 'WOMAN',
    MAN = 'MAN'
}

/**
 * 
 * @export
 * @interface FilterIdsDTO
 */
export interface FilterIdsDTO {
    /**
     * 
     * @type {string}
     * @memberof FilterIdsDTO
     */
    type: FilterIdsDTOTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterIdsDTO
     */
    ids: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum FilterIdsDTOTypeEnum {
    GENDER = 'GENDER',
    CATEGORY = 'CATEGORY',
    COLOR = 'COLOR',
    SUPPLIER = 'SUPPLIER',
    BRAND = 'BRAND',
    ITEM_NAME = 'ITEM_NAME',
    PRICE = 'PRICE',
    SUB_CATEGORY = 'SUB_CATEGORY',
    SIZE = 'SIZE'
}

/**
 * 
 * @export
 * @interface GetClientsRequest
 */
export interface GetClientsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetClientsRequest
     */
    searchStr?: string;
    /**
     * 
     * @type {number}
     * @memberof GetClientsRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof GetClientsRequest
     */
    length?: number;
    /**
     * 
     * @type {string}
     * @memberof GetClientsRequest
     */
    sortBy?: GetClientsRequestSortByEnum;
    /**
     * 
     * @type {string}
     * @memberof GetClientsRequest
     */
    sortOrder?: GetClientsRequestSortOrderEnum;
    /**
     * 
     * @type {Array<ClientFilterDTO>}
     * @memberof GetClientsRequest
     */
    filters?: Array<ClientFilterDTO>;
    /**
     * 
     * @type {string}
     * @memberof GetClientsRequest
     */
    clientType?: GetClientsRequestClientTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GetClientsRequestSortByEnum {
    SURNAME = 'SURNAME',
    CREATED_AT = 'CREATED_AT',
    LOOKS_COUNT = 'LOOKS_COUNT',
    THINGS_COUNT = 'THINGS_COUNT'
}
/**
    * @export
    * @enum {string}
    */
export enum GetClientsRequestSortOrderEnum {
    ASC = 'ASC',
    DESC = 'DESC'
}
/**
    * @export
    * @enum {string}
    */
export enum GetClientsRequestClientTypeEnum {
    CONCIERGE = 'STYLE_CONCIERGE',
    MATE = 'STYLE_MATE'
}

/**
 * 
 * @export
 * @interface ImageUrlDTO
 */
export interface ImageUrlDTO {
    /**
     * 
     * @type {number}
     * @memberof ImageUrlDTO
     */
    clientItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageUrlDTO
     */
    fullImagePath?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageUrlDTO
     */
    sumbnailImagePath?: string;
}
/**
 * 
 * @export
 * @interface ImproveImageDTO
 */
export interface ImproveImageDTO {
    /**
     * 
     * @type {string}
     * @memberof ImproveImageDTO
     */
    originalFileUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImproveImageDTO
     */
    secondStageUrls?: Array<string>;
}
/**
 * 
 * @export
 * @interface InputPart
 */
export interface InputPart {
    /**
     * 
     * @type {MediaType}
     * @memberof InputPart
     */
    mediaType?: MediaType;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof InputPart
     */
    headers?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof InputPart
     */
    bodyAsString?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InputPart
     */
    contentTypeFromMessage?: boolean;
}
/**
 * 
 * @export
 * @interface ItemDTO
 */
export interface ItemDTO {
    /**
     * 
     * @type {number}
     * @memberof ItemDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ItemDTO
     */
    catalogItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemDTO
     */
    catalogItemLink?: string;
    /**
     * 
     * @type {Array<FileDTO>}
     * @memberof ItemDTO
     */
    fileNames?: Array<FileDTO>;
    /**
     * 
     * @type {Array<LookShortDTO>}
     * @memberof ItemDTO
     */
    looks?: Array<LookShortDTO>;
    /**
     * 
     * @type {number}
     * @memberof ItemDTO
     */
    temperatureFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemDTO
     */
    temperatureTo?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemDTO
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemDTO
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemDTO
     */
    brandName?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemDTO
     */
    size?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemDTO
     */
    aiType?: string;
    /**
     * 
     * @type {number}
     * @memberof ItemDTO
     */
    aiScale?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemDTO
     */
    aiDimension?: string;
    /**
     * 
     * @type {CategoryDTO}
     * @memberof ItemDTO
     */
    categoryDTO?: CategoryDTO;
    /**
     * 
     * @type {number}
     * @memberof ItemDTO
     */
    createdAt?: number;
    /**
     * 
     * @type {PriceShortDTO}
     * @memberof ItemDTO
     */
    price?: PriceShortDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ItemDTO
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemDTO
     */
    dreamThing?: boolean;
}
/**
 * 
 * @export
 * @interface ItemStyleDTO
 */
export interface ItemStyleDTO {
    /**
     * 
     * @type {string}
     * @memberof ItemStyleDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemStyleDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemStyleDTO
     */
    gender?: ItemStyleDTOGenderEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ItemStyleDTOGenderEnum {
    MAN = 'MAN',
    WOMAN = 'WOMAN'
}

/**
 * 
 * @export
 * @interface ListClientsResponse
 */
export interface ListClientsResponse {
    /**
     * 
     * @type {Array<ClientDTO>}
     * @memberof ListClientsResponse
     */
    clients?: Array<ClientDTO>;
    /**
     * 
     * @type {number}
     * @memberof ListClientsResponse
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface LoginResponseDTO
 */
export interface LoginResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDTO
     */
    token?: string;
    /**
     * 
     * @type {number}
     * @memberof LoginResponseDTO
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDTO
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponseDTO
     */
    rulesAccepted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDTO
     */
    gender?: LoginResponseDTOGenderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponseDTO
     */
    _new?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum LoginResponseDTOGenderEnum {
    MAN = 'MAN',
    WOMAN = 'WOMAN'
}

/**
 * 
 * @export
 * @interface LookCategoryTranslation
 */
export interface LookCategoryTranslation {
    /**
     * 
     * @type {number}
     * @memberof LookCategoryTranslation
     */
    category?: number;
    /**
     * 
     * @type {string}
     * @memberof LookCategoryTranslation
     */
    translation?: string;
}
/**
 * 
 * @export
 * @interface LookFullDTO
 */
export interface LookFullDTO {
    /**
     * 
     * @type {number}
     * @memberof LookFullDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LookFullDTO
     */
    category?: number;
    /**
     * 
     * @type {number}
     * @memberof LookFullDTO
     */
    createdAt?: number;
    /**
     * 
     * @type {string}
     * @memberof LookFullDTO
     */
    lookPicture?: string;
    /**
     * 
     * @type {Array<LookItemDTO>}
     * @memberof LookFullDTO
     */
    items?: Array<LookItemDTO>;
    /**
     * 
     * @type {number}
     * @memberof LookFullDTO
     */
    updatedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof LookFullDTO
     */
    status?: LookFullDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LookFullDTO
     */
    temperatureFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof LookFullDTO
     */
    temperatureTo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LookFullDTO
     */
    deleted?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum LookFullDTOStatusEnum {
    REAL = 'REAL',
    VIRTUAL = 'VIRTUAL',
    SANDBOX = 'SANDBOX'
}

/**
 * 
 * @export
 * @interface LookItemDTO
 */
export interface LookItemDTO {
    /**
     * 
     * @type {number}
     * @memberof LookItemDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LookItemDTO
     */
    clientItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof LookItemDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof LookItemDTO
     */
    catalogItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof LookItemDTO
     */
    catalogItemLink?: string;
    /**
     * 
     * @type {Array<FileDTO>}
     * @memberof LookItemDTO
     */
    fileNames?: Array<FileDTO>;
    /**
     * 
     * @type {string}
     * @memberof LookItemDTO
     */
    aiType?: string;
    /**
     * 
     * @type {number}
     * @memberof LookItemDTO
     */
    updatedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof LookItemDTO
     */
    supplier?: string;
    /**
     * 
     * @type {PriceShortDTO}
     * @memberof LookItemDTO
     */
    price?: PriceShortDTO;
    /**
     * 
     * @type {CategoryDTO}
     * @memberof LookItemDTO
     */
    category?: CategoryDTO;
    /**
     * 
     * @type {TemperatureDTO}
     * @memberof LookItemDTO
     */
    temperatureDTO?: TemperatureDTO;
    /**
     * 
     * @type {boolean}
     * @memberof LookItemDTO
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LookItemDTO
     */
    dreamThing?: boolean;
}
/**
 * 
 * @export
 * @interface LookShortDTO
 */
export interface LookShortDTO {
    /**
     * 
     * @type {number}
     * @memberof LookShortDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LookShortDTO
     */
    category?: number;
    /**
     * 
     * @type {number}
     * @memberof LookShortDTO
     */
    createdAt?: number;
    /**
     * 
     * @type {string}
     * @memberof LookShortDTO
     */
    lookPicture?: string;
    /**
     * 
     * @type {string}
     * @memberof LookShortDTO
     */
    status?: LookShortDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LookShortDTO
     */
    temperatureFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof LookShortDTO
     */
    temperatureTo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LookShortDTO
     */
    deleted?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum LookShortDTOStatusEnum {
    REAL = 'REAL',
    VIRTUAL = 'VIRTUAL',
    SANDBOX = 'SANDBOX'
}

/**
 * 
 * @export
 * @interface MediaType
 */
export interface MediaType {
    /**
     * 
     * @type {string}
     * @memberof MediaType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaType
     */
    subtype?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MediaType
     */
    parameters?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof MediaType
     */
    wildcardType?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaType
     */
    wildcardSubtype?: boolean;
}
/**
 * 
 * @export
 * @interface MultipartFormDataInput
 */
export interface MultipartFormDataInput {
    /**
     * 
     * @type {{ [key: string]: Array<InputPart>; }}
     * @memberof MultipartFormDataInput
     */
    formDataMap?: { [key: string]: Array<InputPart>; };
    /**
     * 
     * @type {Array<InputPart>}
     * @memberof MultipartFormDataInput
     */
    parts?: Array<InputPart>;
    /**
     * 
     * @type {string}
     * @memberof MultipartFormDataInput
     */
    preamble?: string;
}
/**
 * 
 * @export
 * @interface OrderDTO
 */
export interface OrderDTO {
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderDTO
     */
    items?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof OrderDTO
     */
    addressId?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    paymentType?: OrderDTOPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderDTO
     */
    phone?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum OrderDTOPaymentTypeEnum {
    BY_CASH = 'BY_CASH',
    BY_CARD_OFFLINE = 'BY_CARD_OFFLINE',
    ONLINE = 'ONLINE'
}

/**
 * 
 * @export
 * @interface PaymentResultDTO
 */
export interface PaymentResultDTO {
    /**
     * 
     * @type {string}
     * @memberof PaymentResultDTO
     */
    result?: PaymentResultDTOResultEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultDTO
     */
    threeDUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultDTO
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultDTO
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultDTO
     */
    paReq?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResultDTO
     */
    termUrl?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PaymentResultDTOResultEnum {
    SUCCESS = 'SUCCESS',
    FAIL = 'FAIL',
    THREE_D_SECURE = 'THREE_D_SECURE'
}

/**
 * 
 * @export
 * @interface PermissionDTO
 */
export interface PermissionDTO {
    /**
     * 
     * @type {string}
     * @memberof PermissionDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionDTO
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface PictureDTO
 */
export interface PictureDTO {
    /**
     * 
     * @type {string}
     * @memberof PictureDTO
     */
    size?: PictureDTOSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof PictureDTO
     */
    name?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PictureDTOSizeEnum {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    BIG = 'BIG'
}

/**
 * 
 * @export
 * @interface PriceDTO
 */
export interface PriceDTO {
    /**
     * 
     * @type {number}
     * @memberof PriceDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PriceDTO
     */
    size: string;
    /**
     * 
     * @type {number}
     * @memberof PriceDTO
     */
    price?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PriceDTO
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof PriceDTO
     */
    barcode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PriceDTO
     */
    availableIn?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PriceDTO
     */
    salePercent?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PriceDTO
     */
    inWardrobe?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PriceDTO
     */
    priceDiscount?: number;
}
/**
 * 
 * @export
 * @interface PriceShortDTO
 */
export interface PriceShortDTO {
    /**
     * 
     * @type {number}
     * @memberof PriceShortDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PriceShortDTO
     */
    size: string;
    /**
     * 
     * @type {boolean}
     * @memberof PriceShortDTO
     */
    available: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PriceShortDTO
     */
    inWardrobe?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PriceShortDTO
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceShortDTO
     */
    priceDiscount?: number;
}
/**
 * 
 * @export
 * @interface ProductDTO
 */
export interface ProductDTO {
    /**
     * 
     * @type {number}
     * @memberof ProductDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDTO
     */
    type?: ProductDTOTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductDTO
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductDTO
     */
    salePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDTO
     */
    description?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductDTOTypeEnum {
    ONE_TIME = 'ONE_TIME',
    TWO_TIME = 'TWO_TIME',
    THREE_TIME = 'THREE_TIME',
    COMPILATION = 'COMPILATION'
}

/**
 * 
 * @export
 * @interface ProductInfoDTO
 */
export interface ProductInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof ProductInfoDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInfoDTO
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductInfoDTO
     */
    type?: ProductInfoDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductInfoDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductInfoDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductInfoDTO
     */
    numberOfShopping?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductInfoDTOTypeEnum {
    ONE_TIME = 'ONE_TIME',
    TWO_TIME = 'TWO_TIME',
    THREE_TIME = 'THREE_TIME',
    COMPILATION = 'COMPILATION'
}

/**
 * 
 * @export
 * @interface ProductShortDTO
 */
export interface ProductShortDTO {
    /**
     * 
     * @type {number}
     * @memberof ProductShortDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductShortDTO
     */
    type?: ProductShortDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductShortDTO
     */
    name?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductShortDTOTypeEnum {
    ONE_TIME = 'ONE_TIME',
    TWO_TIME = 'TWO_TIME',
    THREE_TIME = 'THREE_TIME',
    COMPILATION = 'COMPILATION'
}

/**
 * 
 * @export
 * @interface PromoCardDTO
 */
export interface PromoCardDTO {
    /**
     * 
     * @type {number}
     * @memberof PromoCardDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PromoCardDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCardDTO
     */
    textColorHex: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCardDTO
     */
    goToLink: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCardDTO
     */
    extraTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCardDTO
     */
    backgroundUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoCardDTO
     */
    startFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoCardDTO
     */
    endFrom?: number;
}
/**
 * 
 * @export
 * @interface PromoCardFullDTO
 */
export interface PromoCardFullDTO {
    /**
     * 
     * @type {number}
     * @memberof PromoCardFullDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PromoCardFullDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCardFullDTO
     */
    textColorHex: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCardFullDTO
     */
    goToLink: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCardFullDTO
     */
    backgroundPictName: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCardFullDTO
     */
    status?: PromoCardFullDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PromoCardFullDTO
     */
    extraTitle?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoCardFullDTO
     */
    startFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoCardFullDTO
     */
    endFrom?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PromoCardFullDTOStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED'
}

/**
 * 
 * @export
 * @interface PromoCardShortDTO
 */
export interface PromoCardShortDTO {
    /**
     * 
     * @type {number}
     * @memberof PromoCardShortDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PromoCardShortDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCardShortDTO
     */
    status: PromoCardShortDTOStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PromoCardShortDTOStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED'
}

/**
 * 
 * @export
 * @interface PromoPictDTO
 */
export interface PromoPictDTO {
    /**
     * 
     * @type {string}
     * @memberof PromoPictDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoPictDTO
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface PurchaseDTO
 */
export interface PurchaseDTO {
    /**
     * 
     * @type {number}
     * @memberof PurchaseDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof PurchaseDTO
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PurchaseDTO
     */
    finishAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof PurchaseDTO
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseDTO
     */
    status?: PurchaseDTOStatusEnum;
    /**
     * 
     * @type {ProductInfoDTO}
     * @memberof PurchaseDTO
     */
    product?: ProductInfoDTO;
}

/**
    * @export
    * @enum {string}
    */
export enum PurchaseDTOStatusEnum {
    CREATED = 'CREATED',
    BILL_SENT = 'BILL_SENT',
    PAID = 'PAID',
    CONFIRMED = 'CONFIRMED'
}

/**
 * 
 * @export
 * @interface RoleDTO
 */
export interface RoleDTO {
    /**
     * 
     * @type {number}
     * @memberof RoleDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleDTO
     */
    name?: RoleDTONameEnum;
    /**
     * 
     * @type {string}
     * @memberof RoleDTO
     */
    description?: string;
    /**
     * 
     * @type {Array<PermissionDTO>}
     * @memberof RoleDTO
     */
    permissions?: Array<PermissionDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum RoleDTONameEnum {
    SUPERADMIN = 'SUPERADMIN',
    ADMIN = 'ADMIN',
    STYLIST = 'STYLIST',
    CLIENT = 'CLIENT',
    CLIENT_MANAGER = 'CLIENT_MANAGER',
    SUPPLIER = 'SUPPLIER',
    ACCOUNTANT = 'ACCOUNTANT',
    STOREHOUSE = 'STOREHOUSE',
    MARKETING = 'MARKETING',
    SM_MANAGER = 'SM_MANAGER',
    SM_STYLIST = 'SM_STYLIST'
}

/**
 * 
 * @export
 * @interface SandboxItemDTO
 */
export interface SandboxItemDTO {
    /**
     * 
     * @type {number}
     * @memberof SandboxItemDTO
     */
    catalogItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof SandboxItemDTO
     */
    priceId?: number;
}
/**
 * 
 * @export
 * @interface SaveFileDataDTO
 */
export interface SaveFileDataDTO {
    /**
     * 
     * @type {number}
     * @memberof SaveFileDataDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveFileDataDTO
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveFileDataDTO
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveFileDataDTO
     */
    fileName?: string;
    /**
     * 
     * @type {object}
     * @memberof SaveFileDataDTO
     */
    file?: object;
}
/**
 * 
 * @export
 * @interface SaveThingDataDTO
 */
export interface SaveThingDataDTO {
    /**
     * 
     * @type {number}
     * @memberof SaveThingDataDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveThingDataDTO
     */
    compilationId?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    thingUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    type?: SaveThingDataDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    brandId?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    supplierId?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveThingDataDTO
     */
    colorId?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    size?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveThingDataDTO
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveThingDataDTO
     */
    priceDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveThingDataDTO
     */
    categoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    temperatureFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    temperatureTo?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveThingDataDTO
     */
    fileName?: string;
    /**
     * 
     * @type {object}
     * @memberof SaveThingDataDTO
     */
    file?: object;
}

/**
    * @export
    * @enum {string}
    */
export enum SaveThingDataDTOTypeEnum {
    CLOTHES = 'CLOTHES',
    BAG = 'BAG',
    ACCESSORY = 'ACCESSORY',
    SHOES = 'SHOES',
    JEWEL = 'JEWEL'
}

/**
 * 
 * @export
 * @interface SearchParamsDTO
 */
export interface SearchParamsDTO {
    /**
     * 
     * @type {Array<AiFilterDTO>}
     * @memberof SearchParamsDTO
     */
    commonCategories?: Array<AiFilterDTO>;
    /**
     * 
     * @type {Array<AiFilterDTO>}
     * @memberof SearchParamsDTO
     */
    prices?: Array<AiFilterDTO>;
    /**
     * 
     * @type {Array<AiFilterDTO>}
     * @memberof SearchParamsDTO
     */
    styles?: Array<AiFilterDTO>;
    /**
     * 
     * @type {Array<AiFilterDTO>}
     * @memberof SearchParamsDTO
     */
    sizes?: Array<AiFilterDTO>;
    /**
     * 
     * @type {Array<AiFilterDTO>}
     * @memberof SearchParamsDTO
     */
    seasons?: Array<AiFilterDTO>;
}
/**
 * 
 * @export
 * @interface SearchRequest
 */
export interface SearchRequest {
    /**
     * 
     * @type {Array<FilterIdsDTO>}
     * @memberof SearchRequest
     */
    filterIds: Array<FilterIdsDTO>;
    /**
     * 
     * @type {number}
     * @memberof SearchRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchRequest
     */
    length?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchRequest
     */
    sortBy?: SearchRequestSortByEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchRequest
     */
    sortOrder?: SearchRequestSortOrderEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SearchRequestSortByEnum {
    DATE = 'DATE',
    PRICE = 'PRICE',
    SALE_PERCENT = 'SALE_PERCENT'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchRequestSortOrderEnum {
    ASC = 'ASC',
    DESC = 'DESC'
}

/**
 * 
 * @export
 * @interface SearchResult
 */
export interface SearchResult {
    /**
     * 
     * @type {number}
     * @memberof SearchResult
     */
    count?: number;
    /**
     * 
     * @type {Array<CatalogItemShortDTO>}
     * @memberof SearchResult
     */
    result?: Array<CatalogItemShortDTO>;
}
/**
 * 
 * @export
 * @interface ServiceDTO
 */
export interface ServiceDTO {
    /**
     * 
     * @type {string}
     * @memberof ServiceDTO
     */
    place?: ServiceDTOPlaceEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceDTO
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceDTO
     */
    htmlContent?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceDTO
     */
    whatsappNumber?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ServiceDTOPlaceEnum {
    LOOK = 'LOOK',
    THING = 'THING',
    LOOKS = 'LOOKS',
    THINGS = 'THINGS'
}

/**
 * 
 * @export
 * @interface ShoppingDTO
 */
export interface ShoppingDTO {
    /**
     * 
     * @type {number}
     * @memberof ShoppingDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingDTO
     */
    clientId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingDTO
     */
    comments?: string;
    /**
     * 
     * @type {number}
     * @memberof ShoppingDTO
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingDTO
     */
    updatedAt?: number;
    /**
     * 
     * @type {Array<CartItemDTO>}
     * @memberof ShoppingDTO
     */
    items?: Array<CartItemDTO>;
    /**
     * 
     * @type {string}
     * @memberof ShoppingDTO
     */
    status?: ShoppingDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ShoppingDTO
     */
    shoppingDate?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingDTO
     */
    startTime?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingDTO
     */
    finishTime?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingDTO
     */
    budget?: number;
    /**
     * 
     * @type {StudioDTO}
     * @memberof ShoppingDTO
     */
    studio?: StudioDTO;
    /**
     * 
     * @type {string}
     * @memberof ShoppingDTO
     */
    title?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ShoppingDTOStatusEnum {
    DRAFT = 'DRAFT',
    READY_TO_SHOP = 'READY_TO_SHOP',
    SHOPPING = 'SHOPPING',
    READY_FOR_CLIENT = 'READY_FOR_CLIENT',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED'
}

/**
 * 
 * @export
 * @interface ShoppingShortDTO
 */
export interface ShoppingShortDTO {
    /**
     * 
     * @type {number}
     * @memberof ShoppingShortDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingShortDTO
     */
    comments?: string;
    /**
     * 
     * @type {number}
     * @memberof ShoppingShortDTO
     */
    createdAt?: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingShortDTO
     */
    status?: ShoppingShortDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ShoppingShortDTO
     */
    shoppingDate?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ShoppingShortDTOStatusEnum {
    DRAFT = 'DRAFT',
    READY_TO_SHOP = 'READY_TO_SHOP',
    SHOPPING = 'SHOPPING',
    READY_FOR_CLIENT = 'READY_FOR_CLIENT',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED'
}

/**
 * 
 * @export
 * @interface SizeDTO
 */
export interface SizeDTO {
    /**
     * 
     * @type {string}
     * @memberof SizeDTO
     */
    top?: string;
    /**
     * 
     * @type {string}
     * @memberof SizeDTO
     */
    bottom?: string;
    /**
     * 
     * @type {string}
     * @memberof SizeDTO
     */
    shoes?: string;
    /**
     * 
     * @type {string}
     * @memberof SizeDTO
     */
    jeans?: string;
    /**
     * 
     * @type {string}
     * @memberof SizeDTO
     */
    neck?: string;
    /**
     * 
     * @type {string}
     * @memberof SizeDTO
     */
    bra?: string;
}
/**
 * 
 * @export
 * @interface StoryAdminDTO
 */
export interface StoryAdminDTO {
    /**
     * 
     * @type {number}
     * @memberof StoryAdminDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof StoryAdminDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof StoryAdminDTO
     */
    status: StoryAdminDTOStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum StoryAdminDTOStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED'
}

/**
 * 
 * @export
 * @interface StoryDTO
 */
export interface StoryDTO {
    /**
     * 
     * @type {number}
     * @memberof StoryDTO
     */
    id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoryDTO
     */
    pagesHtml: Array<string>;
}
/**
 * 
 * @export
 * @interface StoryPagesDTO
 */
export interface StoryPagesDTO {
    /**
     * 
     * @type {number}
     * @memberof StoryPagesDTO
     */
    id: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof StoryPagesDTO
     */
    pages: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof StoryPagesDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof StoryPagesDTO
     */
    status: StoryPagesDTOStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum StoryPagesDTOStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED'
}

/**
 * 
 * @export
 * @interface StudioDTO
 */
export interface StudioDTO {
    /**
     * 
     * @type {number}
     * @memberof StudioDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StudioDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StudioDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof StudioDTO
     */
    address?: string;
}
/**
 * 
 * @export
 * @interface StylistDTO
 */
export interface StylistDTO {
    /**
     * 
     * @type {number}
     * @memberof StylistDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StylistDTO
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof StylistDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof StylistDTO
     */
    surname?: string;
}
/**
 * 
 * @export
 * @interface SupplierDTO
 */
export interface SupplierDTO {
    /**
     * 
     * @type {string}
     * @memberof SupplierDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierDTO
     */
    referalParameters?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierDTO
     */
    partner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierDTO
     */
    parsed?: boolean;
}
/**
 * 
 * @export
 * @interface SupplierItemDTO
 */
export interface SupplierItemDTO {
    /**
     * 
     * @type {number}
     * @memberof SupplierItemDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierItemDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierItemDTO
     */
    brandName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierItemDTO
     */
    size?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierItemDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierItemDTO
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierItemDTO
     */
    supplierStatus?: SupplierItemDTOSupplierStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SupplierItemDTO
     */
    waitingDateTimestamp?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierItemDTO
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierItemDTO
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierItemDTO
     */
    pictUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SupplierItemDTO
     */
    itemId?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SupplierItemDTOSupplierStatusEnum {
    NONE = 'NONE',
    RESERVED = 'RESERVED',
    READY_FOR_DELIVERY = 'READY_FOR_DELIVERY',
    PRICE_CHANGED = 'PRICE_CHANGED',
    MISSING = 'MISSING'
}

/**
 * 
 * @export
 * @interface TemperatureDTO
 */
export interface TemperatureDTO {
    /**
     * 
     * @type {string}
     * @memberof TemperatureDTO
     */
    min?: string;
    /**
     * 
     * @type {string}
     * @memberof TemperatureDTO
     */
    max?: string;
}
/**
 * 
 * @export
 * @interface Thing
 */
export interface Thing {
    /**
     * 
     * @type {number}
     * @memberof Thing
     */
    thingId?: number;
    /**
     * 
     * @type {number}
     * @memberof Thing
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof Thing
     */
    categoryId: number;
    /**
     * 
     * @type {string}
     * @memberof Thing
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Thing
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof Thing
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof Thing
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Thing
     */
    size?: string;
    /**
     * 
     * @type {number}
     * @memberof Thing
     */
    temperatureFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof Thing
     */
    temperatureTo?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Thing
     */
    dreamItem?: boolean;
}
/**
 * 
 * @export
 * @interface ThingsForLookRequestDTO
 */
export interface ThingsForLookRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof ThingsForLookRequestDTO
     */
    lookId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ThingsForLookRequestDTO
     */
    categoryIds: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ThingsForLookRequestDTO
     */
    style?: Array<ThingsForLookRequestDTOStyleEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ThingsForLookRequestDTO
     */
    sizes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ThingsForLookRequestDTO
     */
    prices?: Array<ThingsForLookRequestDTOPricesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ThingsForLookRequestDTO
     */
    seasons?: Array<ThingsForLookRequestDTOSeasonsEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum ThingsForLookRequestDTOStyleEnum {
    MINIMALISM = 'MINIMALISM',
    ELEGANT = 'ELEGANT',
    CHIC_AND_TRENDY = 'CHIC_AND_TRENDY',
    CASUAL = 'CASUAL',
    SEXY = 'SEXY',
    FEMENINE = 'FEMENINE',
    STREET_WEAR = 'STREET_WEAR',
    AVANGARD = 'AVANGARD',
    CLASSIC = 'CLASSIC',
    SMART_CASUAL = 'SMART_CASUAL',
    SPORT_CASUAL = 'SPORT_CASUAL',
    CREATIVE = 'CREATIVE'
}
/**
    * @export
    * @enum {string}
    */
export enum ThingsForLookRequestDTOPricesEnum {
    R1 = 'R1',
    R2 = 'R2',
    R3 = 'R3',
    R4 = 'R4',
    R5 = 'R5',
    R6 = 'R6',
    R7 = 'R7',
    R8 = 'R8',
    R9 = 'R9',
    R10 = 'R10',
    R11 = 'R11'
}
/**
    * @export
    * @enum {string}
    */
export enum ThingsForLookRequestDTOSeasonsEnum {
    SUMMER = 'SUMMER',
    WARM_DEMI_SEASON = 'WARM_DEMI_SEASON',
    COLD_DEMI_SEASON = 'COLD_DEMI_SEASON',
    WINTER = 'WINTER'
}

/**
 * 
 * @export
 * @interface ThingsForThingsRequestDTO
 */
export interface ThingsForThingsRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof ThingsForThingsRequestDTO
     */
    amount: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ThingsForThingsRequestDTO
     */
    clientItemIds: Array<number>;
}
/**
 * 
 * @export
 * @interface UserDTO
 */
export interface UserDTO {
    /**
     * 
     * @type {number}
     * @memberof UserDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    locale?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDTO
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDTO
     */
    updatedAt?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserDTO
     */
    roleIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof UserDTO
     */
    rulesAccepted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDTO
     */
    aiTester?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface UserFileDTO
 */
export interface UserFileDTO {
    /**
     * 
     * @type {number}
     * @memberof UserFileDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserFileDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFileDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFileDTO
     */
    link?: string;
    /**
     * 
     * @type {number}
     * @memberof UserFileDTO
     */
    createdAtMillis?: number;
    /**
     * 
     * @type {UserDTO}
     * @memberof UserFileDTO
     */
    userDTO?: UserDTO;
    /**
     * 
     * @type {UserDTO}
     * @memberof UserFileDTO
     */
    author?: UserDTO;
}
/**
 * 
 * @export
 * @interface UserSaveDTO
 */
export interface UserSaveDTO {
    /**
     * 
     * @type {number}
     * @memberof UserSaveDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserSaveDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSaveDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSaveDTO
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSaveDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSaveDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSaveDTO
     */
    description?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserSaveDTO
     */
    role?: Array<number>;
}
/**
 * 
 * @export
 * @interface UserStyleDTO
 */
export interface UserStyleDTO {
    /**
     * 
     * @type {string}
     * @memberof UserStyleDTO
     */
    style?: UserStyleDTOStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserStyleDTO
     */
    userAnswer?: UserStyleDTOUserAnswerEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UserStyleDTOStyleEnum {
    MINIMALISM = 'MINIMALISM',
    ELEGANT = 'ELEGANT',
    CHIC_AND_TRENDY = 'CHIC_AND_TRENDY',
    CASUAL = 'CASUAL',
    SEXY = 'SEXY',
    FEMENINE = 'FEMENINE',
    STREET_WEAR = 'STREET_WEAR',
    AVANGARD = 'AVANGARD',
    CLASSIC = 'CLASSIC',
    SMART_CASUAL = 'SMART_CASUAL',
    SPORT_CASUAL = 'SPORT_CASUAL',
    CREATIVE = 'CREATIVE'
}
/**
    * @export
    * @enum {string}
    */
export enum UserStyleDTOUserAnswerEnum {
    YES = 'YES',
    NO = 'NO',
    MAYBE = 'MAYBE'
}

/**
 * 
 * @export
 * @interface VirtualLookDTO
 */
export interface VirtualLookDTO {
    /**
     * 
     * @type {number}
     * @memberof VirtualLookDTO
     */
    id?: number;
    /**
     * 
     * @type {Array<LookItemDTO>}
     * @memberof VirtualLookDTO
     */
    items?: Array<LookItemDTO>;
    /**
     * 
     * @type {number}
     * @memberof VirtualLookDTO
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof VirtualLookDTO
     */
    userScore?: number;
    /**
     * 
     * @type {string}
     * @memberof VirtualLookDTO
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface VirtualLookRequestDTO
 */
export interface VirtualLookRequestDTO {
    /**
     * 
     * @type {Array<number>}
     * @memberof VirtualLookRequestDTO
     */
    clientThingIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof VirtualLookRequestDTO
     */
    clientGender?: VirtualLookRequestDTOClientGenderEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof VirtualLookRequestDTO
     */
    catalogItemIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof VirtualLookRequestDTO
     */
    style?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VirtualLookRequestDTO
     */
    sizeTop?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualLookRequestDTO
     */
    sizeBottom?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualLookRequestDTO
     */
    sizeShoes?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VirtualLookRequestDTO
     */
    prices?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof VirtualLookRequestDTO
     */
    seasons?: Array<VirtualLookRequestDTOSeasonsEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum VirtualLookRequestDTOClientGenderEnum {
    MAN = 'MAN',
    WOMAN = 'WOMAN'
}
/**
    * @export
    * @enum {string}
    */
export enum VirtualLookRequestDTOSeasonsEnum {
    SUMMER = 'SUMMER',
    WARM_DEMI_SEASON = 'WARM_DEMI_SEASON',
    COLD_DEMI_SEASON = 'COLD_DEMI_SEASON',
    WINTER = 'WINTER'
}

/**
 * 
 * @export
 * @interface WhatsAppContactsDTO
 */
export interface WhatsAppContactsDTO {
    /**
     * 
     * @type {string}
     * @memberof WhatsAppContactsDTO
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof WhatsAppContactsDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof WhatsAppContactsDTO
     */
    iconURL?: string;
    /**
     * 
     * @type {string}
     * @memberof WhatsAppContactsDTO
     */
    whatsappNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WhatsAppContactsDTO
     */
    startPhrase?: string;
}

/**
 * AiApi - axios parameter creator
 * @export
 */
export const AiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<number>} virtualLookIds 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointAddLookToSandbox(virtualLookIds: Array<number>, clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'virtualLookIds' is not null or undefined
            if (virtualLookIds === null || virtualLookIds === undefined) {
                throw new RequiredError('virtualLookIds','Required parameter virtualLookIds was null or undefined when calling aiEndpointAddLookToSandbox.');
            }
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling aiEndpointAddLookToSandbox.');
            }
            const localVarPath = `/ai/addLooksToSandbox/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (virtualLookIds) {
                localVarQueryParameter['virtualLookIds'] = virtualLookIds;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} catalogItemIds 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointAddThingToSandbox(catalogItemIds: Array<number>, clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'catalogItemIds' is not null or undefined
            if (catalogItemIds === null || catalogItemIds === undefined) {
                throw new RequiredError('catalogItemIds','Required parameter catalogItemIds was null or undefined when calling aiEndpointAddThingToSandbox.');
            }
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling aiEndpointAddThingToSandbox.');
            }
            const localVarPath = `/ai/addThingToSandbox/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (catalogItemIds) {
                localVarQueryParameter['catalogItemIds'] = catalogItemIds;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * looks from catalog things to one client\'s thing or thing from catalog
         * @param {VirtualLookRequestDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointCatalogThingsLooks(body?: VirtualLookRequestDTO, options: any = {}): RequestArgs {
            const localVarPath = `/ai/catalogThingsLooks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * looks from client\'s things and one thing from catalog or wardrobe
         * @param {number} clientId 
         * @param {number} [clientThingId] 
         * @param {number} [catalogItemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointClientThingsLooks(clientId: number, clientThingId?: number, catalogItemId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling aiEndpointClientThingsLooks.');
            }
            const localVarPath = `/ai/clientThingsLooks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (clientThingId !== undefined) {
                localVarQueryParameter['clientThingId'] = clientThingId;
            }

            if (catalogItemId !== undefined) {
                localVarQueryParameter['catalogItemId'] = catalogItemId;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} lookId 
         * @param {number} score 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointCommentVirtualLook(lookId: number, score: number, comment?: string, options: any = {}): RequestArgs {
            // verify required parameter 'lookId' is not null or undefined
            if (lookId === null || lookId === undefined) {
                throw new RequiredError('lookId','Required parameter lookId was null or undefined when calling aiEndpointCommentVirtualLook.');
            }
            // verify required parameter 'score' is not null or undefined
            if (score === null || score === undefined) {
                throw new RequiredError('score','Required parameter score was null or undefined when calling aiEndpointCommentVirtualLook.');
            }
            const localVarPath = `/ai/commentVirtualLook`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (lookId !== undefined) { 
                localVarFormParams.set('lookId', lookId as any);
            }
    
            if (score !== undefined) { 
                localVarFormParams.set('score', score as any);
            }
    
            if (comment !== undefined) { 
                localVarFormParams.set('comment', comment as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ThingsForLookRequestDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointFindThingsForLook(body?: ThingsForLookRequestDTO, options: any = {}): RequestArgs {
            const localVarPath = `/ai/findThingsForLook`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ThingsForThingsRequestDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointFindThingsForThing(body?: ThingsForThingsRequestDTO, options: any = {}): RequestArgs {
            const localVarPath = `/ai/findThingsForThing`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointSearchParams(options: any = {}): RequestArgs {
            const localVarPath = `/ai/searchParams`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [commonCatId] 
         * @param {Array<'MINIMALISM' | 'ELEGANT' | 'CHIC_AND_TRENDY' | 'CASUAL' | 'SEXY' | 'FEMENINE' | 'STREET_WEAR' | 'AVANGARD' | 'CLASSIC' | 'SMART_CASUAL' | 'SPORT_CASUAL' | 'CREATIVE'>} [style] 
         * @param {Array<string>} [sizes] 
         * @param {Array<'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6' | 'R7' | 'R8' | 'R9' | 'R10' | 'R11'>} [prices] 
         * @param {Array<'SUMMER' | 'WARM_DEMI_SEASON' | 'COLD_DEMI_SEASON' | 'WINTER'>} [seasons] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointSuggestCatalogThings(commonCatId?: Array<number>, style?: Array<'MINIMALISM' | 'ELEGANT' | 'CHIC_AND_TRENDY' | 'CASUAL' | 'SEXY' | 'FEMENINE' | 'STREET_WEAR' | 'AVANGARD' | 'CLASSIC' | 'SMART_CASUAL' | 'SPORT_CASUAL' | 'CREATIVE'>, sizes?: Array<string>, prices?: Array<'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6' | 'R7' | 'R8' | 'R9' | 'R10' | 'R11'>, seasons?: Array<'SUMMER' | 'WARM_DEMI_SEASON' | 'COLD_DEMI_SEASON' | 'WINTER'>, options: any = {}): RequestArgs {
            const localVarPath = `/ai/suggestCatalogThings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (commonCatId) {
                localVarQueryParameter['commonCatId'] = commonCatId;
            }

            if (style) {
                localVarQueryParameter['style'] = style;
            }

            if (sizes) {
                localVarQueryParameter['sizes'] = sizes;
            }

            if (prices) {
                localVarQueryParameter['prices'] = prices;
            }

            if (seasons) {
                localVarQueryParameter['seasons'] = seasons;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiApi - functional programming interface
 * @export
 */
export const AiApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<number>} virtualLookIds 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointAddLookToSandbox(virtualLookIds: Array<number>, clientId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>> {
            const localVarAxiosArgs = AiApiAxiosParamCreator(configuration).aiEndpointAddLookToSandbox(virtualLookIds, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<number>} catalogItemIds 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointAddThingToSandbox(catalogItemIds: Array<number>, clientId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AiApiAxiosParamCreator(configuration).aiEndpointAddThingToSandbox(catalogItemIds, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * looks from catalog things to one client\'s thing or thing from catalog
         * @param {VirtualLookRequestDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointCatalogThingsLooks(body?: VirtualLookRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VirtualLookDTO>> {
            const localVarAxiosArgs = AiApiAxiosParamCreator(configuration).aiEndpointCatalogThingsLooks(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * looks from client\'s things and one thing from catalog or wardrobe
         * @param {number} clientId 
         * @param {number} [clientThingId] 
         * @param {number} [catalogItemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointClientThingsLooks(clientId: number, clientThingId?: number, catalogItemId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VirtualLookDTO>> {
            const localVarAxiosArgs = AiApiAxiosParamCreator(configuration).aiEndpointClientThingsLooks(clientId, clientThingId, catalogItemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} lookId 
         * @param {number} score 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointCommentVirtualLook(lookId: number, score: number, comment?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AiApiAxiosParamCreator(configuration).aiEndpointCommentVirtualLook(lookId, score, comment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ThingsForLookRequestDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointFindThingsForLook(body?: ThingsForLookRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogItemFullDTO>> {
            const localVarAxiosArgs = AiApiAxiosParamCreator(configuration).aiEndpointFindThingsForLook(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ThingsForThingsRequestDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointFindThingsForThing(body?: ThingsForThingsRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientItemCatalogItemsDTO>> {
            const localVarAxiosArgs = AiApiAxiosParamCreator(configuration).aiEndpointFindThingsForThing(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointSearchParams(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchParamsDTO> {
            const localVarAxiosArgs = AiApiAxiosParamCreator(configuration).aiEndpointSearchParams(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<number>} [commonCatId] 
         * @param {Array<'MINIMALISM' | 'ELEGANT' | 'CHIC_AND_TRENDY' | 'CASUAL' | 'SEXY' | 'FEMENINE' | 'STREET_WEAR' | 'AVANGARD' | 'CLASSIC' | 'SMART_CASUAL' | 'SPORT_CASUAL' | 'CREATIVE'>} [style] 
         * @param {Array<string>} [sizes] 
         * @param {Array<'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6' | 'R7' | 'R8' | 'R9' | 'R10' | 'R11'>} [prices] 
         * @param {Array<'SUMMER' | 'WARM_DEMI_SEASON' | 'COLD_DEMI_SEASON' | 'WINTER'>} [seasons] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointSuggestCatalogThings(commonCatId?: Array<number>, style?: Array<'MINIMALISM' | 'ELEGANT' | 'CHIC_AND_TRENDY' | 'CASUAL' | 'SEXY' | 'FEMENINE' | 'STREET_WEAR' | 'AVANGARD' | 'CLASSIC' | 'SMART_CASUAL' | 'SPORT_CASUAL' | 'CREATIVE'>, sizes?: Array<string>, prices?: Array<'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6' | 'R7' | 'R8' | 'R9' | 'R10' | 'R11'>, seasons?: Array<'SUMMER' | 'WARM_DEMI_SEASON' | 'COLD_DEMI_SEASON' | 'WINTER'>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogItemFullDTO>> {
            const localVarAxiosArgs = AiApiAxiosParamCreator(configuration).aiEndpointSuggestCatalogThings(commonCatId, style, sizes, prices, seasons, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AiApi - factory interface
 * @export
 */
export const AiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {Array<number>} virtualLookIds 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointAddLookToSandbox(virtualLookIds: Array<number>, clientId: number, options?: any): AxiosPromise<Array<number>> {
            return AiApiFp(configuration).aiEndpointAddLookToSandbox(virtualLookIds, clientId, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<number>} catalogItemIds 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointAddThingToSandbox(catalogItemIds: Array<number>, clientId: number, options?: any): AxiosPromise<void> {
            return AiApiFp(configuration).aiEndpointAddThingToSandbox(catalogItemIds, clientId, options)(axios, basePath);
        },
        /**
         * looks from catalog things to one client\'s thing or thing from catalog
         * @param {VirtualLookRequestDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointCatalogThingsLooks(body?: VirtualLookRequestDTO, options?: any): AxiosPromise<Array<VirtualLookDTO>> {
            return AiApiFp(configuration).aiEndpointCatalogThingsLooks(body, options)(axios, basePath);
        },
        /**
         * looks from client\'s things and one thing from catalog or wardrobe
         * @param {number} clientId 
         * @param {number} [clientThingId] 
         * @param {number} [catalogItemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointClientThingsLooks(clientId: number, clientThingId?: number, catalogItemId?: number, options?: any): AxiosPromise<Array<VirtualLookDTO>> {
            return AiApiFp(configuration).aiEndpointClientThingsLooks(clientId, clientThingId, catalogItemId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} lookId 
         * @param {number} score 
         * @param {string} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointCommentVirtualLook(lookId: number, score: number, comment?: string, options?: any): AxiosPromise<number> {
            return AiApiFp(configuration).aiEndpointCommentVirtualLook(lookId, score, comment, options)(axios, basePath);
        },
        /**
         * 
         * @param {ThingsForLookRequestDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointFindThingsForLook(body?: ThingsForLookRequestDTO, options?: any): AxiosPromise<Array<CatalogItemFullDTO>> {
            return AiApiFp(configuration).aiEndpointFindThingsForLook(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {ThingsForThingsRequestDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointFindThingsForThing(body?: ThingsForThingsRequestDTO, options?: any): AxiosPromise<Array<ClientItemCatalogItemsDTO>> {
            return AiApiFp(configuration).aiEndpointFindThingsForThing(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointSearchParams(options?: any): AxiosPromise<SearchParamsDTO> {
            return AiApiFp(configuration).aiEndpointSearchParams(options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<number>} [commonCatId] 
         * @param {Array<'MINIMALISM' | 'ELEGANT' | 'CHIC_AND_TRENDY' | 'CASUAL' | 'SEXY' | 'FEMENINE' | 'STREET_WEAR' | 'AVANGARD' | 'CLASSIC' | 'SMART_CASUAL' | 'SPORT_CASUAL' | 'CREATIVE'>} [style] 
         * @param {Array<string>} [sizes] 
         * @param {Array<'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6' | 'R7' | 'R8' | 'R9' | 'R10' | 'R11'>} [prices] 
         * @param {Array<'SUMMER' | 'WARM_DEMI_SEASON' | 'COLD_DEMI_SEASON' | 'WINTER'>} [seasons] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiEndpointSuggestCatalogThings(commonCatId?: Array<number>, style?: Array<'MINIMALISM' | 'ELEGANT' | 'CHIC_AND_TRENDY' | 'CASUAL' | 'SEXY' | 'FEMENINE' | 'STREET_WEAR' | 'AVANGARD' | 'CLASSIC' | 'SMART_CASUAL' | 'SPORT_CASUAL' | 'CREATIVE'>, sizes?: Array<string>, prices?: Array<'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6' | 'R7' | 'R8' | 'R9' | 'R10' | 'R11'>, seasons?: Array<'SUMMER' | 'WARM_DEMI_SEASON' | 'COLD_DEMI_SEASON' | 'WINTER'>, options?: any): AxiosPromise<Array<CatalogItemFullDTO>> {
            return AiApiFp(configuration).aiEndpointSuggestCatalogThings(commonCatId, style, sizes, prices, seasons, options)(axios, basePath);
        },
    };
};

/**
 * AiApi - object-oriented interface
 * @export
 * @class AiApi
 * @extends {BaseAPI}
 */
export class AiApi extends BaseAPI {
    /**
     * 
     * @param {Array<number>} virtualLookIds 
     * @param {number} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public aiEndpointAddLookToSandbox(virtualLookIds: Array<number>, clientId: number, options?: any) {
        return AiApiFp(this.configuration).aiEndpointAddLookToSandbox(virtualLookIds, clientId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} catalogItemIds 
     * @param {number} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public aiEndpointAddThingToSandbox(catalogItemIds: Array<number>, clientId: number, options?: any) {
        return AiApiFp(this.configuration).aiEndpointAddThingToSandbox(catalogItemIds, clientId, options)(this.axios, this.basePath);
    }

    /**
     * looks from catalog things to one client\'s thing or thing from catalog
     * @param {VirtualLookRequestDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public aiEndpointCatalogThingsLooks(body?: VirtualLookRequestDTO, options?: any) {
        return AiApiFp(this.configuration).aiEndpointCatalogThingsLooks(body, options)(this.axios, this.basePath);
    }

    /**
     * looks from client\'s things and one thing from catalog or wardrobe
     * @param {number} clientId 
     * @param {number} [clientThingId] 
     * @param {number} [catalogItemId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public aiEndpointClientThingsLooks(clientId: number, clientThingId?: number, catalogItemId?: number, options?: any) {
        return AiApiFp(this.configuration).aiEndpointClientThingsLooks(clientId, clientThingId, catalogItemId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} lookId 
     * @param {number} score 
     * @param {string} [comment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public aiEndpointCommentVirtualLook(lookId: number, score: number, comment?: string, options?: any) {
        return AiApiFp(this.configuration).aiEndpointCommentVirtualLook(lookId, score, comment, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {ThingsForLookRequestDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public aiEndpointFindThingsForLook(body?: ThingsForLookRequestDTO, options?: any) {
        return AiApiFp(this.configuration).aiEndpointFindThingsForLook(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {ThingsForThingsRequestDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public aiEndpointFindThingsForThing(body?: ThingsForThingsRequestDTO, options?: any) {
        return AiApiFp(this.configuration).aiEndpointFindThingsForThing(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public aiEndpointSearchParams(options?: any) {
        return AiApiFp(this.configuration).aiEndpointSearchParams(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} [commonCatId] 
     * @param {Array<'MINIMALISM' | 'ELEGANT' | 'CHIC_AND_TRENDY' | 'CASUAL' | 'SEXY' | 'FEMENINE' | 'STREET_WEAR' | 'AVANGARD' | 'CLASSIC' | 'SMART_CASUAL' | 'SPORT_CASUAL' | 'CREATIVE'>} [style] 
     * @param {Array<string>} [sizes] 
     * @param {Array<'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6' | 'R7' | 'R8' | 'R9' | 'R10' | 'R11'>} [prices] 
     * @param {Array<'SUMMER' | 'WARM_DEMI_SEASON' | 'COLD_DEMI_SEASON' | 'WINTER'>} [seasons] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public aiEndpointSuggestCatalogThings(commonCatId?: Array<number>, style?: Array<'MINIMALISM' | 'ELEGANT' | 'CHIC_AND_TRENDY' | 'CASUAL' | 'SEXY' | 'FEMENINE' | 'STREET_WEAR' | 'AVANGARD' | 'CLASSIC' | 'SMART_CASUAL' | 'SPORT_CASUAL' | 'CREATIVE'>, sizes?: Array<string>, prices?: Array<'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6' | 'R7' | 'R8' | 'R9' | 'R10' | 'R11'>, seasons?: Array<'SUMMER' | 'WARM_DEMI_SEASON' | 'COLD_DEMI_SEASON' | 'WINTER'>, options?: any) {
        return AiApiFp(this.configuration).aiEndpointSuggestCatalogThings(commonCatId, style, sizes, prices, seasons, options)(this.axios, this.basePath);
    }

}


/**
 * AppApi - axios parameter creator
 * @export
 */
export const AppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAcceptRules(flag: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'flag' is not null or undefined
            if (flag === null || flag === undefined) {
                throw new RequiredError('flag','Required parameter flag was null or undefined when calling appEndpointAcceptRules.');
            }
            const localVarPath = `/app/acceptRules/{flag}`
                .replace(`{${"flag"}}`, encodeURIComponent(String(flag)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns BucketItemId
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddBucketItem(priceId: number, options: any = {}): RequestArgs {
            // verify required parameter 'priceId' is not null or undefined
            if (priceId === null || priceId === undefined) {
                throw new RequiredError('priceId','Required parameter priceId was null or undefined when calling appEndpointAddBucketItem.');
            }
            const localVarPath = `/app/addBucketItem/{priceId}`
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationLookToWardrobe(lookId: number, options: any = {}): RequestArgs {
            // verify required parameter 'lookId' is not null or undefined
            if (lookId === null || lookId === undefined) {
                throw new RequiredError('lookId','Required parameter lookId was null or undefined when calling appEndpointAddCompilationLookToWardrobe.');
            }
            const localVarPath = `/app/addCompilationLookToWardrobe/{look_id}`
                .replace(`{${"look_id"}}`, encodeURIComponent(String(lookId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationThingToWardrobe(thingId: number, options: any = {}): RequestArgs {
            // verify required parameter 'thingId' is not null or undefined
            if (thingId === null || thingId === undefined) {
                throw new RequiredError('thingId','Required parameter thingId was null or undefined when calling appEndpointAddCompilationThingToWardrobe.');
            }
            const localVarPath = `/app/addCompilationThingToWardrobe/{thing_id}`
                .replace(`{${"thing_id"}}`, encodeURIComponent(String(thingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} priceId 
         * @param {'MAN' | 'WOMAN'} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddDreamItem(priceId: number, gender?: 'MAN' | 'WOMAN', options: any = {}): RequestArgs {
            // verify required parameter 'priceId' is not null or undefined
            if (priceId === null || priceId === undefined) {
                throw new RequiredError('priceId','Required parameter priceId was null or undefined when calling appEndpointAddDreamItem.');
            }
            const localVarPath = `/app/addDreamItem/{priceId}`
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [clientThingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddLookItems(id: number, clientThingIds?: Array<number>, catalogThingIds?: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointAddLookItems.');
            }
            const localVarPath = `/app/look/{id}/addItems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (clientThingIds) {
            
                localVarFormParams.set('clientThingIds', clientThingIds.join(COLLECTION_FORMATS.csv));
            }
                if (catalogThingIds) {
            
                localVarFormParams.set('catalogThingIds', catalogThingIds.join(COLLECTION_FORMATS.csv));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddVirtLookToUserLooks(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointAddVirtLookToUserLooks.');
            }
            const localVarPath = `/app/addVirtLookToUserLooks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangeBoughtStatus(clientItemId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientItemId' is not null or undefined
            if (clientItemId === null || clientItemId === undefined) {
                throw new RequiredError('clientItemId','Required parameter clientItemId was null or undefined when calling appEndpointChangeBoughtStatus.');
            }
            const localVarPath = `/app/changeBoughtStatus/{clientItemId}`
                .replace(`{${"clientItemId"}}`, encodeURIComponent(String(clientItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns BucketItemId
         * @param {number} id 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangeBucketItemSize(id: number, priceId: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointChangeBucketItemSize.');
            }
            // verify required parameter 'priceId' is not null or undefined
            if (priceId === null || priceId === undefined) {
                throw new RequiredError('priceId','Required parameter priceId was null or undefined when calling appEndpointChangeBucketItemSize.');
            }
            const localVarPath = `/app/changeBucketItemSize/{id}/{priceId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} itemId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangeDreamItemSize(itemId: number, priceId: number, options: any = {}): RequestArgs {
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling appEndpointChangeDreamItemSize.');
            }
            // verify required parameter 'priceId' is not null or undefined
            if (priceId === null || priceId === undefined) {
                throw new RequiredError('priceId','Required parameter priceId was null or undefined when calling appEndpointChangeDreamItemSize.');
            }
            const localVarPath = `/app/changeDreamItemSize/{itemId}/{priceId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary changePhoneNumber
         * @param {string} phoneNumber 
         * @param {string} smsCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangePhoneNumber(phoneNumber: string, smsCode: string, options: any = {}): RequestArgs {
            // verify required parameter 'phoneNumber' is not null or undefined
            if (phoneNumber === null || phoneNumber === undefined) {
                throw new RequiredError('phoneNumber','Required parameter phoneNumber was null or undefined when calling appEndpointChangePhoneNumber.');
            }
            // verify required parameter 'smsCode' is not null or undefined
            if (smsCode === null || smsCode === undefined) {
                throw new RequiredError('smsCode','Required parameter smsCode was null or undefined when calling appEndpointChangePhoneNumber.');
            }
            const localVarPath = `/app/changePhoneNumber/{phoneNumber}/{smsCode}`
                .replace(`{${"phoneNumber"}}`, encodeURIComponent(String(phoneNumber)))
                .replace(`{${"smsCode"}}`, encodeURIComponent(String(smsCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCheckEmal(email: string, options: any = {}): RequestArgs {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling appEndpointCheckEmal.');
            }
            const localVarPath = `/app/checkEmail`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCheckPhone(phone: string, options: any = {}): RequestArgs {
            // verify required parameter 'phone' is not null or undefined
            if (phone === null || phone === undefined) {
                throw new RequiredError('phone','Required parameter phone was null or undefined when calling appEndpointCheckPhone.');
            }
            const localVarPath = `/app/checkPhone`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateAnonymousUser(options: any = {}): RequestArgs {
            const localVarPath = `/app/createAnonymousUser`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientSelfInfoDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateAnonymousUserExtra(body?: ClientSelfInfoDTO, options: any = {}): RequestArgs {
            const localVarPath = `/app/createAnonymousUserWithExtra`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns PaymentResult
         * @param {CompilationOrderDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateCompilationOrder(body?: CompilationOrderDTO, options: any = {}): RequestArgs {
            const localVarPath = `/app/createCompilationOrder`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} categoryName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateCustomLookCategory(categoryName: string, options: any = {}): RequestArgs {
            // verify required parameter 'categoryName' is not null or undefined
            if (categoryName === null || categoryName === undefined) {
                throw new RequiredError('categoryName','Required parameter categoryName was null or undefined when calling appEndpointCreateCustomLookCategory.');
            }
            const localVarPath = `/app/createCustomLookCategory`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (categoryName !== undefined) { 
                localVarFormParams.set('categoryName', categoryName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteBucketItem(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointDeleteBucketItem.');
            }
            const localVarPath = `/app/deleteBucketItem/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * throws BusinessError with ARGUMENT_ERROR on existing looks in this category
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteCustomLookCategory(categoryId: number, options: any = {}): RequestArgs {
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling appEndpointDeleteCustomLookCategory.');
            }
            const localVarPath = `/app/deleteCustomLookCategory`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (categoryId !== undefined) { 
                localVarFormParams.set('categoryId', categoryId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteDeliveryAddresses(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointDeleteDeliveryAddresses.');
            }
            const localVarPath = `/app/deleteDeliveryAddress/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteLook(id: number, reason?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointDeleteLook.');
            }
            const localVarPath = `/app/deleteLook/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (reason !== undefined) { 
                localVarFormParams.set('reason', reason as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteThing(id: number, reason?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointDeleteThing.');
            }
            const localVarPath = `/app/deleteThing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (reason !== undefined) { 
                localVarFormParams.set('reason', reason as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationLook(id: number, state: boolean, dislikeComment?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointDislikeCompilationLook.');
            }
            // verify required parameter 'state' is not null or undefined
            if (state === null || state === undefined) {
                throw new RequiredError('state','Required parameter state was null or undefined when calling appEndpointDislikeCompilationLook.');
            }
            const localVarPath = `/app/dislikeCompilationLook/{id}/{state}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (dislikeComment !== undefined) {
                localVarQueryParameter['dislikeComment'] = dislikeComment;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationThing(id: number, state: boolean, dislikeComment?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointDislikeCompilationThing.');
            }
            // verify required parameter 'state' is not null or undefined
            if (state === null || state === undefined) {
                throw new RequiredError('state','Required parameter state was null or undefined when calling appEndpointDislikeCompilationThing.');
            }
            const localVarPath = `/app/dislikeCompilationThing/{id}/{state}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (dislikeComment !== undefined) {
                localVarQueryParameter['dislikeComment'] = dislikeComment;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * We cannot edit category name. Just can replace old category with new. So this method returns new category ID!!
         * @param {number} categoryId 
         * @param {string} newCategoryName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointEditCustomLookCategory(categoryId: number, newCategoryName: string, options: any = {}): RequestArgs {
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling appEndpointEditCustomLookCategory.');
            }
            // verify required parameter 'newCategoryName' is not null or undefined
            if (newCategoryName === null || newCategoryName === undefined) {
                throw new RequiredError('newCategoryName','Required parameter newCategoryName was null or undefined when calling appEndpointEditCustomLookCategory.');
            }
            const localVarPath = `/app/editCustomLookCategory`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (categoryId !== undefined) { 
                localVarFormParams.set('categoryId', categoryId as any);
            }
    
            if (newCategoryName !== undefined) { 
                localVarFormParams.set('newCategoryName', newCategoryName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AppSearchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointFindItems(body?: AppSearchRequest, options: any = {}): RequestArgs {
            const localVarPath = `/app/findItems`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetActualWhatsapp(options: any = {}): RequestArgs {
            const localVarPath = `/app/getActualWhatsapp`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetBucket(options: any = {}): RequestArgs {
            const localVarPath = `/app/getBucket`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetBucketItem(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointGetBucketItem.');
            }
            const localVarPath = `/app/getBucketItem/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetBucketOrders(options: any = {}): RequestArgs {
            const localVarPath = `/app/getBucketOrders`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCatalogItem(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointGetCatalogItem.');
            }
            const localVarPath = `/app/catalogItem/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} gender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCategories(gender: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', options: any = {}): RequestArgs {
            // verify required parameter 'gender' is not null or undefined
            if (gender === null || gender === undefined) {
                throw new RequiredError('gender','Required parameter gender was null or undefined when calling appEndpointGetCategories.');
            }
            const localVarPath = `/app/getCategories/{gender}`
                .replace(`{${"gender"}}`, encodeURIComponent(String(gender)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientCategoryNames(options: any = {}): RequestArgs {
            const localVarPath = `/app/categoryNames`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientInfo(options: any = {}): RequestArgs {
            const localVarPath = `/app/clientInfo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientLookCategories(options: any = {}): RequestArgs {
            const localVarPath = `/clients/clientLookCategories`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientPurchases(options: any = {}): RequestArgs {
            const localVarPath = `/app/purchases`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientTemperature(options: any = {}): RequestArgs {
            const localVarPath = `/app/clientTemperature`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientTemperatureForecast(options: any = {}): RequestArgs {
            const localVarPath = `/app/clientTemperatureForecast`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilation(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointGetCompilation.');
            }
            const localVarPath = `/app/compilation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilationServices(options: any = {}): RequestArgs {
            const localVarPath = `/app/compilationServices`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilations(options: any = {}): RequestArgs {
            const localVarPath = `/app/compilations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetConfig(options: any = {}): RequestArgs {
            const localVarPath = `/app/getConfig`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetDeletedLooks(options: any = {}): RequestArgs {
            const localVarPath = `/app/getDeletedLooks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetDeletedThings(options: any = {}): RequestArgs {
            const localVarPath = `/app/getDeletedThings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetDeliveryAddresses(options: any = {}): RequestArgs {
            const localVarPath = `/app/getDeliveryAddresses`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE'} filterType 
         * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} [gender] 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetFilterNames(filterType: 'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE', gender?: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', categoryId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'filterType' is not null or undefined
            if (filterType === null || filterType === undefined) {
                throw new RequiredError('filterType','Required parameter filterType was null or undefined when calling appEndpointGetFilterNames.');
            }
            const localVarPath = `/app/filterNames`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (filterType !== undefined) {
                localVarQueryParameter['filterType'] = filterType;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetFilterTypeNames(options: any = {}): RequestArgs {
            const localVarPath = `/app/filterTypes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetImageUrls(phoneNumber: string, options: any = {}): RequestArgs {
            // verify required parameter 'phoneNumber' is not null or undefined
            if (phoneNumber === null || phoneNumber === undefined) {
                throw new RequiredError('phoneNumber','Required parameter phoneNumber was null or undefined when calling appEndpointGetImageUrls.');
            }
            const localVarPath = `/app/getImageUrls/{phoneNumber}`
                .replace(`{${"phoneNumber"}}`, encodeURIComponent(String(phoneNumber)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetLooks(options: any = {}): RequestArgs {
            const localVarPath = `/app/getLooks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetProductsInfo(options: any = {}): RequestArgs {
            const localVarPath = `/app/products`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetPromoCards(options: any = {}): RequestArgs {
            const localVarPath = `/app/promocards`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetServiceDescriptions(options: any = {}): RequestArgs {
            const localVarPath = `/app/serviceDescriptions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetSessionId(deviceId: string, options: any = {}): RequestArgs {
            // verify required parameter 'deviceId' is not null or undefined
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId','Required parameter deviceId was null or undefined when calling appEndpointGetSessionId.');
            }
            const localVarPath = `/app/sessionId/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetShoppings(options: any = {}): RequestArgs {
            const localVarPath = `/app/getShoppings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetSizes(gender?: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', options: any = {}): RequestArgs {
            const localVarPath = `/app/sizes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetStory(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointGetStory.');
            }
            const localVarPath = `/app/story/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetStyleForm(options: any = {}): RequestArgs {
            const localVarPath = `/app/styleForm`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetStylistInfo(options: any = {}): RequestArgs {
            const localVarPath = `/app/stylist`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'WOMAN' | 'MAN' | 'UNISEX'} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetSuppliers(gender?: 'WOMAN' | 'MAN' | 'UNISEX', options: any = {}): RequestArgs {
            const localVarPath = `/app/suppliers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetThings(options: any = {}): RequestArgs {
            const localVarPath = `/app/getThings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetThingsByCategory(options: any = {}): RequestArgs {
            const localVarPath = `/app/thingsByCategory`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} catalogItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetVirtualLooks(catalogItemId: number, options: any = {}): RequestArgs {
            // verify required parameter 'catalogItemId' is not null or undefined
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId','Required parameter catalogItemId was null or undefined when calling appEndpointGetVirtualLooks.');
            }
            const localVarPath = `/looks/appVirtualLooks/{catalogItemId}`
                .replace(`{${"catalogItemId"}}`, encodeURIComponent(String(catalogItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} lookId 
         * @param {boolean} like 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointLikeForLook(lookId: number, like: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'lookId' is not null or undefined
            if (lookId === null || lookId === undefined) {
                throw new RequiredError('lookId','Required parameter lookId was null or undefined when calling appEndpointLikeForLook.');
            }
            // verify required parameter 'like' is not null or undefined
            if (like === null || like === undefined) {
                throw new RequiredError('like','Required parameter like was null or undefined when calling appEndpointLikeForLook.');
            }
            const localVarPath = `/app/likeForLook/{lookId}/{like}`
                .replace(`{${"lookId"}}`, encodeURIComponent(String(lookId)))
                .replace(`{${"like"}}`, encodeURIComponent(String(like)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * bucket items ids
         * @param {OrderDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointPlaceBucketOrder(body?: OrderDTO, options: any = {}): RequestArgs {
            const localVarPath = `/app/placeBucketOrder`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} userFeedbackRating 
         * @param {string} [userFeedbackText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRateCompilation(id: number, userFeedbackRating: string, userFeedbackText?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointRateCompilation.');
            }
            // verify required parameter 'userFeedbackRating' is not null or undefined
            if (userFeedbackRating === null || userFeedbackRating === undefined) {
                throw new RequiredError('userFeedbackRating','Required parameter userFeedbackRating was null or undefined when calling appEndpointRateCompilation.');
            }
            const localVarPath = `/app/rateCompilation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (userFeedbackRating !== undefined) {
                localVarQueryParameter['userFeedbackRating'] = userFeedbackRating;
            }

            if (userFeedbackText !== undefined) {
                localVarQueryParameter['userFeedbackText'] = userFeedbackText;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRemoveClientsCustomLookCategory(categoryId: number, options: any = {}): RequestArgs {
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling appEndpointRemoveClientsCustomLookCategory.');
            }
            const localVarPath = `/clients/removeClientsCustomLookCategory/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRemoveDreamItem(priceId: number, options: any = {}): RequestArgs {
            // verify required parameter 'priceId' is not null or undefined
            if (priceId === null || priceId === undefined) {
                throw new RequiredError('priceId','Required parameter priceId was null or undefined when calling appEndpointRemoveDreamItem.');
            }
            const localVarPath = `/app/removeDreamItem/{priceId}`
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [thingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRemoveLookItems(id: number, thingIds?: Array<number>, catalogThingIds?: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointRemoveLookItems.');
            }
            const localVarPath = `/app/look/{id}/removeItems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (thingIds) {
            
                localVarFormParams.set('thingIds', thingIds.join(COLLECTION_FORMATS.csv));
            }
                if (catalogThingIds) {
            
                localVarFormParams.set('catalogThingIds', catalogThingIds.join(COLLECTION_FORMATS.csv));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRestoreLook(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointRestoreLook.');
            }
            const localVarPath = `/app/restoreLook/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRestoreThing(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointRestoreThing.');
            }
            const localVarPath = `/app/restoreThing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * saves the client info
         * @param {ClientSelfInfoDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveClientInfo(body?: ClientSelfInfoDTO, options: any = {}): RequestArgs {
            const localVarPath = `/app/saveClientInfo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} city 
         * @param {string} streetAddress 
         * @param {boolean} _default 
         * @param {number} [id] 
         * @param {string} [extraInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveDeliveryAddress(city: string, streetAddress: string, _default: boolean, id?: number, extraInfo?: string, options: any = {}): RequestArgs {
            // verify required parameter 'city' is not null or undefined
            if (city === null || city === undefined) {
                throw new RequiredError('city','Required parameter city was null or undefined when calling appEndpointSaveDeliveryAddress.');
            }
            // verify required parameter 'streetAddress' is not null or undefined
            if (streetAddress === null || streetAddress === undefined) {
                throw new RequiredError('streetAddress','Required parameter streetAddress was null or undefined when calling appEndpointSaveDeliveryAddress.');
            }
            // verify required parameter '_default' is not null or undefined
            if (_default === null || _default === undefined) {
                throw new RequiredError('_default','Required parameter _default was null or undefined when calling appEndpointSaveDeliveryAddress.');
            }
            const localVarPath = `/app/saveDeliveryAddress`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (id !== undefined) { 
                localVarFormParams.set('id', id as any);
            }
    
            if (city !== undefined) { 
                localVarFormParams.set('city', city as any);
            }
    
            if (streetAddress !== undefined) { 
                localVarFormParams.set('streetAddress', streetAddress as any);
            }
    
            if (_default !== undefined) { 
                localVarFormParams.set('default', _default as any);
            }
    
            if (extraInfo !== undefined) { 
                localVarFormParams.set('extraInfo', extraInfo as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If lookId is null than new look will be created otherwise look will be updated
         * @param {number} category 
         * @param {number} [lookId] 
         * @param {string} [lookStatus] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveLook(category: number, lookId?: number, lookStatus?: string, temperatureFrom?: string, temperatureTo?: string, options: any = {}): RequestArgs {
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError('category','Required parameter category was null or undefined when calling appEndpointSaveLook.');
            }
            const localVarPath = `/app/saveLook`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (lookId !== undefined) { 
                localVarFormParams.set('lookId', lookId as any);
            }
    
            if (category !== undefined) { 
                localVarFormParams.set('category', category as any);
            }
    
            if (lookStatus !== undefined) { 
                localVarFormParams.set('lookStatus', lookStatus as any);
            }
    
            if (temperatureFrom !== undefined) { 
                localVarFormParams.set('temperatureFrom', temperatureFrom as any);
            }
    
            if (temperatureTo !== undefined) { 
                localVarFormParams.set('temperatureTo', temperatureTo as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientStyleFormDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveStyleForm(body?: ClientStyleFormDTO, options: any = {}): RequestArgs {
            const localVarPath = `/app/styleForm`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} categoryId 
         * @param {number} [thingId] 
         * @param {number} [userId] 
         * @param {string} [name] 
         * @param {string} [comments] 
         * @param {string} [brand] 
         * @param {string} [imageUrl] 
         * @param {string} [size] 
         * @param {number} [temperatureFrom] 
         * @param {number} [temperatureTo] 
         * @param {boolean} [dreamItem] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveThing(categoryId: number, thingId?: number, userId?: number, name?: string, comments?: string, brand?: string, imageUrl?: string, size?: string, temperatureFrom?: number, temperatureTo?: number, dreamItem?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling appEndpointSaveThing.');
            }
            const localVarPath = `/app/saveThing`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (thingId !== undefined) { 
                localVarFormParams.set('thingId', thingId as any);
            }
    
            if (userId !== undefined) { 
                localVarFormParams.set('userId', userId as any);
            }
    
            if (categoryId !== undefined) { 
                localVarFormParams.set('categoryId', categoryId as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.set('name', name as any);
            }
    
            if (comments !== undefined) { 
                localVarFormParams.set('comments', comments as any);
            }
    
            if (brand !== undefined) { 
                localVarFormParams.set('brand', brand as any);
            }
    
            if (imageUrl !== undefined) { 
                localVarFormParams.set('imageUrl', imageUrl as any);
            }
    
            if (size !== undefined) { 
                localVarFormParams.set('size', size as any);
            }
    
            if (temperatureFrom !== undefined) { 
                localVarFormParams.set('temperatureFrom', temperatureFrom as any);
            }
    
            if (temperatureTo !== undefined) { 
                localVarFormParams.set('temperatureTo', temperatureTo as any);
            }
    
            if (dreamItem !== undefined) { 
                localVarFormParams.set('dreamItem', dreamItem as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetDeviceId(deviceId: string, options: any = {}): RequestArgs {
            // verify required parameter 'deviceId' is not null or undefined
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId','Required parameter deviceId was null or undefined when calling appEndpointSetDeviceId.');
            }
            const localVarPath = `/app/deviceId/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * sets client location city obtained through https://ipinfo.io/
         * @param {string} city 
         * @param {string} country 
         * @param {string} region 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetLocation(city: string, country: string, region: string, options: any = {}): RequestArgs {
            // verify required parameter 'city' is not null or undefined
            if (city === null || city === undefined) {
                throw new RequiredError('city','Required parameter city was null or undefined when calling appEndpointSetLocation.');
            }
            // verify required parameter 'country' is not null or undefined
            if (country === null || country === undefined) {
                throw new RequiredError('country','Required parameter country was null or undefined when calling appEndpointSetLocation.');
            }
            // verify required parameter 'region' is not null or undefined
            if (region === null || region === undefined) {
                throw new RequiredError('region','Required parameter region was null or undefined when calling appEndpointSetLocation.');
            }
            const localVarPath = `/app/setLocation/{city}/{country}/{region}`
                .replace(`{${"city"}}`, encodeURIComponent(String(city)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)))
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * writes client\'s firebase token, gaid or idfv/idfa
         * @param {string} fbToken 
         * @param {string} [gaid] 
         * @param {string} [idfa] 
         * @param {string} [idfv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetTokens(fbToken: string, gaid?: string, idfa?: string, idfv?: string, options: any = {}): RequestArgs {
            // verify required parameter 'fbToken' is not null or undefined
            if (fbToken === null || fbToken === undefined) {
                throw new RequiredError('fbToken','Required parameter fbToken was null or undefined when calling appEndpointSetTokens.');
            }
            const localVarPath = `/app/setTokens`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (fbToken !== undefined) { 
                localVarFormParams.set('fbToken', fbToken as any);
            }
    
            if (gaid !== undefined) { 
                localVarFormParams.set('gaid', gaid as any);
            }
    
            if (idfa !== undefined) { 
                localVarFormParams.set('idfa', idfa as any);
            }
    
            if (idfv !== undefined) { 
                localVarFormParams.set('idfv', idfv as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetUkassaOrderId(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointSetUkassaOrderId.');
            }
            const localVarPath = `/app/setUkassaOrderId/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ErrorDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSubmitError(body?: ErrorDTO, options: any = {}): RequestArgs {
            const localVarPath = `/app/submitError`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSuggestCategories(options: any = {}): RequestArgs {
            const localVarPath = `/app/suggestCategories`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSuggestGCLooks(options: any = {}): RequestArgs {
            const localVarPath = `/app/suggestGCLooks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointUploadClientImage(fileName: string, options: any = {}): RequestArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling appEndpointUploadClientImage.');
            }
            const localVarPath = `/app/uploadClientImg/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * str should be 3 and more chars length!
         * @param {string} str 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSearchParameters(str: string, options: any = {}): RequestArgs {
            // verify required parameter 'str' is not null or undefined
            if (str === null || str === undefined) {
                throw new RequiredError('str','Required parameter str was null or undefined when calling catalogEndpointGetSearchParameters.');
            }
            const localVarPath = `/catalog/search/{str}`
                .replace(`{${"str"}}`, encodeURIComponent(String(str)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppApi - functional programming interface
 * @export
 */
export const AppApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAcceptRules(flag: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointAcceptRules(flag, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns BucketItemId
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddBucketItem(priceId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointAddBucketItem(priceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationLookToWardrobe(lookId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointAddCompilationLookToWardrobe(lookId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationThingToWardrobe(thingId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointAddCompilationThingToWardrobe(thingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} priceId 
         * @param {'MAN' | 'WOMAN'} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddDreamItem(priceId: number, gender?: 'MAN' | 'WOMAN', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointAddDreamItem(priceId, gender, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [clientThingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddLookItems(id: number, clientThingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointAddLookItems(id, clientThingIds, catalogThingIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddVirtLookToUserLooks(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointAddVirtLookToUserLooks(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangeBoughtStatus(clientItemId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointChangeBoughtStatus(clientItemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns BucketItemId
         * @param {number} id 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangeBucketItemSize(id: number, priceId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointChangeBucketItemSize(id, priceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} itemId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangeDreamItemSize(itemId: number, priceId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointChangeDreamItemSize(itemId, priceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary changePhoneNumber
         * @param {string} phoneNumber 
         * @param {string} smsCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangePhoneNumber(phoneNumber: string, smsCode: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointChangePhoneNumber(phoneNumber, smsCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCheckEmal(email: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointCheckEmal(email, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCheckPhone(phone: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointCheckPhone(phone, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateAnonymousUser(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointCreateAnonymousUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ClientSelfInfoDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateAnonymousUserExtra(body?: ClientSelfInfoDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointCreateAnonymousUserExtra(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns PaymentResult
         * @param {CompilationOrderDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateCompilationOrder(body?: CompilationOrderDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResultDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointCreateCompilationOrder(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} categoryName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateCustomLookCategory(categoryName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointCreateCustomLookCategory(categoryName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteBucketItem(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointDeleteBucketItem(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * throws BusinessError with ARGUMENT_ERROR on existing looks in this category
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteCustomLookCategory(categoryId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointDeleteCustomLookCategory(categoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteDeliveryAddresses(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointDeleteDeliveryAddresses(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteLook(id: number, reason?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointDeleteLook(id, reason, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteThing(id: number, reason?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointDeleteThing(id, reason, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationLook(id: number, state: boolean, dislikeComment?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointDislikeCompilationLook(id, state, dislikeComment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationThing(id: number, state: boolean, dislikeComment?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointDislikeCompilationThing(id, state, dislikeComment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * We cannot edit category name. Just can replace old category with new. So this method returns new category ID!!
         * @param {number} categoryId 
         * @param {string} newCategoryName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointEditCustomLookCategory(categoryId: number, newCategoryName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointEditCustomLookCategory(categoryId, newCategoryName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {AppSearchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointFindItems(body?: AppSearchRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResult> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointFindItems(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetActualWhatsapp(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WhatsAppContactsDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetActualWhatsapp(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetBucket(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BucketItemDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetBucket(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetBucketItem(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BucketItemDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetBucketItem(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetBucketOrders(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BucketOrderDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetBucketOrders(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCatalogItem(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogItemFullDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetCatalogItem(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} gender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCategories(gender: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetCategories(gender, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientCategoryNames(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetClientCategoryNames(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPrivateInfoDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetClientInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientLookCategories(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LookCategoryTranslation>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetClientLookCategories(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientPurchases(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PurchaseDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetClientPurchases(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientTemperature(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemperatureDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetClientTemperature(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientTemperatureForecast(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: TemperatureDTO; }> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetClientTemperatureForecast(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilation(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetCompilation(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilationServices(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompilationServicesDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetCompilationServices(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilations(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompilationDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetCompilations(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetConfig(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetConfig(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetDeletedLooks(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LookFullDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetDeletedLooks(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetDeletedThings(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LookItemDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetDeletedThings(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetDeliveryAddresses(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliveryAddressDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetDeliveryAddresses(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE'} filterType 
         * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} [gender] 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetFilterNames(filterType: 'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE', gender?: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', categoryId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetFilterNames(filterType, gender, categoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetFilterTypeNames(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetFilterTypeNames(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetImageUrls(phoneNumber: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImageUrlDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetImageUrls(phoneNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetLooks(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LookFullDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetLooks(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetProductsInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductInfoDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetProductsInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetPromoCards(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromoCardDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetPromoCards(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetServiceDescriptions(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetServiceDescriptions(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetSessionId(deviceId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetSessionId(deviceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetShoppings(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShoppingShortDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetShoppings(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetSizes(gender?: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetSizes(gender, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetStory(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoryDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetStory(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetStyleForm(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientStyleFormDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetStyleForm(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetStylistInfo(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StylistDTO> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetStylistInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {'WOMAN' | 'MAN' | 'UNISEX'} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetSuppliers(gender?: 'WOMAN' | 'MAN' | 'UNISEX', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupplierDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetSuppliers(gender, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetThings(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LookItemDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetThings(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetThingsByCategory(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<ItemDTO>; }> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetThingsByCategory(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} catalogItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetVirtualLooks(catalogItemId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VirtualLookDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointGetVirtualLooks(catalogItemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} lookId 
         * @param {boolean} like 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointLikeForLook(lookId: number, like: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointLikeForLook(lookId, like, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * bucket items ids
         * @param {OrderDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointPlaceBucketOrder(body?: OrderDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointPlaceBucketOrder(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} userFeedbackRating 
         * @param {string} [userFeedbackText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRateCompilation(id: number, userFeedbackRating: string, userFeedbackText?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointRateCompilation(id, userFeedbackRating, userFeedbackText, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRemoveClientsCustomLookCategory(categoryId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointRemoveClientsCustomLookCategory(categoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRemoveDreamItem(priceId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointRemoveDreamItem(priceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [thingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRemoveLookItems(id: number, thingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointRemoveLookItems(id, thingIds, catalogThingIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRestoreLook(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointRestoreLook(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRestoreThing(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointRestoreThing(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * saves the client info
         * @param {ClientSelfInfoDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveClientInfo(body?: ClientSelfInfoDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSaveClientInfo(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} city 
         * @param {string} streetAddress 
         * @param {boolean} _default 
         * @param {number} [id] 
         * @param {string} [extraInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveDeliveryAddress(city: string, streetAddress: string, _default: boolean, id?: number, extraInfo?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSaveDeliveryAddress(city, streetAddress, _default, id, extraInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * If lookId is null than new look will be created otherwise look will be updated
         * @param {number} category 
         * @param {number} [lookId] 
         * @param {string} [lookStatus] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveLook(category: number, lookId?: number, lookStatus?: string, temperatureFrom?: string, temperatureTo?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSaveLook(category, lookId, lookStatus, temperatureFrom, temperatureTo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ClientStyleFormDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveStyleForm(body?: ClientStyleFormDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSaveStyleForm(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} categoryId 
         * @param {number} [thingId] 
         * @param {number} [userId] 
         * @param {string} [name] 
         * @param {string} [comments] 
         * @param {string} [brand] 
         * @param {string} [imageUrl] 
         * @param {string} [size] 
         * @param {number} [temperatureFrom] 
         * @param {number} [temperatureTo] 
         * @param {boolean} [dreamItem] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveThing(categoryId: number, thingId?: number, userId?: number, name?: string, comments?: string, brand?: string, imageUrl?: string, size?: string, temperatureFrom?: number, temperatureTo?: number, dreamItem?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSaveThing(categoryId, thingId, userId, name, comments, brand, imageUrl, size, temperatureFrom, temperatureTo, dreamItem, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetDeviceId(deviceId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSetDeviceId(deviceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * sets client location city obtained through https://ipinfo.io/
         * @param {string} city 
         * @param {string} country 
         * @param {string} region 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetLocation(city: string, country: string, region: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSetLocation(city, country, region, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * writes client\'s firebase token, gaid or idfv/idfa
         * @param {string} fbToken 
         * @param {string} [gaid] 
         * @param {string} [idfa] 
         * @param {string} [idfv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetTokens(fbToken: string, gaid?: string, idfa?: string, idfv?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSetTokens(fbToken, gaid, idfa, idfv, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetUkassaOrderId(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSetUkassaOrderId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ErrorDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSubmitError(body?: ErrorDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSubmitError(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSuggestCategories(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSuggestCategories(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSuggestGCLooks(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VirtualLookDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointSuggestGCLooks(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointUploadClientImage(fileName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).appEndpointUploadClientImage(fileName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * str should be 3 and more chars length!
         * @param {string} str 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSearchParameters(str: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterDTO>> {
            const localVarAxiosArgs = AppApiAxiosParamCreator(configuration).catalogEndpointGetSearchParameters(str, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AppApi - factory interface
 * @export
 */
export const AppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAcceptRules(flag: boolean, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointAcceptRules(flag, options)(axios, basePath);
        },
        /**
         * returns BucketItemId
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddBucketItem(priceId: number, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointAddBucketItem(priceId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationLookToWardrobe(lookId: number, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointAddCompilationLookToWardrobe(lookId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} thingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationThingToWardrobe(thingId: number, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointAddCompilationThingToWardrobe(thingId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} priceId 
         * @param {'MAN' | 'WOMAN'} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddDreamItem(priceId: number, gender?: 'MAN' | 'WOMAN', options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointAddDreamItem(priceId, gender, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [clientThingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddLookItems(id: number, clientThingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any): AxiosPromise<object> {
            return AppApiFp(configuration).appEndpointAddLookItems(id, clientThingIds, catalogThingIds, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddVirtLookToUserLooks(id: number, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointAddVirtLookToUserLooks(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangeBoughtStatus(clientItemId: number, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointChangeBoughtStatus(clientItemId, options)(axios, basePath);
        },
        /**
         * returns BucketItemId
         * @param {number} id 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangeBucketItemSize(id: number, priceId: number, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointChangeBucketItemSize(id, priceId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} itemId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangeDreamItemSize(itemId: number, priceId: number, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointChangeDreamItemSize(itemId, priceId, options)(axios, basePath);
        },
        /**
         * 
         * @summary changePhoneNumber
         * @param {string} phoneNumber 
         * @param {string} smsCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointChangePhoneNumber(phoneNumber: string, smsCode: string, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointChangePhoneNumber(phoneNumber, smsCode, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCheckEmal(email: string, options?: any): AxiosPromise<boolean> {
            return AppApiFp(configuration).appEndpointCheckEmal(email, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCheckPhone(phone: string, options?: any): AxiosPromise<boolean> {
            return AppApiFp(configuration).appEndpointCheckPhone(phone, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateAnonymousUser(options?: any): AxiosPromise<LoginResponseDTO> {
            return AppApiFp(configuration).appEndpointCreateAnonymousUser(options)(axios, basePath);
        },
        /**
         * 
         * @param {ClientSelfInfoDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateAnonymousUserExtra(body?: ClientSelfInfoDTO, options?: any): AxiosPromise<LoginResponseDTO> {
            return AppApiFp(configuration).appEndpointCreateAnonymousUserExtra(body, options)(axios, basePath);
        },
        /**
         * returns PaymentResult
         * @param {CompilationOrderDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateCompilationOrder(body?: CompilationOrderDTO, options?: any): AxiosPromise<PaymentResultDTO> {
            return AppApiFp(configuration).appEndpointCreateCompilationOrder(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} categoryName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateCustomLookCategory(categoryName: string, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointCreateCustomLookCategory(categoryName, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteBucketItem(id: number, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointDeleteBucketItem(id, options)(axios, basePath);
        },
        /**
         * throws BusinessError with ARGUMENT_ERROR on existing looks in this category
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteCustomLookCategory(categoryId: number, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointDeleteCustomLookCategory(categoryId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteDeliveryAddresses(id: number, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointDeleteDeliveryAddresses(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteLook(id: number, reason?: string, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointDeleteLook(id, reason, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDeleteThing(id: number, reason?: string, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointDeleteThing(id, reason, options)(axios, basePath);
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationLook(id: number, state: boolean, dislikeComment?: string, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointDislikeCompilationLook(id, state, dislikeComment, options)(axios, basePath);
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationThing(id: number, state: boolean, dislikeComment?: string, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointDislikeCompilationThing(id, state, dislikeComment, options)(axios, basePath);
        },
        /**
         * We cannot edit category name. Just can replace old category with new. So this method returns new category ID!!
         * @param {number} categoryId 
         * @param {string} newCategoryName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointEditCustomLookCategory(categoryId: number, newCategoryName: string, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointEditCustomLookCategory(categoryId, newCategoryName, options)(axios, basePath);
        },
        /**
         * 
         * @param {AppSearchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointFindItems(body?: AppSearchRequest, options?: any): AxiosPromise<SearchResult> {
            return AppApiFp(configuration).appEndpointFindItems(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetActualWhatsapp(options?: any): AxiosPromise<Array<WhatsAppContactsDTO>> {
            return AppApiFp(configuration).appEndpointGetActualWhatsapp(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetBucket(options?: any): AxiosPromise<Array<BucketItemDTO>> {
            return AppApiFp(configuration).appEndpointGetBucket(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetBucketItem(id: number, options?: any): AxiosPromise<BucketItemDTO> {
            return AppApiFp(configuration).appEndpointGetBucketItem(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetBucketOrders(options?: any): AxiosPromise<Array<BucketOrderDTO>> {
            return AppApiFp(configuration).appEndpointGetBucketOrders(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCatalogItem(id: number, options?: any): AxiosPromise<CatalogItemFullDTO> {
            return AppApiFp(configuration).appEndpointGetCatalogItem(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} gender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCategories(gender: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', options?: any): AxiosPromise<Array<FilterDTO>> {
            return AppApiFp(configuration).appEndpointGetCategories(gender, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientCategoryNames(options?: any): AxiosPromise<Array<FilterDTO>> {
            return AppApiFp(configuration).appEndpointGetClientCategoryNames(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientInfo(options?: any): AxiosPromise<ClientPrivateInfoDTO> {
            return AppApiFp(configuration).appEndpointGetClientInfo(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientLookCategories(options?: any): AxiosPromise<Array<LookCategoryTranslation>> {
            return AppApiFp(configuration).appEndpointGetClientLookCategories(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientPurchases(options?: any): AxiosPromise<Array<PurchaseDTO>> {
            return AppApiFp(configuration).appEndpointGetClientPurchases(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientTemperature(options?: any): AxiosPromise<TemperatureDTO> {
            return AppApiFp(configuration).appEndpointGetClientTemperature(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetClientTemperatureForecast(options?: any): AxiosPromise<{ [key: string]: TemperatureDTO; }> {
            return AppApiFp(configuration).appEndpointGetClientTemperatureForecast(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilation(id: number, options?: any): AxiosPromise<CompilationDTO> {
            return AppApiFp(configuration).appEndpointGetCompilation(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilationServices(options?: any): AxiosPromise<Array<CompilationServicesDTO>> {
            return AppApiFp(configuration).appEndpointGetCompilationServices(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilations(options?: any): AxiosPromise<Array<CompilationDTO>> {
            return AppApiFp(configuration).appEndpointGetCompilations(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetConfig(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return AppApiFp(configuration).appEndpointGetConfig(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetDeletedLooks(options?: any): AxiosPromise<Array<LookFullDTO>> {
            return AppApiFp(configuration).appEndpointGetDeletedLooks(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetDeletedThings(options?: any): AxiosPromise<Array<LookItemDTO>> {
            return AppApiFp(configuration).appEndpointGetDeletedThings(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetDeliveryAddresses(options?: any): AxiosPromise<Array<DeliveryAddressDTO>> {
            return AppApiFp(configuration).appEndpointGetDeliveryAddresses(options)(axios, basePath);
        },
        /**
         * 
         * @param {'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE'} filterType 
         * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} [gender] 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetFilterNames(filterType: 'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE', gender?: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', categoryId?: number, options?: any): AxiosPromise<Array<FilterDTO>> {
            return AppApiFp(configuration).appEndpointGetFilterNames(filterType, gender, categoryId, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetFilterTypeNames(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return AppApiFp(configuration).appEndpointGetFilterTypeNames(options)(axios, basePath);
        },
        /**
         * 
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetImageUrls(phoneNumber: string, options?: any): AxiosPromise<Array<ImageUrlDTO>> {
            return AppApiFp(configuration).appEndpointGetImageUrls(phoneNumber, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetLooks(options?: any): AxiosPromise<Array<LookFullDTO>> {
            return AppApiFp(configuration).appEndpointGetLooks(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetProductsInfo(options?: any): AxiosPromise<Array<ProductInfoDTO>> {
            return AppApiFp(configuration).appEndpointGetProductsInfo(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetPromoCards(options?: any): AxiosPromise<Array<PromoCardDTO>> {
            return AppApiFp(configuration).appEndpointGetPromoCards(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetServiceDescriptions(options?: any): AxiosPromise<Array<ServiceDTO>> {
            return AppApiFp(configuration).appEndpointGetServiceDescriptions(options)(axios, basePath);
        },
        /**
         * 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetSessionId(deviceId: string, options?: any): AxiosPromise<string> {
            return AppApiFp(configuration).appEndpointGetSessionId(deviceId, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetShoppings(options?: any): AxiosPromise<Array<ShoppingShortDTO>> {
            return AppApiFp(configuration).appEndpointGetShoppings(options)(axios, basePath);
        },
        /**
         * 
         * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetSizes(gender?: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', options?: any): AxiosPromise<{ [key: string]: Array<string>; }> {
            return AppApiFp(configuration).appEndpointGetSizes(gender, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetStory(id: number, options?: any): AxiosPromise<StoryDTO> {
            return AppApiFp(configuration).appEndpointGetStory(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetStyleForm(options?: any): AxiosPromise<ClientStyleFormDTO> {
            return AppApiFp(configuration).appEndpointGetStyleForm(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetStylistInfo(options?: any): AxiosPromise<StylistDTO> {
            return AppApiFp(configuration).appEndpointGetStylistInfo(options)(axios, basePath);
        },
        /**
         * 
         * @param {'WOMAN' | 'MAN' | 'UNISEX'} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetSuppliers(gender?: 'WOMAN' | 'MAN' | 'UNISEX', options?: any): AxiosPromise<Array<SupplierDTO>> {
            return AppApiFp(configuration).appEndpointGetSuppliers(gender, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetThings(options?: any): AxiosPromise<Array<LookItemDTO>> {
            return AppApiFp(configuration).appEndpointGetThings(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetThingsByCategory(options?: any): AxiosPromise<{ [key: string]: Array<ItemDTO>; }> {
            return AppApiFp(configuration).appEndpointGetThingsByCategory(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} catalogItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetVirtualLooks(catalogItemId: number, options?: any): AxiosPromise<Array<VirtualLookDTO>> {
            return AppApiFp(configuration).appEndpointGetVirtualLooks(catalogItemId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} lookId 
         * @param {boolean} like 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointLikeForLook(lookId: number, like: boolean, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointLikeForLook(lookId, like, options)(axios, basePath);
        },
        /**
         * bucket items ids
         * @param {OrderDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointPlaceBucketOrder(body?: OrderDTO, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointPlaceBucketOrder(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} userFeedbackRating 
         * @param {string} [userFeedbackText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRateCompilation(id: number, userFeedbackRating: string, userFeedbackText?: string, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointRateCompilation(id, userFeedbackRating, userFeedbackText, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRemoveClientsCustomLookCategory(categoryId: number, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointRemoveClientsCustomLookCategory(categoryId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRemoveDreamItem(priceId: number, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointRemoveDreamItem(priceId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [thingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRemoveLookItems(id: number, thingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any): AxiosPromise<object> {
            return AppApiFp(configuration).appEndpointRemoveLookItems(id, thingIds, catalogThingIds, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRestoreLook(id: number, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointRestoreLook(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRestoreThing(id: number, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointRestoreThing(id, options)(axios, basePath);
        },
        /**
         * saves the client info
         * @param {ClientSelfInfoDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveClientInfo(body?: ClientSelfInfoDTO, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointSaveClientInfo(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} city 
         * @param {string} streetAddress 
         * @param {boolean} _default 
         * @param {number} [id] 
         * @param {string} [extraInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveDeliveryAddress(city: string, streetAddress: string, _default: boolean, id?: number, extraInfo?: string, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointSaveDeliveryAddress(city, streetAddress, _default, id, extraInfo, options)(axios, basePath);
        },
        /**
         * If lookId is null than new look will be created otherwise look will be updated
         * @param {number} category 
         * @param {number} [lookId] 
         * @param {string} [lookStatus] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveLook(category: number, lookId?: number, lookStatus?: string, temperatureFrom?: string, temperatureTo?: string, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointSaveLook(category, lookId, lookStatus, temperatureFrom, temperatureTo, options)(axios, basePath);
        },
        /**
         * 
         * @param {ClientStyleFormDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveStyleForm(body?: ClientStyleFormDTO, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointSaveStyleForm(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} categoryId 
         * @param {number} [thingId] 
         * @param {number} [userId] 
         * @param {string} [name] 
         * @param {string} [comments] 
         * @param {string} [brand] 
         * @param {string} [imageUrl] 
         * @param {string} [size] 
         * @param {number} [temperatureFrom] 
         * @param {number} [temperatureTo] 
         * @param {boolean} [dreamItem] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSaveThing(categoryId: number, thingId?: number, userId?: number, name?: string, comments?: string, brand?: string, imageUrl?: string, size?: string, temperatureFrom?: number, temperatureTo?: number, dreamItem?: boolean, options?: any): AxiosPromise<number> {
            return AppApiFp(configuration).appEndpointSaveThing(categoryId, thingId, userId, name, comments, brand, imageUrl, size, temperatureFrom, temperatureTo, dreamItem, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetDeviceId(deviceId: string, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointSetDeviceId(deviceId, options)(axios, basePath);
        },
        /**
         * sets client location city obtained through https://ipinfo.io/
         * @param {string} city 
         * @param {string} country 
         * @param {string} region 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetLocation(city: string, country: string, region: string, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointSetLocation(city, country, region, options)(axios, basePath);
        },
        /**
         * writes client\'s firebase token, gaid or idfv/idfa
         * @param {string} fbToken 
         * @param {string} [gaid] 
         * @param {string} [idfa] 
         * @param {string} [idfv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetTokens(fbToken: string, gaid?: string, idfa?: string, idfv?: string, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointSetTokens(fbToken, gaid, idfa, idfv, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetUkassaOrderId(id: string, options?: any): AxiosPromise<object> {
            return AppApiFp(configuration).appEndpointSetUkassaOrderId(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {ErrorDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSubmitError(body?: ErrorDTO, options?: any): AxiosPromise<void> {
            return AppApiFp(configuration).appEndpointSubmitError(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSuggestCategories(options?: any): AxiosPromise<Array<CategoryDTO>> {
            return AppApiFp(configuration).appEndpointSuggestCategories(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSuggestGCLooks(options?: any): AxiosPromise<Array<VirtualLookDTO>> {
            return AppApiFp(configuration).appEndpointSuggestGCLooks(options)(axios, basePath);
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointUploadClientImage(fileName: string, options?: any): AxiosPromise<string> {
            return AppApiFp(configuration).appEndpointUploadClientImage(fileName, options)(axios, basePath);
        },
        /**
         * str should be 3 and more chars length!
         * @param {string} str 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSearchParameters(str: string, options?: any): AxiosPromise<Array<FilterDTO>> {
            return AppApiFp(configuration).catalogEndpointGetSearchParameters(str, options)(axios, basePath);
        },
    };
};

/**
 * AppApi - object-oriented interface
 * @export
 * @class AppApi
 * @extends {BaseAPI}
 */
export class AppApi extends BaseAPI {
    /**
     * 
     * @param {boolean} flag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointAcceptRules(flag: boolean, options?: any) {
        return AppApiFp(this.configuration).appEndpointAcceptRules(flag, options)(this.axios, this.basePath);
    }

    /**
     * returns BucketItemId
     * @param {number} priceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointAddBucketItem(priceId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointAddBucketItem(priceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} lookId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointAddCompilationLookToWardrobe(lookId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointAddCompilationLookToWardrobe(lookId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} thingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointAddCompilationThingToWardrobe(thingId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointAddCompilationThingToWardrobe(thingId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} priceId 
     * @param {'MAN' | 'WOMAN'} [gender] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointAddDreamItem(priceId: number, gender?: 'MAN' | 'WOMAN', options?: any) {
        return AppApiFp(this.configuration).appEndpointAddDreamItem(priceId, gender, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {Array<number>} [clientThingIds] 
     * @param {Array<number>} [catalogThingIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointAddLookItems(id: number, clientThingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any) {
        return AppApiFp(this.configuration).appEndpointAddLookItems(id, clientThingIds, catalogThingIds, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointAddVirtLookToUserLooks(id: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointAddVirtLookToUserLooks(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointChangeBoughtStatus(clientItemId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointChangeBoughtStatus(clientItemId, options)(this.axios, this.basePath);
    }

    /**
     * returns BucketItemId
     * @param {number} id 
     * @param {number} priceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointChangeBucketItemSize(id: number, priceId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointChangeBucketItemSize(id, priceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} itemId 
     * @param {number} priceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointChangeDreamItemSize(itemId: number, priceId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointChangeDreamItemSize(itemId, priceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary changePhoneNumber
     * @param {string} phoneNumber 
     * @param {string} smsCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointChangePhoneNumber(phoneNumber: string, smsCode: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointChangePhoneNumber(phoneNumber, smsCode, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointCheckEmal(email: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointCheckEmal(email, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} phone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointCheckPhone(phone: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointCheckPhone(phone, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointCreateAnonymousUser(options?: any) {
        return AppApiFp(this.configuration).appEndpointCreateAnonymousUser(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {ClientSelfInfoDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointCreateAnonymousUserExtra(body?: ClientSelfInfoDTO, options?: any) {
        return AppApiFp(this.configuration).appEndpointCreateAnonymousUserExtra(body, options)(this.axios, this.basePath);
    }

    /**
     * returns PaymentResult
     * @param {CompilationOrderDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointCreateCompilationOrder(body?: CompilationOrderDTO, options?: any) {
        return AppApiFp(this.configuration).appEndpointCreateCompilationOrder(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} categoryName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointCreateCustomLookCategory(categoryName: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointCreateCustomLookCategory(categoryName, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointDeleteBucketItem(id: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointDeleteBucketItem(id, options)(this.axios, this.basePath);
    }

    /**
     * throws BusinessError with ARGUMENT_ERROR on existing looks in this category
     * @param {number} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointDeleteCustomLookCategory(categoryId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointDeleteCustomLookCategory(categoryId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointDeleteDeliveryAddresses(id: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointDeleteDeliveryAddresses(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointDeleteLook(id: number, reason?: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointDeleteLook(id, reason, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointDeleteThing(id: number, reason?: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointDeleteThing(id, reason, options)(this.axios, this.basePath);
    }

    /**
     * state == true|false
     * @param {number} id 
     * @param {boolean} state 
     * @param {string} [dislikeComment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointDislikeCompilationLook(id: number, state: boolean, dislikeComment?: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointDislikeCompilationLook(id, state, dislikeComment, options)(this.axios, this.basePath);
    }

    /**
     * state == true|false
     * @param {number} id 
     * @param {boolean} state 
     * @param {string} [dislikeComment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointDislikeCompilationThing(id: number, state: boolean, dislikeComment?: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointDislikeCompilationThing(id, state, dislikeComment, options)(this.axios, this.basePath);
    }

    /**
     * We cannot edit category name. Just can replace old category with new. So this method returns new category ID!!
     * @param {number} categoryId 
     * @param {string} newCategoryName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointEditCustomLookCategory(categoryId: number, newCategoryName: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointEditCustomLookCategory(categoryId, newCategoryName, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {AppSearchRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointFindItems(body?: AppSearchRequest, options?: any) {
        return AppApiFp(this.configuration).appEndpointFindItems(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetActualWhatsapp(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetActualWhatsapp(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetBucket(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetBucket(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetBucketItem(id: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointGetBucketItem(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetBucketOrders(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetBucketOrders(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetCatalogItem(id: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointGetCatalogItem(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} gender 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetCategories(gender: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', options?: any) {
        return AppApiFp(this.configuration).appEndpointGetCategories(gender, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetClientCategoryNames(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetClientCategoryNames(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetClientInfo(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetClientInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetClientLookCategories(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetClientLookCategories(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetClientPurchases(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetClientPurchases(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetClientTemperature(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetClientTemperature(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetClientTemperatureForecast(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetClientTemperatureForecast(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetCompilation(id: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointGetCompilation(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetCompilationServices(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetCompilationServices(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetCompilations(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetCompilations(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetConfig(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetConfig(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetDeletedLooks(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetDeletedLooks(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetDeletedThings(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetDeletedThings(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetDeliveryAddresses(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetDeliveryAddresses(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE'} filterType 
     * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} [gender] 
     * @param {number} [categoryId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetFilterNames(filterType: 'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE', gender?: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', categoryId?: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointGetFilterNames(filterType, gender, categoryId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetFilterTypeNames(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetFilterTypeNames(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} phoneNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetImageUrls(phoneNumber: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointGetImageUrls(phoneNumber, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetLooks(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetLooks(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetProductsInfo(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetProductsInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetPromoCards(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetPromoCards(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetServiceDescriptions(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetServiceDescriptions(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetSessionId(deviceId: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointGetSessionId(deviceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetShoppings(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetShoppings(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT'} [gender] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetSizes(gender?: 'KID_BOY' | 'KID_GIRL' | 'MAN' | 'WOMAN' | 'KID_UNISEX' | 'UNISEX' | 'INFANT', options?: any) {
        return AppApiFp(this.configuration).appEndpointGetSizes(gender, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetStory(id: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointGetStory(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetStyleForm(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetStyleForm(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetStylistInfo(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetStylistInfo(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {'WOMAN' | 'MAN' | 'UNISEX'} [gender] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetSuppliers(gender?: 'WOMAN' | 'MAN' | 'UNISEX', options?: any) {
        return AppApiFp(this.configuration).appEndpointGetSuppliers(gender, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetThings(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetThings(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetThingsByCategory(options?: any) {
        return AppApiFp(this.configuration).appEndpointGetThingsByCategory(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} catalogItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointGetVirtualLooks(catalogItemId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointGetVirtualLooks(catalogItemId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} lookId 
     * @param {boolean} like 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointLikeForLook(lookId: number, like: boolean, options?: any) {
        return AppApiFp(this.configuration).appEndpointLikeForLook(lookId, like, options)(this.axios, this.basePath);
    }

    /**
     * bucket items ids
     * @param {OrderDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointPlaceBucketOrder(body?: OrderDTO, options?: any) {
        return AppApiFp(this.configuration).appEndpointPlaceBucketOrder(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {string} userFeedbackRating 
     * @param {string} [userFeedbackText] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointRateCompilation(id: number, userFeedbackRating: string, userFeedbackText?: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointRateCompilation(id, userFeedbackRating, userFeedbackText, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointRemoveClientsCustomLookCategory(categoryId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointRemoveClientsCustomLookCategory(categoryId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} priceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointRemoveDreamItem(priceId: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointRemoveDreamItem(priceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {Array<number>} [thingIds] 
     * @param {Array<number>} [catalogThingIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointRemoveLookItems(id: number, thingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any) {
        return AppApiFp(this.configuration).appEndpointRemoveLookItems(id, thingIds, catalogThingIds, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointRestoreLook(id: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointRestoreLook(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointRestoreThing(id: number, options?: any) {
        return AppApiFp(this.configuration).appEndpointRestoreThing(id, options)(this.axios, this.basePath);
    }

    /**
     * saves the client info
     * @param {ClientSelfInfoDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSaveClientInfo(body?: ClientSelfInfoDTO, options?: any) {
        return AppApiFp(this.configuration).appEndpointSaveClientInfo(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} city 
     * @param {string} streetAddress 
     * @param {boolean} _default 
     * @param {number} [id] 
     * @param {string} [extraInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSaveDeliveryAddress(city: string, streetAddress: string, _default: boolean, id?: number, extraInfo?: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointSaveDeliveryAddress(city, streetAddress, _default, id, extraInfo, options)(this.axios, this.basePath);
    }

    /**
     * If lookId is null than new look will be created otherwise look will be updated
     * @param {number} category 
     * @param {number} [lookId] 
     * @param {string} [lookStatus] 
     * @param {string} [temperatureFrom] 
     * @param {string} [temperatureTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSaveLook(category: number, lookId?: number, lookStatus?: string, temperatureFrom?: string, temperatureTo?: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointSaveLook(category, lookId, lookStatus, temperatureFrom, temperatureTo, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {ClientStyleFormDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSaveStyleForm(body?: ClientStyleFormDTO, options?: any) {
        return AppApiFp(this.configuration).appEndpointSaveStyleForm(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} categoryId 
     * @param {number} [thingId] 
     * @param {number} [userId] 
     * @param {string} [name] 
     * @param {string} [comments] 
     * @param {string} [brand] 
     * @param {string} [imageUrl] 
     * @param {string} [size] 
     * @param {number} [temperatureFrom] 
     * @param {number} [temperatureTo] 
     * @param {boolean} [dreamItem] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSaveThing(categoryId: number, thingId?: number, userId?: number, name?: string, comments?: string, brand?: string, imageUrl?: string, size?: string, temperatureFrom?: number, temperatureTo?: number, dreamItem?: boolean, options?: any) {
        return AppApiFp(this.configuration).appEndpointSaveThing(categoryId, thingId, userId, name, comments, brand, imageUrl, size, temperatureFrom, temperatureTo, dreamItem, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSetDeviceId(deviceId: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointSetDeviceId(deviceId, options)(this.axios, this.basePath);
    }

    /**
     * sets client location city obtained through https://ipinfo.io/
     * @param {string} city 
     * @param {string} country 
     * @param {string} region 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSetLocation(city: string, country: string, region: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointSetLocation(city, country, region, options)(this.axios, this.basePath);
    }

    /**
     * writes client\'s firebase token, gaid or idfv/idfa
     * @param {string} fbToken 
     * @param {string} [gaid] 
     * @param {string} [idfa] 
     * @param {string} [idfv] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSetTokens(fbToken: string, gaid?: string, idfa?: string, idfv?: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointSetTokens(fbToken, gaid, idfa, idfv, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSetUkassaOrderId(id: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointSetUkassaOrderId(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {ErrorDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSubmitError(body?: ErrorDTO, options?: any) {
        return AppApiFp(this.configuration).appEndpointSubmitError(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSuggestCategories(options?: any) {
        return AppApiFp(this.configuration).appEndpointSuggestCategories(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointSuggestGCLooks(options?: any) {
        return AppApiFp(this.configuration).appEndpointSuggestGCLooks(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appEndpointUploadClientImage(fileName: string, options?: any) {
        return AppApiFp(this.configuration).appEndpointUploadClientImage(fileName, options)(this.axios, this.basePath);
    }

    /**
     * str should be 3 and more chars length!
     * @param {string} str 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public catalogEndpointGetSearchParameters(str: string, options?: any) {
        return AppApiFp(this.configuration).catalogEndpointGetSearchParameters(str, options)(this.axios, this.basePath);
    }

}


/**
 * AppCompilationApi - axios parameter creator
 * @export
 */
export const AppCompilationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationLookToWardrobe(lookId: number, options: any = {}): RequestArgs {
            // verify required parameter 'lookId' is not null or undefined
            if (lookId === null || lookId === undefined) {
                throw new RequiredError('lookId','Required parameter lookId was null or undefined when calling appEndpointAddCompilationLookToWardrobe.');
            }
            const localVarPath = `/app/addCompilationLookToWardrobe/{look_id}`
                .replace(`{${"look_id"}}`, encodeURIComponent(String(lookId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationThingToWardrobe(thingId: number, options: any = {}): RequestArgs {
            // verify required parameter 'thingId' is not null or undefined
            if (thingId === null || thingId === undefined) {
                throw new RequiredError('thingId','Required parameter thingId was null or undefined when calling appEndpointAddCompilationThingToWardrobe.');
            }
            const localVarPath = `/app/addCompilationThingToWardrobe/{thing_id}`
                .replace(`{${"thing_id"}}`, encodeURIComponent(String(thingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns PaymentResult
         * @param {CompilationOrderDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateCompilationOrder(body?: CompilationOrderDTO, options: any = {}): RequestArgs {
            const localVarPath = `/app/createCompilationOrder`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationLook(id: number, state: boolean, dislikeComment?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointDislikeCompilationLook.');
            }
            // verify required parameter 'state' is not null or undefined
            if (state === null || state === undefined) {
                throw new RequiredError('state','Required parameter state was null or undefined when calling appEndpointDislikeCompilationLook.');
            }
            const localVarPath = `/app/dislikeCompilationLook/{id}/{state}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (dislikeComment !== undefined) {
                localVarQueryParameter['dislikeComment'] = dislikeComment;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationThing(id: number, state: boolean, dislikeComment?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointDislikeCompilationThing.');
            }
            // verify required parameter 'state' is not null or undefined
            if (state === null || state === undefined) {
                throw new RequiredError('state','Required parameter state was null or undefined when calling appEndpointDislikeCompilationThing.');
            }
            const localVarPath = `/app/dislikeCompilationThing/{id}/{state}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (dislikeComment !== undefined) {
                localVarQueryParameter['dislikeComment'] = dislikeComment;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilation(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointGetCompilation.');
            }
            const localVarPath = `/app/compilation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilationServices(options: any = {}): RequestArgs {
            const localVarPath = `/app/compilationServices`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilations(options: any = {}): RequestArgs {
            const localVarPath = `/app/compilations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} userFeedbackRating 
         * @param {string} [userFeedbackText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRateCompilation(id: number, userFeedbackRating: string, userFeedbackText?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointRateCompilation.');
            }
            // verify required parameter 'userFeedbackRating' is not null or undefined
            if (userFeedbackRating === null || userFeedbackRating === undefined) {
                throw new RequiredError('userFeedbackRating','Required parameter userFeedbackRating was null or undefined when calling appEndpointRateCompilation.');
            }
            const localVarPath = `/app/rateCompilation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (userFeedbackRating !== undefined) {
                localVarQueryParameter['userFeedbackRating'] = userFeedbackRating;
            }

            if (userFeedbackText !== undefined) {
                localVarQueryParameter['userFeedbackText'] = userFeedbackText;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetUkassaOrderId(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling appEndpointSetUkassaOrderId.');
            }
            const localVarPath = `/app/setUkassaOrderId/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppCompilationApi - functional programming interface
 * @export
 */
export const AppCompilationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationLookToWardrobe(lookId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointAddCompilationLookToWardrobe(lookId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationThingToWardrobe(thingId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointAddCompilationThingToWardrobe(thingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns PaymentResult
         * @param {CompilationOrderDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateCompilationOrder(body?: CompilationOrderDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResultDTO> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointCreateCompilationOrder(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationLook(id: number, state: boolean, dislikeComment?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointDislikeCompilationLook(id, state, dislikeComment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationThing(id: number, state: boolean, dislikeComment?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointDislikeCompilationThing(id, state, dislikeComment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilation(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationDTO> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointGetCompilation(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilationServices(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompilationServicesDTO>> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointGetCompilationServices(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilations(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompilationDTO>> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointGetCompilations(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} userFeedbackRating 
         * @param {string} [userFeedbackText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRateCompilation(id: number, userFeedbackRating: string, userFeedbackText?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointRateCompilation(id, userFeedbackRating, userFeedbackText, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetUkassaOrderId(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = AppCompilationApiAxiosParamCreator(configuration).appEndpointSetUkassaOrderId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AppCompilationApi - factory interface
 * @export
 */
export const AppCompilationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationLookToWardrobe(lookId: number, options?: any): AxiosPromise<number> {
            return AppCompilationApiFp(configuration).appEndpointAddCompilationLookToWardrobe(lookId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} thingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointAddCompilationThingToWardrobe(thingId: number, options?: any): AxiosPromise<void> {
            return AppCompilationApiFp(configuration).appEndpointAddCompilationThingToWardrobe(thingId, options)(axios, basePath);
        },
        /**
         * returns PaymentResult
         * @param {CompilationOrderDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointCreateCompilationOrder(body?: CompilationOrderDTO, options?: any): AxiosPromise<PaymentResultDTO> {
            return AppCompilationApiFp(configuration).appEndpointCreateCompilationOrder(body, options)(axios, basePath);
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationLook(id: number, state: boolean, dislikeComment?: string, options?: any): AxiosPromise<number> {
            return AppCompilationApiFp(configuration).appEndpointDislikeCompilationLook(id, state, dislikeComment, options)(axios, basePath);
        },
        /**
         * state == true|false
         * @param {number} id 
         * @param {boolean} state 
         * @param {string} [dislikeComment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointDislikeCompilationThing(id: number, state: boolean, dislikeComment?: string, options?: any): AxiosPromise<number> {
            return AppCompilationApiFp(configuration).appEndpointDislikeCompilationThing(id, state, dislikeComment, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilation(id: number, options?: any): AxiosPromise<CompilationDTO> {
            return AppCompilationApiFp(configuration).appEndpointGetCompilation(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilationServices(options?: any): AxiosPromise<Array<CompilationServicesDTO>> {
            return AppCompilationApiFp(configuration).appEndpointGetCompilationServices(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointGetCompilations(options?: any): AxiosPromise<Array<CompilationDTO>> {
            return AppCompilationApiFp(configuration).appEndpointGetCompilations(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} userFeedbackRating 
         * @param {string} [userFeedbackText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointRateCompilation(id: number, userFeedbackRating: string, userFeedbackText?: string, options?: any): AxiosPromise<number> {
            return AppCompilationApiFp(configuration).appEndpointRateCompilation(id, userFeedbackRating, userFeedbackText, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEndpointSetUkassaOrderId(id: string, options?: any): AxiosPromise<object> {
            return AppCompilationApiFp(configuration).appEndpointSetUkassaOrderId(id, options)(axios, basePath);
        },
    };
};

/**
 * AppCompilationApi - object-oriented interface
 * @export
 * @class AppCompilationApi
 * @extends {BaseAPI}
 */
export class AppCompilationApi extends BaseAPI {
    /**
     * 
     * @param {number} lookId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointAddCompilationLookToWardrobe(lookId: number, options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointAddCompilationLookToWardrobe(lookId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} thingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointAddCompilationThingToWardrobe(thingId: number, options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointAddCompilationThingToWardrobe(thingId, options)(this.axios, this.basePath);
    }

    /**
     * returns PaymentResult
     * @param {CompilationOrderDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointCreateCompilationOrder(body?: CompilationOrderDTO, options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointCreateCompilationOrder(body, options)(this.axios, this.basePath);
    }

    /**
     * state == true|false
     * @param {number} id 
     * @param {boolean} state 
     * @param {string} [dislikeComment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointDislikeCompilationLook(id: number, state: boolean, dislikeComment?: string, options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointDislikeCompilationLook(id, state, dislikeComment, options)(this.axios, this.basePath);
    }

    /**
     * state == true|false
     * @param {number} id 
     * @param {boolean} state 
     * @param {string} [dislikeComment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointDislikeCompilationThing(id: number, state: boolean, dislikeComment?: string, options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointDislikeCompilationThing(id, state, dislikeComment, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointGetCompilation(id: number, options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointGetCompilation(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointGetCompilationServices(options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointGetCompilationServices(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointGetCompilations(options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointGetCompilations(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {string} userFeedbackRating 
     * @param {string} [userFeedbackText] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointRateCompilation(id: number, userFeedbackRating: string, userFeedbackText?: string, options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointRateCompilation(id, userFeedbackRating, userFeedbackText, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppCompilationApi
     */
    public appEndpointSetUkassaOrderId(id: string, options?: any) {
        return AppCompilationApiFp(this.configuration).appEndpointSetUkassaOrderId(id, options)(this.axios, this.basePath);
    }

}


/**
 * CatalogApi - axios parameter creator
 * @export
 */
export const CatalogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * brandId
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointAddNewBrand(name: string, options: any = {}): RequestArgs {
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling catalogEndpointAddNewBrand.');
            }
            const localVarPath = `/catalog/addNewBrand/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointAddNewSupplier(name: string, options: any = {}): RequestArgs {
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling catalogEndpointAddNewSupplier.');
            }
            const localVarPath = `/catalog/addNewSupplier/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointCountItems(options: any = {}): RequestArgs {
            const localVarPath = `/catalog/count`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointFindItems2(body?: SearchRequest, options: any = {}): RequestArgs {
            const localVarPath = `/catalog/findItems2`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetClientCategoryNames(userId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling catalogEndpointGetClientCategoryNames.');
            }
            const localVarPath = `/catalog/categoryNames/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE'} filterType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetFilterNames(filterType: 'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE', options: any = {}): RequestArgs {
            // verify required parameter 'filterType' is not null or undefined
            if (filterType === null || filterType === undefined) {
                throw new RequiredError('filterType','Required parameter filterType was null or undefined when calling catalogEndpointGetFilterNames.');
            }
            const localVarPath = `/catalog/filterNames/{filterType}`
                .replace(`{${"filterType"}}`, encodeURIComponent(String(filterType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetFilterTypeNames(options: any = {}): RequestArgs {
            const localVarPath = `/catalog/filterTypes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItem(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling catalogEndpointGetItem.');
            }
            const localVarPath = `/catalog/item/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItemStyleNamess(options: any = {}): RequestArgs {
            const localVarPath = `/catalog/itemStyleNames`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItemStyles(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling catalogEndpointGetItemStyles.');
            }
            const localVarPath = `/catalog/itemStyles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItems(offset: number, limit: number, options: any = {}): RequestArgs {
            // verify required parameter 'offset' is not null or undefined
            if (offset === null || offset === undefined) {
                throw new RequiredError('offset','Required parameter offset was null or undefined when calling catalogEndpointGetItems.');
            }
            // verify required parameter 'limit' is not null or undefined
            if (limit === null || limit === undefined) {
                throw new RequiredError('limit','Required parameter limit was null or undefined when calling catalogEndpointGetItems.');
            }
            const localVarPath = `/catalog/listItems`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (offset !== undefined) { 
                localVarFormParams.set('offset', offset as any);
            }
    
            if (limit !== undefined) { 
                localVarFormParams.set('limit', limit as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * str should be 3 and more chars length!
         * @param {string} str 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSearchParameters(str: string, options: any = {}): RequestArgs {
            // verify required parameter 'str' is not null or undefined
            if (str === null || str === undefined) {
                throw new RequiredError('str','Required parameter str was null or undefined when calling catalogEndpointGetSearchParameters.');
            }
            const localVarPath = `/catalog/search/{str}`
                .replace(`{${"str"}}`, encodeURIComponent(String(str)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSuppliersList(options: any = {}): RequestArgs {
            const localVarPath = `/catalog/suppliersList`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSuppliersTranslations(options: any = {}): RequestArgs {
            const localVarPath = `/catalog/suppliers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} supplier 
         * @param {string} url 
         * @param {number} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointParseItemUrl(supplier: string, url: string, clientId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'supplier' is not null or undefined
            if (supplier === null || supplier === undefined) {
                throw new RequiredError('supplier','Required parameter supplier was null or undefined when calling catalogEndpointParseItemUrl.');
            }
            // verify required parameter 'url' is not null or undefined
            if (url === null || url === undefined) {
                throw new RequiredError('url','Required parameter url was null or undefined when calling catalogEndpointParseItemUrl.');
            }
            const localVarPath = `/catalog/parseItemUrl/{supplier}`
                .replace(`{${"supplier"}}`, encodeURIComponent(String(supplier)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (url !== undefined) { 
                localVarFormParams.set('url', url as any);
            }
    
            if (clientId !== undefined) { 
                localVarFormParams.set('clientId', clientId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {string} type 
         * @param {string} brandId 
         * @param {number} categoryId 
         * @param {number} colorId 
         * @param {string} gender 
         * @param {string} supplier 
         * @param {string} size 
         * @param {number} fullPrice 
         * @param {number} [id] 
         * @param {string} [description] 
         * @param {string} [material] 
         * @param {number} [priceDiscount] 
         * @param {string} [barcode] 
         * @param {number} [shoppingId] 
         * @param {string} [originalUrl] 
         * @param {number} [clientId] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointSaveItem(name: string, type: string, brandId: string, categoryId: number, colorId: number, gender: string, supplier: string, size: string, fullPrice: number, id?: number, description?: string, material?: string, priceDiscount?: number, barcode?: string, shoppingId?: number, originalUrl?: string, clientId?: number, temperatureFrom?: string, temperatureTo?: string, options: any = {}): RequestArgs {
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling catalogEndpointSaveItem.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling catalogEndpointSaveItem.');
            }
            // verify required parameter 'brandId' is not null or undefined
            if (brandId === null || brandId === undefined) {
                throw new RequiredError('brandId','Required parameter brandId was null or undefined when calling catalogEndpointSaveItem.');
            }
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling catalogEndpointSaveItem.');
            }
            // verify required parameter 'colorId' is not null or undefined
            if (colorId === null || colorId === undefined) {
                throw new RequiredError('colorId','Required parameter colorId was null or undefined when calling catalogEndpointSaveItem.');
            }
            // verify required parameter 'gender' is not null or undefined
            if (gender === null || gender === undefined) {
                throw new RequiredError('gender','Required parameter gender was null or undefined when calling catalogEndpointSaveItem.');
            }
            // verify required parameter 'supplier' is not null or undefined
            if (supplier === null || supplier === undefined) {
                throw new RequiredError('supplier','Required parameter supplier was null or undefined when calling catalogEndpointSaveItem.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling catalogEndpointSaveItem.');
            }
            // verify required parameter 'fullPrice' is not null or undefined
            if (fullPrice === null || fullPrice === undefined) {
                throw new RequiredError('fullPrice','Required parameter fullPrice was null or undefined when calling catalogEndpointSaveItem.');
            }
            const localVarPath = `/catalog/saveItem`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (id !== undefined) { 
                localVarFormParams.set('id', id as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.set('name', name as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.set('type', type as any);
            }
    
            if (brandId !== undefined) { 
                localVarFormParams.set('brandId', brandId as any);
            }
    
            if (categoryId !== undefined) { 
                localVarFormParams.set('categoryId', categoryId as any);
            }
    
            if (colorId !== undefined) { 
                localVarFormParams.set('colorId', colorId as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.set('description', description as any);
            }
    
            if (gender !== undefined) { 
                localVarFormParams.set('gender', gender as any);
            }
    
            if (material !== undefined) { 
                localVarFormParams.set('material', material as any);
            }
    
            if (supplier !== undefined) { 
                localVarFormParams.set('supplier', supplier as any);
            }
    
            if (size !== undefined) { 
                localVarFormParams.set('size', size as any);
            }
    
            if (fullPrice !== undefined) { 
                localVarFormParams.set('fullPrice', fullPrice as any);
            }
    
            if (priceDiscount !== undefined) { 
                localVarFormParams.set('priceDiscount', priceDiscount as any);
            }
    
            if (barcode !== undefined) { 
                localVarFormParams.set('barcode', barcode as any);
            }
    
            if (shoppingId !== undefined) { 
                localVarFormParams.set('shoppingId', shoppingId as any);
            }
    
            if (originalUrl !== undefined) { 
                localVarFormParams.set('originalUrl', originalUrl as any);
            }
    
            if (clientId !== undefined) { 
                localVarFormParams.set('clientId', clientId as any);
            }
    
            if (temperatureFrom !== undefined) { 
                localVarFormParams.set('temperatureFrom', temperatureFrom as any);
            }
    
            if (temperatureTo !== undefined) { 
                localVarFormParams.set('temperatureTo', temperatureTo as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns new picture url
         * @param {number} itemId 
         * @param {string} [pictUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointSetItemPictureFromUrl(itemId: number, pictUrl?: string, options: any = {}): RequestArgs {
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling catalogEndpointSetItemPictureFromUrl.');
            }
            const localVarPath = `/catalog/setItemPictureFromUrl/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (pictUrl !== undefined) { 
                localVarFormParams.set('pictUrl', pictUrl as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<string>} [styleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointSetItemStyles(id: number, styleIds?: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling catalogEndpointSetItemStyles.');
            }
            const localVarPath = `/catalog/setItemStyles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (styleIds) {
                localVarQueryParameter['styleIds'] = styleIds;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} itemId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointUploadItemImage(itemId: number, fileName: string, options: any = {}): RequestArgs {
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling catalogEndpointUploadItemImage.');
            }
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling catalogEndpointUploadItemImage.');
            }
            const localVarPath = `/catalog/uploadItemImg/{itemId}/{fileName}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImageByUrl(url?: string, options: any = {}): RequestArgs {
            const localVarPath = `/service/improveImgByUrl`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (url !== undefined) { 
                localVarFormParams.set('url', url as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogApi - functional programming interface
 * @export
 */
export const CatalogApiFp = function(configuration?: Configuration) {
    return {
        /**
         * brandId
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointAddNewBrand(name: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointAddNewBrand(name, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointAddNewSupplier(name: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointAddNewSupplier(name, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointCountItems(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointCountItems(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SearchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointFindItems2(body?: SearchRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResult> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointFindItems2(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetClientCategoryNames(userId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterDTO>> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetClientCategoryNames(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE'} filterType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetFilterNames(filterType: 'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterDTO>> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetFilterNames(filterType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetFilterTypeNames(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetFilterTypeNames(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItem(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogItemFullDTO> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetItem(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItemStyleNamess(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ItemStyleDTO>> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetItemStyleNamess(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItemStyles(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetItemStyles(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItems(offset: number, limit: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogItemShortDTO>> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetItems(offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * str should be 3 and more chars length!
         * @param {string} str 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSearchParameters(str: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterDTO>> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetSearchParameters(str, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSuppliersList(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupplierDTO>> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetSuppliersList(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSuppliersTranslations(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointGetSuppliersTranslations(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} supplier 
         * @param {string} url 
         * @param {number} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointParseItemUrl(supplier: string, url: string, clientId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogItemShortDTO>> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointParseItemUrl(supplier, url, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {string} type 
         * @param {string} brandId 
         * @param {number} categoryId 
         * @param {number} colorId 
         * @param {string} gender 
         * @param {string} supplier 
         * @param {string} size 
         * @param {number} fullPrice 
         * @param {number} [id] 
         * @param {string} [description] 
         * @param {string} [material] 
         * @param {number} [priceDiscount] 
         * @param {string} [barcode] 
         * @param {number} [shoppingId] 
         * @param {string} [originalUrl] 
         * @param {number} [clientId] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointSaveItem(name: string, type: string, brandId: string, categoryId: number, colorId: number, gender: string, supplier: string, size: string, fullPrice: number, id?: number, description?: string, material?: string, priceDiscount?: number, barcode?: string, shoppingId?: number, originalUrl?: string, clientId?: number, temperatureFrom?: string, temperatureTo?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointSaveItem(name, type, brandId, categoryId, colorId, gender, supplier, size, fullPrice, id, description, material, priceDiscount, barcode, shoppingId, originalUrl, clientId, temperatureFrom, temperatureTo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns new picture url
         * @param {number} itemId 
         * @param {string} [pictUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointSetItemPictureFromUrl(itemId: number, pictUrl?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointSetItemPictureFromUrl(itemId, pictUrl, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<string>} [styleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointSetItemStyles(id: number, styleIds?: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointSetItemStyles(id, styleIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} itemId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointUploadItemImage(itemId: number, fileName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).catalogEndpointUploadItemImage(itemId, fileName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImageByUrl(url?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImproveImageDTO> {
            const localVarAxiosArgs = CatalogApiAxiosParamCreator(configuration).serviceEndpointImproveImageByUrl(url, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CatalogApi - factory interface
 * @export
 */
export const CatalogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * brandId
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointAddNewBrand(name: string, options?: any): AxiosPromise<string> {
            return CatalogApiFp(configuration).catalogEndpointAddNewBrand(name, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointAddNewSupplier(name: string, options?: any): AxiosPromise<string> {
            return CatalogApiFp(configuration).catalogEndpointAddNewSupplier(name, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointCountItems(options?: any): AxiosPromise<number> {
            return CatalogApiFp(configuration).catalogEndpointCountItems(options)(axios, basePath);
        },
        /**
         * 
         * @param {SearchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointFindItems2(body?: SearchRequest, options?: any): AxiosPromise<SearchResult> {
            return CatalogApiFp(configuration).catalogEndpointFindItems2(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetClientCategoryNames(userId: number, options?: any): AxiosPromise<Array<FilterDTO>> {
            return CatalogApiFp(configuration).catalogEndpointGetClientCategoryNames(userId, options)(axios, basePath);
        },
        /**
         * 
         * @param {'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE'} filterType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetFilterNames(filterType: 'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE', options?: any): AxiosPromise<Array<FilterDTO>> {
            return CatalogApiFp(configuration).catalogEndpointGetFilterNames(filterType, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetFilterTypeNames(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return CatalogApiFp(configuration).catalogEndpointGetFilterTypeNames(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItem(id: number, options?: any): AxiosPromise<CatalogItemFullDTO> {
            return CatalogApiFp(configuration).catalogEndpointGetItem(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItemStyleNamess(options?: any): AxiosPromise<Array<ItemStyleDTO>> {
            return CatalogApiFp(configuration).catalogEndpointGetItemStyleNamess(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItemStyles(id: number, options?: any): AxiosPromise<Array<string>> {
            return CatalogApiFp(configuration).catalogEndpointGetItemStyles(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetItems(offset: number, limit: number, options?: any): AxiosPromise<Array<CatalogItemShortDTO>> {
            return CatalogApiFp(configuration).catalogEndpointGetItems(offset, limit, options)(axios, basePath);
        },
        /**
         * str should be 3 and more chars length!
         * @param {string} str 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSearchParameters(str: string, options?: any): AxiosPromise<Array<FilterDTO>> {
            return CatalogApiFp(configuration).catalogEndpointGetSearchParameters(str, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSuppliersList(options?: any): AxiosPromise<Array<SupplierDTO>> {
            return CatalogApiFp(configuration).catalogEndpointGetSuppliersList(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointGetSuppliersTranslations(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return CatalogApiFp(configuration).catalogEndpointGetSuppliersTranslations(options)(axios, basePath);
        },
        /**
         * 
         * @param {string} supplier 
         * @param {string} url 
         * @param {number} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointParseItemUrl(supplier: string, url: string, clientId?: number, options?: any): AxiosPromise<Array<CatalogItemShortDTO>> {
            return CatalogApiFp(configuration).catalogEndpointParseItemUrl(supplier, url, clientId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {string} type 
         * @param {string} brandId 
         * @param {number} categoryId 
         * @param {number} colorId 
         * @param {string} gender 
         * @param {string} supplier 
         * @param {string} size 
         * @param {number} fullPrice 
         * @param {number} [id] 
         * @param {string} [description] 
         * @param {string} [material] 
         * @param {number} [priceDiscount] 
         * @param {string} [barcode] 
         * @param {number} [shoppingId] 
         * @param {string} [originalUrl] 
         * @param {number} [clientId] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointSaveItem(name: string, type: string, brandId: string, categoryId: number, colorId: number, gender: string, supplier: string, size: string, fullPrice: number, id?: number, description?: string, material?: string, priceDiscount?: number, barcode?: string, shoppingId?: number, originalUrl?: string, clientId?: number, temperatureFrom?: string, temperatureTo?: string, options?: any): AxiosPromise<number> {
            return CatalogApiFp(configuration).catalogEndpointSaveItem(name, type, brandId, categoryId, colorId, gender, supplier, size, fullPrice, id, description, material, priceDiscount, barcode, shoppingId, originalUrl, clientId, temperatureFrom, temperatureTo, options)(axios, basePath);
        },
        /**
         * returns new picture url
         * @param {number} itemId 
         * @param {string} [pictUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointSetItemPictureFromUrl(itemId: number, pictUrl?: string, options?: any): AxiosPromise<string> {
            return CatalogApiFp(configuration).catalogEndpointSetItemPictureFromUrl(itemId, pictUrl, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<string>} [styleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointSetItemStyles(id: number, styleIds?: Array<string>, options?: any): AxiosPromise<void> {
            return CatalogApiFp(configuration).catalogEndpointSetItemStyles(id, styleIds, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} itemId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogEndpointUploadItemImage(itemId: number, fileName: string, options?: any): AxiosPromise<string> {
            return CatalogApiFp(configuration).catalogEndpointUploadItemImage(itemId, fileName, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImageByUrl(url?: string, options?: any): AxiosPromise<ImproveImageDTO> {
            return CatalogApiFp(configuration).serviceEndpointImproveImageByUrl(url, options)(axios, basePath);
        },
    };
};

/**
 * CatalogApi - object-oriented interface
 * @export
 * @class CatalogApi
 * @extends {BaseAPI}
 */
export class CatalogApi extends BaseAPI {
    /**
     * brandId
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointAddNewBrand(name: string, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointAddNewBrand(name, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointAddNewSupplier(name: string, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointAddNewSupplier(name, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointCountItems(options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointCountItems(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {SearchRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointFindItems2(body?: SearchRequest, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointFindItems2(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetClientCategoryNames(userId: number, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetClientCategoryNames(userId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE'} filterType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetFilterNames(filterType: 'GENDER' | 'CATEGORY' | 'COLOR' | 'SUPPLIER' | 'BRAND' | 'ITEM_NAME' | 'PRICE' | 'SUB_CATEGORY' | 'SIZE', options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetFilterNames(filterType, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetFilterTypeNames(options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetFilterTypeNames(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetItem(id: number, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetItem(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetItemStyleNamess(options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetItemStyleNamess(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetItemStyles(id: number, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetItemStyles(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetItems(offset: number, limit: number, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetItems(offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * str should be 3 and more chars length!
     * @param {string} str 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetSearchParameters(str: string, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetSearchParameters(str, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetSuppliersList(options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetSuppliersList(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointGetSuppliersTranslations(options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointGetSuppliersTranslations(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} supplier 
     * @param {string} url 
     * @param {number} [clientId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointParseItemUrl(supplier: string, url: string, clientId?: number, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointParseItemUrl(supplier, url, clientId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} name 
     * @param {string} type 
     * @param {string} brandId 
     * @param {number} categoryId 
     * @param {number} colorId 
     * @param {string} gender 
     * @param {string} supplier 
     * @param {string} size 
     * @param {number} fullPrice 
     * @param {number} [id] 
     * @param {string} [description] 
     * @param {string} [material] 
     * @param {number} [priceDiscount] 
     * @param {string} [barcode] 
     * @param {number} [shoppingId] 
     * @param {string} [originalUrl] 
     * @param {number} [clientId] 
     * @param {string} [temperatureFrom] 
     * @param {string} [temperatureTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointSaveItem(name: string, type: string, brandId: string, categoryId: number, colorId: number, gender: string, supplier: string, size: string, fullPrice: number, id?: number, description?: string, material?: string, priceDiscount?: number, barcode?: string, shoppingId?: number, originalUrl?: string, clientId?: number, temperatureFrom?: string, temperatureTo?: string, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointSaveItem(name, type, brandId, categoryId, colorId, gender, supplier, size, fullPrice, id, description, material, priceDiscount, barcode, shoppingId, originalUrl, clientId, temperatureFrom, temperatureTo, options)(this.axios, this.basePath);
    }

    /**
     * returns new picture url
     * @param {number} itemId 
     * @param {string} [pictUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointSetItemPictureFromUrl(itemId: number, pictUrl?: string, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointSetItemPictureFromUrl(itemId, pictUrl, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {Array<string>} [styleIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointSetItemStyles(id: number, styleIds?: Array<string>, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointSetItemStyles(id, styleIds, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} itemId 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public catalogEndpointUploadItemImage(itemId: number, fileName: string, options?: any) {
        return CatalogApiFp(this.configuration).catalogEndpointUploadItemImage(itemId, fileName, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} [url] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public serviceEndpointImproveImageByUrl(url?: string, options?: any) {
        return CatalogApiFp(this.configuration).serviceEndpointImproveImageByUrl(url, options)(this.axios, this.basePath);
    }

}


/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatEndpointReceive(options: any = {}): RequestArgs {
            const localVarPath = `/chat`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatEndpointSend(options: any = {}): RequestArgs {
            const localVarPath = `/chat`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<InputPart>} [parts] 
         * @param {string} [preamble] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatEndpointUpload(parts?: Array<InputPart>, preamble?: string, options: any = {}): RequestArgs {
            const localVarPath = `/chat/upload`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (parts) {
            
                localVarFormParams.append('parts', parts.join(COLLECTION_FORMATS.csv));
            }
    
            if (preamble !== undefined) { 
                localVarFormParams.append('preamble', preamble as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatEndpointReceive(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>> {
            const localVarAxiosArgs = ChatApiAxiosParamCreator(configuration).chatEndpointReceive(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatEndpointSend(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ChatApiAxiosParamCreator(configuration).chatEndpointSend(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<InputPart>} [parts] 
         * @param {string} [preamble] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatEndpointUpload(parts?: Array<InputPart>, preamble?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ChatApiAxiosParamCreator(configuration).chatEndpointUpload(parts, preamble, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatEndpointReceive(options?: any): AxiosPromise<Array<object>> {
            return ChatApiFp(configuration).chatEndpointReceive(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatEndpointSend(options?: any): AxiosPromise<string> {
            return ChatApiFp(configuration).chatEndpointSend(options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<InputPart>} [parts] 
         * @param {string} [preamble] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatEndpointUpload(parts?: Array<InputPart>, preamble?: string, options?: any): AxiosPromise<string> {
            return ChatApiFp(configuration).chatEndpointUpload(parts, preamble, options)(axios, basePath);
        },
    };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatEndpointReceive(options?: any) {
        return ChatApiFp(this.configuration).chatEndpointReceive(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatEndpointSend(options?: any) {
        return ChatApiFp(this.configuration).chatEndpointSend(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<InputPart>} [parts] 
     * @param {string} [preamble] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatEndpointUpload(parts?: Array<InputPart>, preamble?: string, options?: any) {
        return ChatApiFp(this.configuration).chatEndpointUpload(parts, preamble, options)(this.axios, this.basePath);
    }

}


/**
 * ClientsApi - axios parameter creator
 * @export
 */
export const ClientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointChangeSubscriptionStatus(subscriptionId: number, status: 'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED', options: any = {}): RequestArgs {
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new RequiredError('subscriptionId','Required parameter subscriptionId was null or undefined when calling clientEndpointChangeSubscriptionStatus.');
            }
            // verify required parameter 'status' is not null or undefined
            if (status === null || status === undefined) {
                throw new RequiredError('status','Required parameter status was null or undefined when calling clientEndpointChangeSubscriptionStatus.');
            }
            const localVarPath = `/clients/changeSubscriptionStatus/{subscriptionId}/{status}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} productId 
         * @param {number} [price] 
         * @param {number} [finishAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointCreateClientSubscription(userId: number, productId: number, price?: number, finishAt?: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling clientEndpointCreateClientSubscription.');
            }
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling clientEndpointCreateClientSubscription.');
            }
            const localVarPath = `/clients/createClientSubscription`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (userId !== undefined) { 
                localVarFormParams.set('userId', userId as any);
            }
    
            if (productId !== undefined) { 
                localVarFormParams.set('productId', productId as any);
            }
    
            if (price !== undefined) { 
                localVarFormParams.set('price', price as any);
            }
    
            if (finishAt !== undefined) { 
                localVarFormParams.set('finishAt', finishAt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} categoryName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointCreateCustomLookCategory(clientId: number, categoryName: string, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling clientEndpointCreateCustomLookCategory.');
            }
            // verify required parameter 'categoryName' is not null or undefined
            if (categoryName === null || categoryName === undefined) {
                throw new RequiredError('categoryName','Required parameter categoryName was null or undefined when calling clientEndpointCreateCustomLookCategory.');
            }
            const localVarPath = `/clients/createCustomLookCategory/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (categoryName !== undefined) { 
                localVarFormParams.set('categoryName', categoryName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClientInfo(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling clientEndpointGetClientInfo.');
            }
            const localVarPath = `/clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClientSubscription(userId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling clientEndpointGetClientSubscription.');
            }
            const localVarPath = `/clients/getClientSubscription/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetClientsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClients(body?: GetClientsRequest, options: any = {}): RequestArgs {
            const localVarPath = `/clients`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetLookCategories(clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling clientEndpointGetLookCategories.');
            }
            const localVarPath = `/clients/lookCategories/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetProducts(options: any = {}): RequestArgs {
            const localVarPath = `/clients/getProducts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointRemoveCustomLookCategory(clientId: number, categoryId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling clientEndpointRemoveCustomLookCategory.');
            }
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling clientEndpointRemoveCustomLookCategory.');
            }
            const localVarPath = `/clients/removeCustomLookCategory/{clientId}/{categoryId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * saves the client info
         * @param {ClientInfoDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointSaveClientInfo(body?: ClientInfoDTO, options: any = {}): RequestArgs {
            const localVarPath = `/clients/saveClientInfo`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * gets possible client statuses with translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointStatusList(options: any = {}): RequestArgs {
            const localVarPath = `/clients/statusList`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientsApi - functional programming interface
 * @export
 */
export const ClientsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointChangeSubscriptionStatus(subscriptionId: number, status: 'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointChangeSubscriptionStatus(subscriptionId, status, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} productId 
         * @param {number} [price] 
         * @param {number} [finishAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointCreateClientSubscription(userId: number, productId: number, price?: number, finishAt?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointCreateClientSubscription(userId, productId, price, finishAt, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} categoryName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointCreateCustomLookCategory(clientId: number, categoryName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointCreateCustomLookCategory(clientId, categoryName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClientInfo(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientInfoDTO> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointGetClientInfo(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClientSubscription(userId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientSubscriptionDTO>> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointGetClientSubscription(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {GetClientsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClients(body?: GetClientsRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListClientsResponse> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointGetClients(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetLookCategories(clientId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LookCategoryTranslation>> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointGetLookCategories(clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetProducts(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDTO>> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointGetProducts(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointRemoveCustomLookCategory(clientId: number, categoryId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointRemoveCustomLookCategory(clientId, categoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * saves the client info
         * @param {ClientInfoDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointSaveClientInfo(body?: ClientInfoDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointSaveClientInfo(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * gets possible client statuses with translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointStatusList(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }> {
            const localVarAxiosArgs = ClientsApiAxiosParamCreator(configuration).clientEndpointStatusList(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientsApi - factory interface
 * @export
 */
export const ClientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointChangeSubscriptionStatus(subscriptionId: number, status: 'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED', options?: any): AxiosPromise<void> {
            return ClientsApiFp(configuration).clientEndpointChangeSubscriptionStatus(subscriptionId, status, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} productId 
         * @param {number} [price] 
         * @param {number} [finishAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointCreateClientSubscription(userId: number, productId: number, price?: number, finishAt?: number, options?: any): AxiosPromise<number> {
            return ClientsApiFp(configuration).clientEndpointCreateClientSubscription(userId, productId, price, finishAt, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} categoryName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointCreateCustomLookCategory(clientId: number, categoryName: string, options?: any): AxiosPromise<number> {
            return ClientsApiFp(configuration).clientEndpointCreateCustomLookCategory(clientId, categoryName, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClientInfo(id: number, options?: any): AxiosPromise<ClientInfoDTO> {
            return ClientsApiFp(configuration).clientEndpointGetClientInfo(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClientSubscription(userId: number, options?: any): AxiosPromise<Array<ClientSubscriptionDTO>> {
            return ClientsApiFp(configuration).clientEndpointGetClientSubscription(userId, options)(axios, basePath);
        },
        /**
         * 
         * @param {GetClientsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClients(body?: GetClientsRequest, options?: any): AxiosPromise<ListClientsResponse> {
            return ClientsApiFp(configuration).clientEndpointGetClients(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetLookCategories(clientId: number, options?: any): AxiosPromise<Array<LookCategoryTranslation>> {
            return ClientsApiFp(configuration).clientEndpointGetLookCategories(clientId, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetProducts(options?: any): AxiosPromise<Array<ProductDTO>> {
            return ClientsApiFp(configuration).clientEndpointGetProducts(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointRemoveCustomLookCategory(clientId: number, categoryId: number, options?: any): AxiosPromise<void> {
            return ClientsApiFp(configuration).clientEndpointRemoveCustomLookCategory(clientId, categoryId, options)(axios, basePath);
        },
        /**
         * saves the client info
         * @param {ClientInfoDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointSaveClientInfo(body?: ClientInfoDTO, options?: any): AxiosPromise<number> {
            return ClientsApiFp(configuration).clientEndpointSaveClientInfo(body, options)(axios, basePath);
        },
        /**
         * gets possible client statuses with translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointStatusList(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return ClientsApiFp(configuration).clientEndpointStatusList(options)(axios, basePath);
        },
    };
};

/**
 * ClientsApi - object-oriented interface
 * @export
 * @class ClientsApi
 * @extends {BaseAPI}
 */
export class ClientsApi extends BaseAPI {
    /**
     * 
     * @param {number} subscriptionId 
     * @param {'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED'} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointChangeSubscriptionStatus(subscriptionId: number, status: 'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED', options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointChangeSubscriptionStatus(subscriptionId, status, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {number} productId 
     * @param {number} [price] 
     * @param {number} [finishAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointCreateClientSubscription(userId: number, productId: number, price?: number, finishAt?: number, options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointCreateClientSubscription(userId, productId, price, finishAt, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {string} categoryName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointCreateCustomLookCategory(clientId: number, categoryName: string, options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointCreateCustomLookCategory(clientId, categoryName, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointGetClientInfo(id: number, options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointGetClientInfo(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointGetClientSubscription(userId: number, options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointGetClientSubscription(userId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {GetClientsRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointGetClients(body?: GetClientsRequest, options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointGetClients(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointGetLookCategories(clientId: number, options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointGetLookCategories(clientId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointGetProducts(options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointGetProducts(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {number} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointRemoveCustomLookCategory(clientId: number, categoryId: number, options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointRemoveCustomLookCategory(clientId, categoryId, options)(this.axios, this.basePath);
    }

    /**
     * saves the client info
     * @param {ClientInfoDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointSaveClientInfo(body?: ClientInfoDTO, options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointSaveClientInfo(body, options)(this.axios, this.basePath);
    }

    /**
     * gets possible client statuses with translation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public clientEndpointStatusList(options?: any) {
        return ClientsApiFp(this.configuration).clientEndpointStatusList(options)(this.axios, this.basePath);
    }

}


/**
 * CommentsApi - axios parameter creator
 * @export
 */
export const CommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} shoppingItemId 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentEndpointCommentShoppingItem(shoppingItemId: number, comment: string, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingItemId' is not null or undefined
            if (shoppingItemId === null || shoppingItemId === undefined) {
                throw new RequiredError('shoppingItemId','Required parameter shoppingItemId was null or undefined when calling commentEndpointCommentShoppingItem.');
            }
            // verify required parameter 'comment' is not null or undefined
            if (comment === null || comment === undefined) {
                throw new RequiredError('comment','Required parameter comment was null or undefined when calling commentEndpointCommentShoppingItem.');
            }
            const localVarPath = `/comments/commentShoppingItem`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (shoppingItemId !== undefined) { 
                localVarFormParams.set('shoppingItemId', shoppingItemId as any);
            }
    
            if (comment !== undefined) { 
                localVarFormParams.set('comment', comment as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} shoppingItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentEndpointGetShoppingItemComments(shoppingItemId: number, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingItemId' is not null or undefined
            if (shoppingItemId === null || shoppingItemId === undefined) {
                throw new RequiredError('shoppingItemId','Required parameter shoppingItemId was null or undefined when calling commentEndpointGetShoppingItemComments.');
            }
            const localVarPath = `/comments/getShoppingItemComments/{shoppingItemId}`
                .replace(`{${"shoppingItemId"}}`, encodeURIComponent(String(shoppingItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentsApi - functional programming interface
 * @export
 */
export const CommentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} shoppingItemId 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentEndpointCommentShoppingItem(shoppingItemId: number, comment: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CommentsApiAxiosParamCreator(configuration).commentEndpointCommentShoppingItem(shoppingItemId, comment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} shoppingItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentEndpointGetShoppingItemComments(shoppingItemId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommentDTO>> {
            const localVarAxiosArgs = CommentsApiAxiosParamCreator(configuration).commentEndpointGetShoppingItemComments(shoppingItemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CommentsApi - factory interface
 * @export
 */
export const CommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} shoppingItemId 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentEndpointCommentShoppingItem(shoppingItemId: number, comment: string, options?: any): AxiosPromise<number> {
            return CommentsApiFp(configuration).commentEndpointCommentShoppingItem(shoppingItemId, comment, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} shoppingItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentEndpointGetShoppingItemComments(shoppingItemId: number, options?: any): AxiosPromise<Array<CommentDTO>> {
            return CommentsApiFp(configuration).commentEndpointGetShoppingItemComments(shoppingItemId, options)(axios, basePath);
        },
    };
};

/**
 * CommentsApi - object-oriented interface
 * @export
 * @class CommentsApi
 * @extends {BaseAPI}
 */
export class CommentsApi extends BaseAPI {
    /**
     * 
     * @param {number} shoppingItemId 
     * @param {string} comment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentEndpointCommentShoppingItem(shoppingItemId: number, comment: string, options?: any) {
        return CommentsApiFp(this.configuration).commentEndpointCommentShoppingItem(shoppingItemId, comment, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} shoppingItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentEndpointGetShoppingItemComments(shoppingItemId: number, options?: any) {
        return CommentsApiFp(this.configuration).commentEndpointGetShoppingItemComments(shoppingItemId, options)(this.axios, this.basePath);
    }

}


/**
 * CommonApi - axios parameter creator
 * @export
 */
export const CommonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonEndpointGetStylists(options: any = {}): RequestArgs {
            const localVarPath = `/admin/stylists`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonApi - functional programming interface
 * @export
 */
export const CommonApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonEndpointGetStylists(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDTO>> {
            const localVarAxiosArgs = CommonApiAxiosParamCreator(configuration).commonEndpointGetStylists(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CommonApi - factory interface
 * @export
 */
export const CommonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonEndpointGetStylists(options?: any): AxiosPromise<Array<UserDTO>> {
            return CommonApiFp(configuration).commonEndpointGetStylists(options)(axios, basePath);
        },
    };
};

/**
 * CommonApi - object-oriented interface
 * @export
 * @class CommonApi
 * @extends {BaseAPI}
 */
export class CommonApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public commonEndpointGetStylists(options?: any) {
        return CommonApiFp(this.configuration).commonEndpointGetStylists(options)(this.axios, this.basePath);
    }

}


/**
 * CompilationsApi - axios parameter creator
 * @export
 */
export const CompilationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} compilationId 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddAiLook(compilationId: number, lookId: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationId' is not null or undefined
            if (compilationId === null || compilationId === undefined) {
                throw new RequiredError('compilationId','Required parameter compilationId was null or undefined when calling compilationEndpointAddAiLook.');
            }
            // verify required parameter 'lookId' is not null or undefined
            if (lookId === null || lookId === undefined) {
                throw new RequiredError('lookId','Required parameter lookId was null or undefined when calling compilationEndpointAddAiLook.');
            }
            const localVarPath = `/compilation/addAiLook/{compilationId}/{lookId}`
                .replace(`{${"compilationId"}}`, encodeURIComponent(String(compilationId)))
                .replace(`{${"lookId"}}`, encodeURIComponent(String(lookId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {number} compilationThingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddCompilationThingToLook(compilationLookId: number, compilationThingId: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationLookId' is not null or undefined
            if (compilationLookId === null || compilationLookId === undefined) {
                throw new RequiredError('compilationLookId','Required parameter compilationLookId was null or undefined when calling compilationEndpointAddCompilationThingToLook.');
            }
            // verify required parameter 'compilationThingId' is not null or undefined
            if (compilationThingId === null || compilationThingId === undefined) {
                throw new RequiredError('compilationThingId','Required parameter compilationThingId was null or undefined when calling compilationEndpointAddCompilationThingToLook.');
            }
            const localVarPath = `/compilation/addCompilationThingToLook/{compilationLookId}/{compilationThingId}`
                .replace(`{${"compilationLookId"}}`, encodeURIComponent(String(compilationLookId)))
                .replace(`{${"compilationThingId"}}`, encodeURIComponent(String(compilationThingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {string} stylistComment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddStylistComment(compilationId: number, stylistComment: string, options: any = {}): RequestArgs {
            // verify required parameter 'compilationId' is not null or undefined
            if (compilationId === null || compilationId === undefined) {
                throw new RequiredError('compilationId','Required parameter compilationId was null or undefined when calling compilationEndpointAddStylistComment.');
            }
            // verify required parameter 'stylistComment' is not null or undefined
            if (stylistComment === null || stylistComment === undefined) {
                throw new RequiredError('stylistComment','Required parameter stylistComment was null or undefined when calling compilationEndpointAddStylistComment.');
            }
            const localVarPath = `/compilation/addStylistComment/{compilationId}`
                .replace(`{${"compilationId"}}`, encodeURIComponent(String(compilationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (stylistComment !== undefined) { 
                localVarFormParams.set('stylistComment', stylistComment as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {number} [catalogThingId] 
         * @param {number} [clientThingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddThing(compilationLookId: number, catalogThingId?: number, clientThingId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationLookId' is not null or undefined
            if (compilationLookId === null || compilationLookId === undefined) {
                throw new RequiredError('compilationLookId','Required parameter compilationLookId was null or undefined when calling compilationEndpointAddThing.');
            }
            const localVarPath = `/compilation/addThing/{compilationLookId}`
                .replace(`{${"compilationLookId"}}`, encodeURIComponent(String(compilationLookId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (catalogThingId !== undefined) {
                localVarQueryParameter['catalogThingId'] = catalogThingId;
            }

            if (clientThingId !== undefined) {
                localVarQueryParameter['clientThingId'] = clientThingId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} [catalogThingId] 
         * @param {number} [clientThingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddThingToCompilation(compilationId: number, catalogThingId?: number, clientThingId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationId' is not null or undefined
            if (compilationId === null || compilationId === undefined) {
                throw new RequiredError('compilationId','Required parameter compilationId was null or undefined when calling compilationEndpointAddThingToCompilation.');
            }
            const localVarPath = `/compilation/addThingToCompilation/{compilationId}`
                .replace(`{${"compilationId"}}`, encodeURIComponent(String(compilationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (catalogThingId !== undefined) {
                localVarQueryParameter['catalogThingId'] = catalogThingId;
            }

            if (clientThingId !== undefined) {
                localVarQueryParameter['clientThingId'] = clientThingId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} stylistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAssignStylist(compilationId: number, stylistId: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationId' is not null or undefined
            if (compilationId === null || compilationId === undefined) {
                throw new RequiredError('compilationId','Required parameter compilationId was null or undefined when calling compilationEndpointAssignStylist.');
            }
            // verify required parameter 'stylistId' is not null or undefined
            if (stylistId === null || stylistId === undefined) {
                throw new RequiredError('stylistId','Required parameter stylistId was null or undefined when calling compilationEndpointAssignStylist.');
            }
            const localVarPath = `/compilation/assignStylist/{compilationId}/{stylistId}`
                .replace(`{${"compilationId"}}`, encodeURIComponent(String(compilationId)))
                .replace(`{${"stylistId"}}`, encodeURIComponent(String(stylistId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointClientForm(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling compilationEndpointClientForm.');
            }
            const localVarPath = `/compilation/compilationForm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointClientFormNew(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling compilationEndpointClientFormNew.');
            }
            const localVarPath = `/compilation/compilationFormNew/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointCopyLook(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling compilationEndpointCopyLook.');
            }
            const localVarPath = `/compilation/copyLook/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointDeleteLook(compilationLookId: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationLookId' is not null or undefined
            if (compilationLookId === null || compilationLookId === undefined) {
                throw new RequiredError('compilationLookId','Required parameter compilationLookId was null or undefined when calling compilationEndpointDeleteLook.');
            }
            const localVarPath = `/compilation/deleteLook/{compilationLookId}`
                .replace(`{${"compilationLookId"}}`, encodeURIComponent(String(compilationLookId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationThingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointDeleteThing(compilationThingId: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationThingId' is not null or undefined
            if (compilationThingId === null || compilationThingId === undefined) {
                throw new RequiredError('compilationThingId','Required parameter compilationThingId was null or undefined when calling compilationEndpointDeleteThing.');
            }
            const localVarPath = `/compilation/deleteThing/{compilationThingId}`
                .replace(`{${"compilationThingId"}}`, encodeURIComponent(String(compilationThingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointGetOrder(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling compilationEndpointGetOrder.');
            }
            const localVarPath = `/compilation/order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>} [orderStatus] 
         * @param {'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST'} [sortBy] 
         * @param {number} [clientId] 
         * @param {number} [stylistId] 
         * @param {number} [offset] 
         * @param {number} [length] 
         * @param {'DESC' | 'ASC'} [sortOrder] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointGetOrders(orderStatus?: Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>, sortBy?: 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST', clientId?: number, stylistId?: number, offset?: number, length?: number, sortOrder?: 'DESC' | 'ASC', searchStr?: string, options: any = {}): RequestArgs {
            const localVarPath = `/compilation/getOrders`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (orderStatus) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (stylistId !== undefined) {
                localVarQueryParameter['stylistId'] = stylistId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (length !== undefined) {
                localVarQueryParameter['length'] = length;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = searchStr;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} deadlineMillis 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointOrderDeadline(compilationId: number, deadlineMillis: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationId' is not null or undefined
            if (compilationId === null || compilationId === undefined) {
                throw new RequiredError('compilationId','Required parameter compilationId was null or undefined when calling compilationEndpointOrderDeadline.');
            }
            // verify required parameter 'deadlineMillis' is not null or undefined
            if (deadlineMillis === null || deadlineMillis === undefined) {
                throw new RequiredError('deadlineMillis','Required parameter deadlineMillis was null or undefined when calling compilationEndpointOrderDeadline.');
            }
            const localVarPath = `/compilation/orderDeadline/{compilationId}/{deadlineMillis}`
                .replace(`{${"compilationId"}}`, encodeURIComponent(String(compilationId)))
                .replace(`{${"deadlineMillis"}}`, encodeURIComponent(String(deadlineMillis)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {'NEW' | 'IN_PROGRESS' | 'FINISHED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointOrderStatus(compilationId: number, status: 'NEW' | 'IN_PROGRESS' | 'FINISHED', options: any = {}): RequestArgs {
            // verify required parameter 'compilationId' is not null or undefined
            if (compilationId === null || compilationId === undefined) {
                throw new RequiredError('compilationId','Required parameter compilationId was null or undefined when calling compilationEndpointOrderStatus.');
            }
            // verify required parameter 'status' is not null or undefined
            if (status === null || status === undefined) {
                throw new RequiredError('status','Required parameter status was null or undefined when calling compilationEndpointOrderStatus.');
            }
            const localVarPath = `/compilation/orderStatus/{compilationId}/{status}`
                .replace(`{${"compilationId"}}`, encodeURIComponent(String(compilationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>} [orderStatus] 
         * @param {'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST'} [sortBy] 
         * @param {number} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointOrders(orderStatus?: Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>, sortBy?: 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST', clientId?: number, options: any = {}): RequestArgs {
            const localVarPath = `/compilation/orders`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (orderStatus) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} url 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointParseItemUrl(url: string, options: any = {}): RequestArgs {
            // verify required parameter 'url' is not null or undefined
            if (url === null || url === undefined) {
                throw new RequiredError('url','Required parameter url was null or undefined when calling compilationEndpointParseItemUrl.');
            }
            const localVarPath = `/compilation/parseItemUrl`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (url !== undefined) { 
                localVarFormParams.set('url', url as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {number} thingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointRemoveThingFromLook(compilationLookId: number, thingId: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationLookId' is not null or undefined
            if (compilationLookId === null || compilationLookId === undefined) {
                throw new RequiredError('compilationLookId','Required parameter compilationLookId was null or undefined when calling compilationEndpointRemoveThingFromLook.');
            }
            // verify required parameter 'thingId' is not null or undefined
            if (thingId === null || thingId === undefined) {
                throw new RequiredError('thingId','Required parameter thingId was null or undefined when calling compilationEndpointRemoveThingFromLook.');
            }
            const localVarPath = `/compilation/removeThingFromLook/{compilationLookId}/{thingId}`
                .replace(`{${"compilationLookId"}}`, encodeURIComponent(String(compilationLookId)))
                .replace(`{${"thingId"}}`, encodeURIComponent(String(thingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} [lookId] 
         * @param {number} [temperatureFrom] 
         * @param {number} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointSaveLook(compilationId: number, lookId?: number, temperatureFrom?: number, temperatureTo?: number, options: any = {}): RequestArgs {
            // verify required parameter 'compilationId' is not null or undefined
            if (compilationId === null || compilationId === undefined) {
                throw new RequiredError('compilationId','Required parameter compilationId was null or undefined when calling compilationEndpointSaveLook.');
            }
            const localVarPath = `/compilation/saveLook/{compilationId}`
                .replace(`{${"compilationId"}}`, encodeURIComponent(String(compilationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (lookId !== undefined) {
                localVarQueryParameter['lookId'] = lookId;
            }

            if (temperatureFrom !== undefined) {
                localVarQueryParameter['temperatureFrom'] = temperatureFrom;
            }

            if (temperatureTo !== undefined) {
                localVarQueryParameter['temperatureTo'] = temperatureTo;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {number} [compilationId] 
         * @param {string} [thingUrl] 
         * @param {string} [type] 
         * @param {string} [name] 
         * @param {string} [brandId] 
         * @param {string} [supplierId] 
         * @param {number} [colorId] 
         * @param {string} [size] 
         * @param {number} [price] 
         * @param {number} [priceDiscount] 
         * @param {number} [categoryId] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {string} [imageUrl] 
         * @param {string} [fileName] 
         * @param {object} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointUploadThing(id?: number, compilationId?: number, thingUrl?: string, type?: string, name?: string, brandId?: string, supplierId?: string, colorId?: number, size?: string, price?: number, priceDiscount?: number, categoryId?: number, temperatureFrom?: string, temperatureTo?: string, imageUrl?: string, fileName?: string, file?: object, options: any = {}): RequestArgs {
            const localVarPath = `/compilation/uploadThing`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (id !== undefined) { 
                localVarFormParams.append('id', id as any);
            }
    
            if (compilationId !== undefined) { 
                localVarFormParams.append('compilationId', compilationId as any);
            }
    
            if (thingUrl !== undefined) { 
                localVarFormParams.append('thingUrl', thingUrl as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (brandId !== undefined) { 
                localVarFormParams.append('brandId', brandId as any);
            }
    
            if (supplierId !== undefined) { 
                localVarFormParams.append('supplierId', supplierId as any);
            }
    
            if (colorId !== undefined) { 
                localVarFormParams.append('colorId', colorId as any);
            }
    
            if (size !== undefined) { 
                localVarFormParams.append('size', size as any);
            }
    
            if (price !== undefined) { 
                localVarFormParams.append('price', price as any);
            }
    
            if (priceDiscount !== undefined) { 
                localVarFormParams.append('priceDiscount', priceDiscount as any);
            }
    
            if (categoryId !== undefined) { 
                localVarFormParams.append('categoryId', categoryId as any);
            }
    
            if (temperatureFrom !== undefined) { 
                localVarFormParams.append('temperatureFrom', temperatureFrom as any);
            }
    
            if (temperatureTo !== undefined) { 
                localVarFormParams.append('temperatureTo', temperatureTo as any);
            }
    
            if (imageUrl !== undefined) { 
                localVarFormParams.append('imageUrl', imageUrl as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('fileName', fileName as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompilationsApi - functional programming interface
 * @export
 */
export const CompilationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} compilationId 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddAiLook(compilationId: number, lookId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointAddAiLook(compilationId, lookId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {number} compilationThingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddCompilationThingToLook(compilationLookId: number, compilationThingId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointAddCompilationThingToLook(compilationLookId, compilationThingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {string} stylistComment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddStylistComment(compilationId: number, stylistComment: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationFullDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointAddStylistComment(compilationId, stylistComment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {number} [catalogThingId] 
         * @param {number} [clientThingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddThing(compilationLookId: number, catalogThingId?: number, clientThingId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationThingDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointAddThing(compilationLookId, catalogThingId, clientThingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} [catalogThingId] 
         * @param {number} [clientThingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddThingToCompilation(compilationId: number, catalogThingId?: number, clientThingId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationThingDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointAddThingToCompilation(compilationId, catalogThingId, clientThingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} stylistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAssignStylist(compilationId: number, stylistId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationFullDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointAssignStylist(compilationId, stylistId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointClientForm(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointClientForm(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointClientFormNew(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientStyleFormDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointClientFormNew(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointCopyLook(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationLookDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointCopyLook(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointDeleteLook(compilationLookId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointDeleteLook(compilationLookId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationThingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointDeleteThing(compilationThingId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointDeleteThing(compilationThingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointGetOrder(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationFullDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointGetOrder(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>} [orderStatus] 
         * @param {'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST'} [sortBy] 
         * @param {number} [clientId] 
         * @param {number} [stylistId] 
         * @param {number} [offset] 
         * @param {number} [length] 
         * @param {'DESC' | 'ASC'} [sortOrder] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointGetOrders(orderStatus?: Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>, sortBy?: 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST', clientId?: number, stylistId?: number, offset?: number, length?: number, sortOrder?: 'DESC' | 'ASC', searchStr?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationsDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointGetOrders(orderStatus, sortBy, clientId, stylistId, offset, length, sortOrder, searchStr, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} deadlineMillis 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointOrderDeadline(compilationId: number, deadlineMillis: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationFullDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointOrderDeadline(compilationId, deadlineMillis, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {'NEW' | 'IN_PROGRESS' | 'FINISHED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointOrderStatus(compilationId: number, status: 'NEW' | 'IN_PROGRESS' | 'FINISHED', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationFullDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointOrderStatus(compilationId, status, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>} [orderStatus] 
         * @param {'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST'} [sortBy] 
         * @param {number} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointOrders(orderStatus?: Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>, sortBy?: 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST', clientId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompilationFullDTO>> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointOrders(orderStatus, sortBy, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} url 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointParseItemUrl(url: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogItemShortDTO>> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointParseItemUrl(url, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {number} thingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointRemoveThingFromLook(compilationLookId: number, thingId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointRemoveThingFromLook(compilationLookId, thingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} [lookId] 
         * @param {number} [temperatureFrom] 
         * @param {number} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointSaveLook(compilationId: number, lookId?: number, temperatureFrom?: number, temperatureTo?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointSaveLook(compilationId, lookId, temperatureFrom, temperatureTo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {number} [compilationId] 
         * @param {string} [thingUrl] 
         * @param {string} [type] 
         * @param {string} [name] 
         * @param {string} [brandId] 
         * @param {string} [supplierId] 
         * @param {number} [colorId] 
         * @param {string} [size] 
         * @param {number} [price] 
         * @param {number} [priceDiscount] 
         * @param {number} [categoryId] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {string} [imageUrl] 
         * @param {string} [fileName] 
         * @param {object} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointUploadThing(id?: number, compilationId?: number, thingUrl?: string, type?: string, name?: string, brandId?: string, supplierId?: string, colorId?: number, size?: string, price?: number, priceDiscount?: number, categoryId?: number, temperatureFrom?: string, temperatureTo?: string, imageUrl?: string, fileName?: string, file?: object, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompilationThingDTO> {
            const localVarAxiosArgs = CompilationsApiAxiosParamCreator(configuration).compilationEndpointUploadThing(id, compilationId, thingUrl, type, name, brandId, supplierId, colorId, size, price, priceDiscount, categoryId, temperatureFrom, temperatureTo, imageUrl, fileName, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CompilationsApi - factory interface
 * @export
 */
export const CompilationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} compilationId 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddAiLook(compilationId: number, lookId: number, options?: any): AxiosPromise<number> {
            return CompilationsApiFp(configuration).compilationEndpointAddAiLook(compilationId, lookId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {number} compilationThingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddCompilationThingToLook(compilationLookId: number, compilationThingId: number, options?: any): AxiosPromise<void> {
            return CompilationsApiFp(configuration).compilationEndpointAddCompilationThingToLook(compilationLookId, compilationThingId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {string} stylistComment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddStylistComment(compilationId: number, stylistComment: string, options?: any): AxiosPromise<CompilationFullDTO> {
            return CompilationsApiFp(configuration).compilationEndpointAddStylistComment(compilationId, stylistComment, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {number} [catalogThingId] 
         * @param {number} [clientThingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddThing(compilationLookId: number, catalogThingId?: number, clientThingId?: number, options?: any): AxiosPromise<CompilationThingDTO> {
            return CompilationsApiFp(configuration).compilationEndpointAddThing(compilationLookId, catalogThingId, clientThingId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} [catalogThingId] 
         * @param {number} [clientThingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAddThingToCompilation(compilationId: number, catalogThingId?: number, clientThingId?: number, options?: any): AxiosPromise<CompilationThingDTO> {
            return CompilationsApiFp(configuration).compilationEndpointAddThingToCompilation(compilationId, catalogThingId, clientThingId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} stylistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointAssignStylist(compilationId: number, stylistId: number, options?: any): AxiosPromise<CompilationFullDTO> {
            return CompilationsApiFp(configuration).compilationEndpointAssignStylist(compilationId, stylistId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointClientForm(id: number, options?: any): AxiosPromise<string> {
            return CompilationsApiFp(configuration).compilationEndpointClientForm(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointClientFormNew(id: number, options?: any): AxiosPromise<ClientStyleFormDTO> {
            return CompilationsApiFp(configuration).compilationEndpointClientFormNew(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointCopyLook(id: number, options?: any): AxiosPromise<CompilationLookDTO> {
            return CompilationsApiFp(configuration).compilationEndpointCopyLook(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointDeleteLook(compilationLookId: number, options?: any): AxiosPromise<number> {
            return CompilationsApiFp(configuration).compilationEndpointDeleteLook(compilationLookId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationThingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointDeleteThing(compilationThingId: number, options?: any): AxiosPromise<number> {
            return CompilationsApiFp(configuration).compilationEndpointDeleteThing(compilationThingId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointGetOrder(id: number, options?: any): AxiosPromise<CompilationFullDTO> {
            return CompilationsApiFp(configuration).compilationEndpointGetOrder(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>} [orderStatus] 
         * @param {'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST'} [sortBy] 
         * @param {number} [clientId] 
         * @param {number} [stylistId] 
         * @param {number} [offset] 
         * @param {number} [length] 
         * @param {'DESC' | 'ASC'} [sortOrder] 
         * @param {string} [searchStr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointGetOrders(orderStatus?: Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>, sortBy?: 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST', clientId?: number, stylistId?: number, offset?: number, length?: number, sortOrder?: 'DESC' | 'ASC', searchStr?: string, options?: any): AxiosPromise<CompilationsDTO> {
            return CompilationsApiFp(configuration).compilationEndpointGetOrders(orderStatus, sortBy, clientId, stylistId, offset, length, sortOrder, searchStr, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} deadlineMillis 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointOrderDeadline(compilationId: number, deadlineMillis: number, options?: any): AxiosPromise<CompilationFullDTO> {
            return CompilationsApiFp(configuration).compilationEndpointOrderDeadline(compilationId, deadlineMillis, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {'NEW' | 'IN_PROGRESS' | 'FINISHED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointOrderStatus(compilationId: number, status: 'NEW' | 'IN_PROGRESS' | 'FINISHED', options?: any): AxiosPromise<CompilationFullDTO> {
            return CompilationsApiFp(configuration).compilationEndpointOrderStatus(compilationId, status, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>} [orderStatus] 
         * @param {'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST'} [sortBy] 
         * @param {number} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointOrders(orderStatus?: Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>, sortBy?: 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST', clientId?: number, options?: any): AxiosPromise<Array<CompilationFullDTO>> {
            return CompilationsApiFp(configuration).compilationEndpointOrders(orderStatus, sortBy, clientId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} url 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointParseItemUrl(url: string, options?: any): AxiosPromise<Array<CatalogItemShortDTO>> {
            return CompilationsApiFp(configuration).compilationEndpointParseItemUrl(url, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationLookId 
         * @param {number} thingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointRemoveThingFromLook(compilationLookId: number, thingId: number, options?: any): AxiosPromise<number> {
            return CompilationsApiFp(configuration).compilationEndpointRemoveThingFromLook(compilationLookId, thingId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} compilationId 
         * @param {number} [lookId] 
         * @param {number} [temperatureFrom] 
         * @param {number} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointSaveLook(compilationId: number, lookId?: number, temperatureFrom?: number, temperatureTo?: number, options?: any): AxiosPromise<number> {
            return CompilationsApiFp(configuration).compilationEndpointSaveLook(compilationId, lookId, temperatureFrom, temperatureTo, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {number} [compilationId] 
         * @param {string} [thingUrl] 
         * @param {string} [type] 
         * @param {string} [name] 
         * @param {string} [brandId] 
         * @param {string} [supplierId] 
         * @param {number} [colorId] 
         * @param {string} [size] 
         * @param {number} [price] 
         * @param {number} [priceDiscount] 
         * @param {number} [categoryId] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {string} [imageUrl] 
         * @param {string} [fileName] 
         * @param {object} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compilationEndpointUploadThing(id?: number, compilationId?: number, thingUrl?: string, type?: string, name?: string, brandId?: string, supplierId?: string, colorId?: number, size?: string, price?: number, priceDiscount?: number, categoryId?: number, temperatureFrom?: string, temperatureTo?: string, imageUrl?: string, fileName?: string, file?: object, options?: any): AxiosPromise<CompilationThingDTO> {
            return CompilationsApiFp(configuration).compilationEndpointUploadThing(id, compilationId, thingUrl, type, name, brandId, supplierId, colorId, size, price, priceDiscount, categoryId, temperatureFrom, temperatureTo, imageUrl, fileName, file, options)(axios, basePath);
        },
    };
};

/**
 * CompilationsApi - object-oriented interface
 * @export
 * @class CompilationsApi
 * @extends {BaseAPI}
 */
export class CompilationsApi extends BaseAPI {
    /**
     * 
     * @param {number} compilationId 
     * @param {number} lookId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointAddAiLook(compilationId: number, lookId: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointAddAiLook(compilationId, lookId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationLookId 
     * @param {number} compilationThingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointAddCompilationThingToLook(compilationLookId: number, compilationThingId: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointAddCompilationThingToLook(compilationLookId, compilationThingId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationId 
     * @param {string} stylistComment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointAddStylistComment(compilationId: number, stylistComment: string, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointAddStylistComment(compilationId, stylistComment, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationLookId 
     * @param {number} [catalogThingId] 
     * @param {number} [clientThingId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointAddThing(compilationLookId: number, catalogThingId?: number, clientThingId?: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointAddThing(compilationLookId, catalogThingId, clientThingId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationId 
     * @param {number} [catalogThingId] 
     * @param {number} [clientThingId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointAddThingToCompilation(compilationId: number, catalogThingId?: number, clientThingId?: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointAddThingToCompilation(compilationId, catalogThingId, clientThingId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationId 
     * @param {number} stylistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointAssignStylist(compilationId: number, stylistId: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointAssignStylist(compilationId, stylistId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointClientForm(id: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointClientForm(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointClientFormNew(id: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointClientFormNew(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointCopyLook(id: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointCopyLook(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationLookId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointDeleteLook(compilationLookId: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointDeleteLook(compilationLookId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationThingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointDeleteThing(compilationThingId: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointDeleteThing(compilationThingId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointGetOrder(id: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointGetOrder(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>} [orderStatus] 
     * @param {'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST'} [sortBy] 
     * @param {number} [clientId] 
     * @param {number} [stylistId] 
     * @param {number} [offset] 
     * @param {number} [length] 
     * @param {'DESC' | 'ASC'} [sortOrder] 
     * @param {string} [searchStr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointGetOrders(orderStatus?: Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>, sortBy?: 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST', clientId?: number, stylistId?: number, offset?: number, length?: number, sortOrder?: 'DESC' | 'ASC', searchStr?: string, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointGetOrders(orderStatus, sortBy, clientId, stylistId, offset, length, sortOrder, searchStr, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationId 
     * @param {number} deadlineMillis 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointOrderDeadline(compilationId: number, deadlineMillis: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointOrderDeadline(compilationId, deadlineMillis, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationId 
     * @param {'NEW' | 'IN_PROGRESS' | 'FINISHED'} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointOrderStatus(compilationId: number, status: 'NEW' | 'IN_PROGRESS' | 'FINISHED', options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointOrderStatus(compilationId, status, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>} [orderStatus] 
     * @param {'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST'} [sortBy] 
     * @param {number} [clientId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointOrders(orderStatus?: Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>, sortBy?: 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST', clientId?: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointOrders(orderStatus, sortBy, clientId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} url 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointParseItemUrl(url: string, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointParseItemUrl(url, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationLookId 
     * @param {number} thingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointRemoveThingFromLook(compilationLookId: number, thingId: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointRemoveThingFromLook(compilationLookId, thingId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} compilationId 
     * @param {number} [lookId] 
     * @param {number} [temperatureFrom] 
     * @param {number} [temperatureTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointSaveLook(compilationId: number, lookId?: number, temperatureFrom?: number, temperatureTo?: number, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointSaveLook(compilationId, lookId, temperatureFrom, temperatureTo, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} [id] 
     * @param {number} [compilationId] 
     * @param {string} [thingUrl] 
     * @param {string} [type] 
     * @param {string} [name] 
     * @param {string} [brandId] 
     * @param {string} [supplierId] 
     * @param {number} [colorId] 
     * @param {string} [size] 
     * @param {number} [price] 
     * @param {number} [priceDiscount] 
     * @param {number} [categoryId] 
     * @param {string} [temperatureFrom] 
     * @param {string} [temperatureTo] 
     * @param {string} [imageUrl] 
     * @param {string} [fileName] 
     * @param {object} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompilationsApi
     */
    public compilationEndpointUploadThing(id?: number, compilationId?: number, thingUrl?: string, type?: string, name?: string, brandId?: string, supplierId?: string, colorId?: number, size?: string, price?: number, priceDiscount?: number, categoryId?: number, temperatureFrom?: string, temperatureTo?: string, imageUrl?: string, fileName?: string, file?: object, options?: any) {
        return CompilationsApiFp(this.configuration).compilationEndpointUploadThing(id, compilationId, thingUrl, type, name, brandId, supplierId, colorId, size, price, priceDiscount, categoryId, temperatureFrom, temperatureTo, imageUrl, fileName, file, options)(this.axios, this.basePath);
    }

}


/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointDeleteFile(fileId: number, options: any = {}): RequestArgs {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling filesEndpointDeleteFile.');
            }
            const localVarPath = `/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointGetUserFile(userId: number, fileId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling filesEndpointGetUserFile.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling filesEndpointGetUserFile.');
            }
            const localVarPath = `/files/{userId}/{fileId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointGetUserFiles(userId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling filesEndpointGetUserFiles.');
            }
            const localVarPath = `/files/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [description] 
         * @param {number} [userId] 
         * @param {string} [fileName] 
         * @param {object} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointStoreFile(id?: number, description?: string, userId?: number, fileName?: string, file?: object, options: any = {}): RequestArgs {
            const localVarPath = `/files`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (id !== undefined) { 
                localVarFormParams.append('id', id as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (userId !== undefined) { 
                localVarFormParams.append('userId', userId as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('fileName', fileName as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointDeleteFile(fileId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = FilesApiAxiosParamCreator(configuration).filesEndpointDeleteFile(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointGetUserFile(userId: number, fileId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFileDTO> {
            const localVarAxiosArgs = FilesApiAxiosParamCreator(configuration).filesEndpointGetUserFile(userId, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointGetUserFiles(userId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserFileDTO>> {
            const localVarAxiosArgs = FilesApiAxiosParamCreator(configuration).filesEndpointGetUserFiles(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [description] 
         * @param {number} [userId] 
         * @param {string} [fileName] 
         * @param {object} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointStoreFile(id?: number, description?: string, userId?: number, fileName?: string, file?: object, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFileDTO> {
            const localVarAxiosArgs = FilesApiAxiosParamCreator(configuration).filesEndpointStoreFile(id, description, userId, fileName, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointDeleteFile(fileId: number, options?: any): AxiosPromise<void> {
            return FilesApiFp(configuration).filesEndpointDeleteFile(fileId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointGetUserFile(userId: number, fileId: number, options?: any): AxiosPromise<UserFileDTO> {
            return FilesApiFp(configuration).filesEndpointGetUserFile(userId, fileId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointGetUserFiles(userId: number, options?: any): AxiosPromise<Array<UserFileDTO>> {
            return FilesApiFp(configuration).filesEndpointGetUserFiles(userId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [description] 
         * @param {number} [userId] 
         * @param {string} [fileName] 
         * @param {object} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesEndpointStoreFile(id?: number, description?: string, userId?: number, fileName?: string, file?: object, options?: any): AxiosPromise<UserFileDTO> {
            return FilesApiFp(configuration).filesEndpointStoreFile(id, description, userId, fileName, file, options)(axios, basePath);
        },
    };
};

/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
export class FilesApi extends BaseAPI {
    /**
     * 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public filesEndpointDeleteFile(fileId: number, options?: any) {
        return FilesApiFp(this.configuration).filesEndpointDeleteFile(fileId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public filesEndpointGetUserFile(userId: number, fileId: number, options?: any) {
        return FilesApiFp(this.configuration).filesEndpointGetUserFile(userId, fileId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public filesEndpointGetUserFiles(userId: number, options?: any) {
        return FilesApiFp(this.configuration).filesEndpointGetUserFiles(userId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} [id] 
     * @param {string} [description] 
     * @param {number} [userId] 
     * @param {string} [fileName] 
     * @param {object} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public filesEndpointStoreFile(id?: number, description?: string, userId?: number, fileName?: string, file?: object, options?: any) {
        return FilesApiFp(this.configuration).filesEndpointStoreFile(id, description, userId, fileName, file, options)(this.axios, this.basePath);
    }

}


/**
 * LookApi - axios parameter creator
 * @export
 */
export const LookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * adds item from catalog to users things, returns thing item id
         * @param {number} userId 
         * @param {number} itemId 
         * @param {number} [priceId] 
         * @param {boolean} [isDream] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointAddCatalogItem(userId: number, itemId: number, priceId?: number, isDream?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling lookEndpointAddCatalogItem.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling lookEndpointAddCatalogItem.');
            }
            const localVarPath = `/looks/addCatalogItem`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (userId !== undefined) { 
                localVarFormParams.set('userId', userId as any);
            }
    
            if (itemId !== undefined) { 
                localVarFormParams.set('itemId', itemId as any);
            }
    
            if (priceId !== undefined) { 
                localVarFormParams.set('priceId', priceId as any);
            }
    
            if (isDream !== undefined) { 
                localVarFormParams.set('isDream', isDream as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [clientThingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointAddLookItems(id: number, clientThingIds?: Array<number>, catalogThingIds?: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling lookEndpointAddLookItems.');
            }
            const localVarPath = `/looks/look/{id}/addItems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (clientThingIds) {
            
                localVarFormParams.set('clientThingIds', clientThingIds.join(COLLECTION_FORMATS.csv));
            }
                if (catalogThingIds) {
            
                localVarFormParams.set('catalogThingIds', catalogThingIds.join(COLLECTION_FORMATS.csv));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointCloneLook(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling lookEndpointCloneLook.');
            }
            const localVarPath = `/looks/cloneLook/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteLook(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling lookEndpointDeleteLook.');
            }
            const localVarPath = `/looks/deleteLook/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteLooks(body: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling lookEndpointDeleteLooks.');
            }
            const localVarPath = `/looks/deleteLooks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteThing(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling lookEndpointDeleteThing.');
            }
            const localVarPath = `/looks/deleteThing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteThings(body: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling lookEndpointDeleteThings.');
            }
            const localVarPath = `/looks/deleteThings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLook(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling lookEndpointGetLook.');
            }
            const localVarPath = `/looks/look/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLookCategories(options: any = {}): RequestArgs {
            const localVarPath = `/looks/lookCategories`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * return user\'s looks. If status not set returns REAL looks
         * @param {number} userId 
         * @param {'REAL' | 'VIRTUAL' | 'SANDBOX'} [lookStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLooks(userId: number, lookStatus?: 'REAL' | 'VIRTUAL' | 'SANDBOX', options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling lookEndpointGetLooks.');
            }
            const localVarPath = `/looks/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (lookStatus !== undefined) {
                localVarQueryParameter['lookStatus'] = lookStatus;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLooksByCategory(userId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling lookEndpointGetLooksByCategory.');
            }
            const localVarPath = `/looks/looksCategory/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetThings(userId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling lookEndpointGetThings.');
            }
            const localVarPath = `/looks/things/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetThingsByCategory(userId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling lookEndpointGetThingsByCategory.');
            }
            const localVarPath = `/looks/thingsCategory/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} catalogItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetVirtualLooks(userId: number, catalogItemId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling lookEndpointGetVirtualLooks.');
            }
            // verify required parameter 'catalogItemId' is not null or undefined
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId','Required parameter catalogItemId was null or undefined when calling lookEndpointGetVirtualLooks.');
            }
            const localVarPath = `/looks/virtualLooks/{userId}/{catalogItemId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"catalogItemId"}}`, encodeURIComponent(String(catalogItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointImproveThingPicture(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling lookEndpointImproveThingPicture.');
            }
            const localVarPath = `/looks/improveThingPicture/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [thingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointRemoveLookItems(id: number, thingIds?: Array<number>, catalogThingIds?: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling lookEndpointRemoveLookItems.');
            }
            const localVarPath = `/looks/look/{id}/removeItems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (thingIds) {
            
                localVarFormParams.set('thingIds', thingIds.join(COLLECTION_FORMATS.csv));
            }
                if (catalogThingIds) {
            
                localVarFormParams.set('catalogThingIds', catalogThingIds.join(COLLECTION_FORMATS.csv));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * if userId is null than look will be created for current user. User with stylist role can create looks for other users. If lookId is null than new look will be created otherwise look will be updated
         * @param {number} userId 
         * @param {number} category 
         * @param {number} [lookId] 
         * @param {string} [lookStatus] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointSaveLook(userId: number, category: number, lookId?: number, lookStatus?: string, temperatureFrom?: string, temperatureTo?: string, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling lookEndpointSaveLook.');
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError('category','Required parameter category was null or undefined when calling lookEndpointSaveLook.');
            }
            const localVarPath = `/looks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (lookId !== undefined) { 
                localVarFormParams.set('lookId', lookId as any);
            }
    
            if (userId !== undefined) { 
                localVarFormParams.set('userId', userId as any);
            }
    
            if (category !== undefined) { 
                localVarFormParams.set('category', category as any);
            }
    
            if (lookStatus !== undefined) { 
                localVarFormParams.set('lookStatus', lookStatus as any);
            }
    
            if (temperatureFrom !== undefined) { 
                localVarFormParams.set('temperatureFrom', temperatureFrom as any);
            }
    
            if (temperatureTo !== undefined) { 
                localVarFormParams.set('temperatureTo', temperatureTo as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User with stylist role can create thing for other users. If thingId is null than new thing will be created otherwise thing will be updated
         * @param {number} categoryId 
         * @param {number} [thingId] 
         * @param {number} [userId] 
         * @param {string} [name] 
         * @param {string} [comments] 
         * @param {string} [brand] 
         * @param {string} [imageUrl] 
         * @param {string} [size] 
         * @param {number} [temperatureFrom] 
         * @param {number} [temperatureTo] 
         * @param {boolean} [dreamItem] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointSaveThing(categoryId: number, thingId?: number, userId?: number, name?: string, comments?: string, brand?: string, imageUrl?: string, size?: string, temperatureFrom?: number, temperatureTo?: number, dreamItem?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling lookEndpointSaveThing.');
            }
            const localVarPath = `/looks/saveThing`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (thingId !== undefined) { 
                localVarFormParams.set('thingId', thingId as any);
            }
    
            if (userId !== undefined) { 
                localVarFormParams.set('userId', userId as any);
            }
    
            if (categoryId !== undefined) { 
                localVarFormParams.set('categoryId', categoryId as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.set('name', name as any);
            }
    
            if (comments !== undefined) { 
                localVarFormParams.set('comments', comments as any);
            }
    
            if (brand !== undefined) { 
                localVarFormParams.set('brand', brand as any);
            }
    
            if (imageUrl !== undefined) { 
                localVarFormParams.set('imageUrl', imageUrl as any);
            }
    
            if (size !== undefined) { 
                localVarFormParams.set('size', size as any);
            }
    
            if (temperatureFrom !== undefined) { 
                localVarFormParams.set('temperatureFrom', temperatureFrom as any);
            }
    
            if (temperatureTo !== undefined) { 
                localVarFormParams.set('temperatureTo', temperatureTo as any);
            }
    
            if (dreamItem !== undefined) { 
                localVarFormParams.set('dreamItem', dreamItem as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<Thing>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointSaveThings(body?: Array<Thing>, options: any = {}): RequestArgs {
            const localVarPath = `/looks/saveThings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointUploadClientImage(clientId: number, fileName: string, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling lookEndpointUploadClientImage.');
            }
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling lookEndpointUploadClientImage.');
            }
            const localVarPath = `/looks/uploadClientImg/{clientId}/{fileName}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointUploadThingImage(thingId: number, fileName: string, options: any = {}): RequestArgs {
            // verify required parameter 'thingId' is not null or undefined
            if (thingId === null || thingId === undefined) {
                throw new RequiredError('thingId','Required parameter thingId was null or undefined when calling lookEndpointUploadThingImage.');
            }
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling lookEndpointUploadThingImage.');
            }
            const localVarPath = `/looks/uploadThingImg/{thingId}/{fileName}`
                .replace(`{${"thingId"}}`, encodeURIComponent(String(thingId)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImage(fileName: string, options: any = {}): RequestArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling serviceEndpointImproveImage.');
            }
            const localVarPath = `/service/improveImg/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fromUrl] 
         * @param {string} [toUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointReplaceImgByUrl(fromUrl?: string, toUrl?: string, options: any = {}): RequestArgs {
            const localVarPath = `/service/replaceImgByUrl`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (fromUrl !== undefined) { 
                localVarFormParams.set('fromUrl', fromUrl as any);
            }
    
            if (toUrl !== undefined) { 
                localVarFormParams.set('toUrl', toUrl as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {string} [pictUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointSetThingPictureFromUrl(thingId: number, pictUrl?: string, options: any = {}): RequestArgs {
            // verify required parameter 'thingId' is not null or undefined
            if (thingId === null || thingId === undefined) {
                throw new RequiredError('thingId','Required parameter thingId was null or undefined when calling serviceEndpointSetThingPictureFromUrl.');
            }
            const localVarPath = `/service/setThingPictureFromUrl/{thingId}`
                .replace(`{${"thingId"}}`, encodeURIComponent(String(thingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (pictUrl !== undefined) { 
                localVarFormParams.set('pictUrl', pictUrl as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LookApi - functional programming interface
 * @export
 */
export const LookApiFp = function(configuration?: Configuration) {
    return {
        /**
         * adds item from catalog to users things, returns thing item id
         * @param {number} userId 
         * @param {number} itemId 
         * @param {number} [priceId] 
         * @param {boolean} [isDream] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointAddCatalogItem(userId: number, itemId: number, priceId?: number, isDream?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointAddCatalogItem(userId, itemId, priceId, isDream, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [clientThingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointAddLookItems(id: number, clientThingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointAddLookItems(id, clientThingIds, catalogThingIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointCloneLook(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointCloneLook(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteLook(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointDeleteLook(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteLooks(body: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointDeleteLooks(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteThing(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointDeleteThing(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteThings(body: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointDeleteThings(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLook(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LookFullDTO> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointGetLook(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLookCategories(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LookCategoryTranslation>> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointGetLookCategories(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * return user\'s looks. If status not set returns REAL looks
         * @param {number} userId 
         * @param {'REAL' | 'VIRTUAL' | 'SANDBOX'} [lookStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLooks(userId: number, lookStatus?: 'REAL' | 'VIRTUAL' | 'SANDBOX', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LookFullDTO>> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointGetLooks(userId, lookStatus, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLooksByCategory(userId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<LookFullDTO>; }> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointGetLooksByCategory(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetThings(userId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ItemDTO>> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointGetThings(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetThingsByCategory(userId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<ItemDTO>; }> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointGetThingsByCategory(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} catalogItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetVirtualLooks(userId: number, catalogItemId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VirtualLookDTO>> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointGetVirtualLooks(userId, catalogItemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointImproveThingPicture(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointImproveThingPicture(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [thingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointRemoveLookItems(id: number, thingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointRemoveLookItems(id, thingIds, catalogThingIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * if userId is null than look will be created for current user. User with stylist role can create looks for other users. If lookId is null than new look will be created otherwise look will be updated
         * @param {number} userId 
         * @param {number} category 
         * @param {number} [lookId] 
         * @param {string} [lookStatus] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointSaveLook(userId: number, category: number, lookId?: number, lookStatus?: string, temperatureFrom?: string, temperatureTo?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointSaveLook(userId, category, lookId, lookStatus, temperatureFrom, temperatureTo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * User with stylist role can create thing for other users. If thingId is null than new thing will be created otherwise thing will be updated
         * @param {number} categoryId 
         * @param {number} [thingId] 
         * @param {number} [userId] 
         * @param {string} [name] 
         * @param {string} [comments] 
         * @param {string} [brand] 
         * @param {string} [imageUrl] 
         * @param {string} [size] 
         * @param {number} [temperatureFrom] 
         * @param {number} [temperatureTo] 
         * @param {boolean} [dreamItem] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointSaveThing(categoryId: number, thingId?: number, userId?: number, name?: string, comments?: string, brand?: string, imageUrl?: string, size?: string, temperatureFrom?: number, temperatureTo?: number, dreamItem?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointSaveThing(categoryId, thingId, userId, name, comments, brand, imageUrl, size, temperatureFrom, temperatureTo, dreamItem, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<Thing>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointSaveThings(body?: Array<Thing>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointSaveThings(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointUploadClientImage(clientId: number, fileName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointUploadClientImage(clientId, fileName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointUploadThingImage(thingId: number, fileName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).lookEndpointUploadThingImage(thingId, fileName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImage(fileName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImproveImageDTO> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).serviceEndpointImproveImage(fileName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [fromUrl] 
         * @param {string} [toUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointReplaceImgByUrl(fromUrl?: string, toUrl?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).serviceEndpointReplaceImgByUrl(fromUrl, toUrl, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {string} [pictUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointSetThingPictureFromUrl(thingId: number, pictUrl?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = LookApiAxiosParamCreator(configuration).serviceEndpointSetThingPictureFromUrl(thingId, pictUrl, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LookApi - factory interface
 * @export
 */
export const LookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * adds item from catalog to users things, returns thing item id
         * @param {number} userId 
         * @param {number} itemId 
         * @param {number} [priceId] 
         * @param {boolean} [isDream] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointAddCatalogItem(userId: number, itemId: number, priceId?: number, isDream?: boolean, options?: any): AxiosPromise<number> {
            return LookApiFp(configuration).lookEndpointAddCatalogItem(userId, itemId, priceId, isDream, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [clientThingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointAddLookItems(id: number, clientThingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any): AxiosPromise<void> {
            return LookApiFp(configuration).lookEndpointAddLookItems(id, clientThingIds, catalogThingIds, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointCloneLook(id: number, options?: any): AxiosPromise<number> {
            return LookApiFp(configuration).lookEndpointCloneLook(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteLook(id: number, options?: any): AxiosPromise<void> {
            return LookApiFp(configuration).lookEndpointDeleteLook(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteLooks(body: Array<number>, options?: any): AxiosPromise<void> {
            return LookApiFp(configuration).lookEndpointDeleteLooks(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteThing(id: number, options?: any): AxiosPromise<void> {
            return LookApiFp(configuration).lookEndpointDeleteThing(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointDeleteThings(body: Array<number>, options?: any): AxiosPromise<void> {
            return LookApiFp(configuration).lookEndpointDeleteThings(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLook(id: number, options?: any): AxiosPromise<LookFullDTO> {
            return LookApiFp(configuration).lookEndpointGetLook(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLookCategories(options?: any): AxiosPromise<Array<LookCategoryTranslation>> {
            return LookApiFp(configuration).lookEndpointGetLookCategories(options)(axios, basePath);
        },
        /**
         * return user\'s looks. If status not set returns REAL looks
         * @param {number} userId 
         * @param {'REAL' | 'VIRTUAL' | 'SANDBOX'} [lookStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLooks(userId: number, lookStatus?: 'REAL' | 'VIRTUAL' | 'SANDBOX', options?: any): AxiosPromise<Array<LookFullDTO>> {
            return LookApiFp(configuration).lookEndpointGetLooks(userId, lookStatus, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetLooksByCategory(userId: number, options?: any): AxiosPromise<{ [key: string]: Array<LookFullDTO>; }> {
            return LookApiFp(configuration).lookEndpointGetLooksByCategory(userId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetThings(userId: number, options?: any): AxiosPromise<Array<ItemDTO>> {
            return LookApiFp(configuration).lookEndpointGetThings(userId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetThingsByCategory(userId: number, options?: any): AxiosPromise<{ [key: string]: Array<ItemDTO>; }> {
            return LookApiFp(configuration).lookEndpointGetThingsByCategory(userId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} catalogItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointGetVirtualLooks(userId: number, catalogItemId: number, options?: any): AxiosPromise<Array<VirtualLookDTO>> {
            return LookApiFp(configuration).lookEndpointGetVirtualLooks(userId, catalogItemId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointImproveThingPicture(id: number, options?: any): AxiosPromise<void> {
            return LookApiFp(configuration).lookEndpointImproveThingPicture(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [thingIds] 
         * @param {Array<number>} [catalogThingIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointRemoveLookItems(id: number, thingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any): AxiosPromise<void> {
            return LookApiFp(configuration).lookEndpointRemoveLookItems(id, thingIds, catalogThingIds, options)(axios, basePath);
        },
        /**
         * if userId is null than look will be created for current user. User with stylist role can create looks for other users. If lookId is null than new look will be created otherwise look will be updated
         * @param {number} userId 
         * @param {number} category 
         * @param {number} [lookId] 
         * @param {string} [lookStatus] 
         * @param {string} [temperatureFrom] 
         * @param {string} [temperatureTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointSaveLook(userId: number, category: number, lookId?: number, lookStatus?: string, temperatureFrom?: string, temperatureTo?: string, options?: any): AxiosPromise<number> {
            return LookApiFp(configuration).lookEndpointSaveLook(userId, category, lookId, lookStatus, temperatureFrom, temperatureTo, options)(axios, basePath);
        },
        /**
         * User with stylist role can create thing for other users. If thingId is null than new thing will be created otherwise thing will be updated
         * @param {number} categoryId 
         * @param {number} [thingId] 
         * @param {number} [userId] 
         * @param {string} [name] 
         * @param {string} [comments] 
         * @param {string} [brand] 
         * @param {string} [imageUrl] 
         * @param {string} [size] 
         * @param {number} [temperatureFrom] 
         * @param {number} [temperatureTo] 
         * @param {boolean} [dreamItem] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointSaveThing(categoryId: number, thingId?: number, userId?: number, name?: string, comments?: string, brand?: string, imageUrl?: string, size?: string, temperatureFrom?: number, temperatureTo?: number, dreamItem?: boolean, options?: any): AxiosPromise<number> {
            return LookApiFp(configuration).lookEndpointSaveThing(categoryId, thingId, userId, name, comments, brand, imageUrl, size, temperatureFrom, temperatureTo, dreamItem, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<Thing>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointSaveThings(body?: Array<Thing>, options?: any): AxiosPromise<void> {
            return LookApiFp(configuration).lookEndpointSaveThings(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointUploadClientImage(clientId: number, fileName: string, options?: any): AxiosPromise<string> {
            return LookApiFp(configuration).lookEndpointUploadClientImage(clientId, fileName, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} thingId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookEndpointUploadThingImage(thingId: number, fileName: string, options?: any): AxiosPromise<string> {
            return LookApiFp(configuration).lookEndpointUploadThingImage(thingId, fileName, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImage(fileName: string, options?: any): AxiosPromise<ImproveImageDTO> {
            return LookApiFp(configuration).serviceEndpointImproveImage(fileName, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} [fromUrl] 
         * @param {string} [toUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointReplaceImgByUrl(fromUrl?: string, toUrl?: string, options?: any): AxiosPromise<void> {
            return LookApiFp(configuration).serviceEndpointReplaceImgByUrl(fromUrl, toUrl, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} thingId 
         * @param {string} [pictUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointSetThingPictureFromUrl(thingId: number, pictUrl?: string, options?: any): AxiosPromise<string> {
            return LookApiFp(configuration).serviceEndpointSetThingPictureFromUrl(thingId, pictUrl, options)(axios, basePath);
        },
    };
};

/**
 * LookApi - object-oriented interface
 * @export
 * @class LookApi
 * @extends {BaseAPI}
 */
export class LookApi extends BaseAPI {
    /**
     * adds item from catalog to users things, returns thing item id
     * @param {number} userId 
     * @param {number} itemId 
     * @param {number} [priceId] 
     * @param {boolean} [isDream] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointAddCatalogItem(userId: number, itemId: number, priceId?: number, isDream?: boolean, options?: any) {
        return LookApiFp(this.configuration).lookEndpointAddCatalogItem(userId, itemId, priceId, isDream, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {Array<number>} [clientThingIds] 
     * @param {Array<number>} [catalogThingIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointAddLookItems(id: number, clientThingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any) {
        return LookApiFp(this.configuration).lookEndpointAddLookItems(id, clientThingIds, catalogThingIds, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointCloneLook(id: number, options?: any) {
        return LookApiFp(this.configuration).lookEndpointCloneLook(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointDeleteLook(id: number, options?: any) {
        return LookApiFp(this.configuration).lookEndpointDeleteLook(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointDeleteLooks(body: Array<number>, options?: any) {
        return LookApiFp(this.configuration).lookEndpointDeleteLooks(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointDeleteThing(id: number, options?: any) {
        return LookApiFp(this.configuration).lookEndpointDeleteThing(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointDeleteThings(body: Array<number>, options?: any) {
        return LookApiFp(this.configuration).lookEndpointDeleteThings(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointGetLook(id: number, options?: any) {
        return LookApiFp(this.configuration).lookEndpointGetLook(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointGetLookCategories(options?: any) {
        return LookApiFp(this.configuration).lookEndpointGetLookCategories(options)(this.axios, this.basePath);
    }

    /**
     * return user\'s looks. If status not set returns REAL looks
     * @param {number} userId 
     * @param {'REAL' | 'VIRTUAL' | 'SANDBOX'} [lookStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointGetLooks(userId: number, lookStatus?: 'REAL' | 'VIRTUAL' | 'SANDBOX', options?: any) {
        return LookApiFp(this.configuration).lookEndpointGetLooks(userId, lookStatus, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointGetLooksByCategory(userId: number, options?: any) {
        return LookApiFp(this.configuration).lookEndpointGetLooksByCategory(userId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointGetThings(userId: number, options?: any) {
        return LookApiFp(this.configuration).lookEndpointGetThings(userId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointGetThingsByCategory(userId: number, options?: any) {
        return LookApiFp(this.configuration).lookEndpointGetThingsByCategory(userId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {number} catalogItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointGetVirtualLooks(userId: number, catalogItemId: number, options?: any) {
        return LookApiFp(this.configuration).lookEndpointGetVirtualLooks(userId, catalogItemId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointImproveThingPicture(id: number, options?: any) {
        return LookApiFp(this.configuration).lookEndpointImproveThingPicture(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {Array<number>} [thingIds] 
     * @param {Array<number>} [catalogThingIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointRemoveLookItems(id: number, thingIds?: Array<number>, catalogThingIds?: Array<number>, options?: any) {
        return LookApiFp(this.configuration).lookEndpointRemoveLookItems(id, thingIds, catalogThingIds, options)(this.axios, this.basePath);
    }

    /**
     * if userId is null than look will be created for current user. User with stylist role can create looks for other users. If lookId is null than new look will be created otherwise look will be updated
     * @param {number} userId 
     * @param {number} category 
     * @param {number} [lookId] 
     * @param {string} [lookStatus] 
     * @param {string} [temperatureFrom] 
     * @param {string} [temperatureTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointSaveLook(userId: number, category: number, lookId?: number, lookStatus?: string, temperatureFrom?: string, temperatureTo?: string, options?: any) {
        return LookApiFp(this.configuration).lookEndpointSaveLook(userId, category, lookId, lookStatus, temperatureFrom, temperatureTo, options)(this.axios, this.basePath);
    }

    /**
     * User with stylist role can create thing for other users. If thingId is null than new thing will be created otherwise thing will be updated
     * @param {number} categoryId 
     * @param {number} [thingId] 
     * @param {number} [userId] 
     * @param {string} [name] 
     * @param {string} [comments] 
     * @param {string} [brand] 
     * @param {string} [imageUrl] 
     * @param {string} [size] 
     * @param {number} [temperatureFrom] 
     * @param {number} [temperatureTo] 
     * @param {boolean} [dreamItem] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointSaveThing(categoryId: number, thingId?: number, userId?: number, name?: string, comments?: string, brand?: string, imageUrl?: string, size?: string, temperatureFrom?: number, temperatureTo?: number, dreamItem?: boolean, options?: any) {
        return LookApiFp(this.configuration).lookEndpointSaveThing(categoryId, thingId, userId, name, comments, brand, imageUrl, size, temperatureFrom, temperatureTo, dreamItem, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<Thing>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointSaveThings(body?: Array<Thing>, options?: any) {
        return LookApiFp(this.configuration).lookEndpointSaveThings(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointUploadClientImage(clientId: number, fileName: string, options?: any) {
        return LookApiFp(this.configuration).lookEndpointUploadClientImage(clientId, fileName, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} thingId 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public lookEndpointUploadThingImage(thingId: number, fileName: string, options?: any) {
        return LookApiFp(this.configuration).lookEndpointUploadThingImage(thingId, fileName, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public serviceEndpointImproveImage(fileName: string, options?: any) {
        return LookApiFp(this.configuration).serviceEndpointImproveImage(fileName, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} [fromUrl] 
     * @param {string} [toUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public serviceEndpointReplaceImgByUrl(fromUrl?: string, toUrl?: string, options?: any) {
        return LookApiFp(this.configuration).serviceEndpointReplaceImgByUrl(fromUrl, toUrl, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} thingId 
     * @param {string} [pictUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookApi
     */
    public serviceEndpointSetThingPictureFromUrl(thingId: number, pictUrl?: string, options?: any) {
        return LookApiFp(this.configuration).serviceEndpointSetThingPictureFromUrl(thingId, pictUrl, options)(this.axios, this.basePath);
    }

}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saleEndpointGetClientPurchases(options: any = {}): RequestArgs {
            const localVarPath = `/sale/clientPurchases`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saleEndpointGetProducts(options: any = {}): RequestArgs {
            const localVarPath = `/sale/products`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saleEndpointRegisterPurchase(productId: number, transactionId: string, options: any = {}): RequestArgs {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling saleEndpointRegisterPurchase.');
            }
            // verify required parameter 'transactionId' is not null or undefined
            if (transactionId === null || transactionId === undefined) {
                throw new RequiredError('transactionId','Required parameter transactionId was null or undefined when calling saleEndpointRegisterPurchase.');
            }
            const localVarPath = `/sale/purchase/{productId}/{transactionId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saleEndpointGetClientPurchases(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientPurchaseDTO>> {
            const localVarAxiosArgs = ProductsApiAxiosParamCreator(configuration).saleEndpointGetClientPurchases(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saleEndpointGetProducts(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDTO>> {
            const localVarAxiosArgs = ProductsApiAxiosParamCreator(configuration).saleEndpointGetProducts(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saleEndpointRegisterPurchase(productId: number, transactionId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ProductsApiAxiosParamCreator(configuration).saleEndpointRegisterPurchase(productId, transactionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saleEndpointGetClientPurchases(options?: any): AxiosPromise<Array<ClientPurchaseDTO>> {
            return ProductsApiFp(configuration).saleEndpointGetClientPurchases(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saleEndpointGetProducts(options?: any): AxiosPromise<Array<ProductDTO>> {
            return ProductsApiFp(configuration).saleEndpointGetProducts(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} productId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saleEndpointRegisterPurchase(productId: number, transactionId: string, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).saleEndpointRegisterPurchase(productId, transactionId, options)(axios, basePath);
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public saleEndpointGetClientPurchases(options?: any) {
        return ProductsApiFp(this.configuration).saleEndpointGetClientPurchases(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public saleEndpointGetProducts(options?: any) {
        return ProductsApiFp(this.configuration).saleEndpointGetProducts(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} productId 
     * @param {string} transactionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public saleEndpointRegisterPurchase(productId: number, transactionId: string, options?: any) {
        return ProductsApiFp(this.configuration).saleEndpointRegisterPurchase(productId, transactionId, options)(this.axios, this.basePath);
    }

}


/**
 * PromoCardApi - axios parameter creator
 * @export
 */
export const PromoCardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointDeleteCard(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling promoCardEndpointDeleteCard.');
            }
            const localVarPath = `/promocard/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointGetCard(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling promoCardEndpointGetCard.');
            }
            const localVarPath = `/promocard/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointGetCards(options: any = {}): RequestArgs {
            const localVarPath = `/promocard`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointGetPictures(options: any = {}): RequestArgs {
            const localVarPath = `/promocard/pictures`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns promo card id
         * @param {number} [id] 
         * @param {string} [title] 
         * @param {string} [extraTitle] 
         * @param {string} [textColorHex] 
         * @param {string} [goToLink] 
         * @param {string} [backgroundPictName] 
         * @param {number} [startFromMillis] 
         * @param {number} [endFromMillis] 
         * @param {'DRAFT' | 'ACTIVE' | 'CLOSED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointStoreCard(id?: number, title?: string, extraTitle?: string, textColorHex?: string, goToLink?: string, backgroundPictName?: string, startFromMillis?: number, endFromMillis?: number, status?: 'DRAFT' | 'ACTIVE' | 'CLOSED', options: any = {}): RequestArgs {
            const localVarPath = `/promocard`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (extraTitle !== undefined) {
                localVarQueryParameter['extraTitle'] = extraTitle;
            }

            if (textColorHex !== undefined) {
                localVarQueryParameter['textColorHex'] = textColorHex;
            }

            if (goToLink !== undefined) {
                localVarQueryParameter['goToLink'] = goToLink;
            }

            if (backgroundPictName !== undefined) {
                localVarQueryParameter['backgroundPictName'] = backgroundPictName;
            }

            if (startFromMillis !== undefined) {
                localVarQueryParameter['startFromMillis'] = startFromMillis;
            }

            if (endFromMillis !== undefined) {
                localVarQueryParameter['endFromMillis'] = endFromMillis;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromoCardApi - functional programming interface
 * @export
 */
export const PromoCardApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointDeleteCard(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = PromoCardApiAxiosParamCreator(configuration).promoCardEndpointDeleteCard(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointGetCard(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCardFullDTO> {
            const localVarAxiosArgs = PromoCardApiAxiosParamCreator(configuration).promoCardEndpointGetCard(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointGetCards(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromoCardShortDTO>> {
            const localVarAxiosArgs = PromoCardApiAxiosParamCreator(configuration).promoCardEndpointGetCards(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointGetPictures(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PromoPictDTO>> {
            const localVarAxiosArgs = PromoCardApiAxiosParamCreator(configuration).promoCardEndpointGetPictures(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns promo card id
         * @param {number} [id] 
         * @param {string} [title] 
         * @param {string} [extraTitle] 
         * @param {string} [textColorHex] 
         * @param {string} [goToLink] 
         * @param {string} [backgroundPictName] 
         * @param {number} [startFromMillis] 
         * @param {number} [endFromMillis] 
         * @param {'DRAFT' | 'ACTIVE' | 'CLOSED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointStoreCard(id?: number, title?: string, extraTitle?: string, textColorHex?: string, goToLink?: string, backgroundPictName?: string, startFromMillis?: number, endFromMillis?: number, status?: 'DRAFT' | 'ACTIVE' | 'CLOSED', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = PromoCardApiAxiosParamCreator(configuration).promoCardEndpointStoreCard(id, title, extraTitle, textColorHex, goToLink, backgroundPictName, startFromMillis, endFromMillis, status, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PromoCardApi - factory interface
 * @export
 */
export const PromoCardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointDeleteCard(id: number, options?: any): AxiosPromise<number> {
            return PromoCardApiFp(configuration).promoCardEndpointDeleteCard(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointGetCard(id: number, options?: any): AxiosPromise<PromoCardFullDTO> {
            return PromoCardApiFp(configuration).promoCardEndpointGetCard(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointGetCards(options?: any): AxiosPromise<Array<PromoCardShortDTO>> {
            return PromoCardApiFp(configuration).promoCardEndpointGetCards(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointGetPictures(options?: any): AxiosPromise<Array<PromoPictDTO>> {
            return PromoCardApiFp(configuration).promoCardEndpointGetPictures(options)(axios, basePath);
        },
        /**
         * returns promo card id
         * @param {number} [id] 
         * @param {string} [title] 
         * @param {string} [extraTitle] 
         * @param {string} [textColorHex] 
         * @param {string} [goToLink] 
         * @param {string} [backgroundPictName] 
         * @param {number} [startFromMillis] 
         * @param {number} [endFromMillis] 
         * @param {'DRAFT' | 'ACTIVE' | 'CLOSED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCardEndpointStoreCard(id?: number, title?: string, extraTitle?: string, textColorHex?: string, goToLink?: string, backgroundPictName?: string, startFromMillis?: number, endFromMillis?: number, status?: 'DRAFT' | 'ACTIVE' | 'CLOSED', options?: any): AxiosPromise<number> {
            return PromoCardApiFp(configuration).promoCardEndpointStoreCard(id, title, extraTitle, textColorHex, goToLink, backgroundPictName, startFromMillis, endFromMillis, status, options)(axios, basePath);
        },
    };
};

/**
 * PromoCardApi - object-oriented interface
 * @export
 * @class PromoCardApi
 * @extends {BaseAPI}
 */
export class PromoCardApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCardApi
     */
    public promoCardEndpointDeleteCard(id: number, options?: any) {
        return PromoCardApiFp(this.configuration).promoCardEndpointDeleteCard(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCardApi
     */
    public promoCardEndpointGetCard(id: number, options?: any) {
        return PromoCardApiFp(this.configuration).promoCardEndpointGetCard(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCardApi
     */
    public promoCardEndpointGetCards(options?: any) {
        return PromoCardApiFp(this.configuration).promoCardEndpointGetCards(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCardApi
     */
    public promoCardEndpointGetPictures(options?: any) {
        return PromoCardApiFp(this.configuration).promoCardEndpointGetPictures(options)(this.axios, this.basePath);
    }

    /**
     * returns promo card id
     * @param {number} [id] 
     * @param {string} [title] 
     * @param {string} [extraTitle] 
     * @param {string} [textColorHex] 
     * @param {string} [goToLink] 
     * @param {string} [backgroundPictName] 
     * @param {number} [startFromMillis] 
     * @param {number} [endFromMillis] 
     * @param {'DRAFT' | 'ACTIVE' | 'CLOSED'} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCardApi
     */
    public promoCardEndpointStoreCard(id?: number, title?: string, extraTitle?: string, textColorHex?: string, goToLink?: string, backgroundPictName?: string, startFromMillis?: number, endFromMillis?: number, status?: 'DRAFT' | 'ACTIVE' | 'CLOSED', options?: any) {
        return PromoCardApiFp(this.configuration).promoCardEndpointStoreCard(id, title, extraTitle, textColorHex, goToLink, backgroundPictName, startFromMillis, endFromMillis, status, options)(this.axios, this.basePath);
    }

}


/**
 * QrcodeApi - axios parameter creator
 * @export
 */
export const QrcodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This method recieves parameters from QR and returns found things from FNS
         * @param {string} t 
         * @param {string} s 
         * @param {string} fn 
         * @param {string} i 
         * @param {string} fp 
         * @param {string} n 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qREndpoint(t: string, s: string, fn: string, i: string, fp: string, n: string, options: any = {}): RequestArgs {
            // verify required parameter 't' is not null or undefined
            if (t === null || t === undefined) {
                throw new RequiredError('t','Required parameter t was null or undefined when calling qREndpoint.');
            }
            // verify required parameter 's' is not null or undefined
            if (s === null || s === undefined) {
                throw new RequiredError('s','Required parameter s was null or undefined when calling qREndpoint.');
            }
            // verify required parameter 'fn' is not null or undefined
            if (fn === null || fn === undefined) {
                throw new RequiredError('fn','Required parameter fn was null or undefined when calling qREndpoint.');
            }
            // verify required parameter 'i' is not null or undefined
            if (i === null || i === undefined) {
                throw new RequiredError('i','Required parameter i was null or undefined when calling qREndpoint.');
            }
            // verify required parameter 'fp' is not null or undefined
            if (fp === null || fp === undefined) {
                throw new RequiredError('fp','Required parameter fp was null or undefined when calling qREndpoint.');
            }
            // verify required parameter 'n' is not null or undefined
            if (n === null || n === undefined) {
                throw new RequiredError('n','Required parameter n was null or undefined when calling qREndpoint.');
            }
            const localVarPath = `/qr`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (t !== undefined) { 
                localVarFormParams.set('t', t as any);
            }
    
            if (s !== undefined) { 
                localVarFormParams.set('s', s as any);
            }
    
            if (fn !== undefined) { 
                localVarFormParams.set('fn', fn as any);
            }
    
            if (i !== undefined) { 
                localVarFormParams.set('i', i as any);
            }
    
            if (fp !== undefined) { 
                localVarFormParams.set('fp', fp as any);
            }
    
            if (n !== undefined) { 
                localVarFormParams.set('n', n as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method saves items to 1C
         * @param {Array<CheckItemDTO>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qREndpointSaveItems(body?: Array<CheckItemDTO>, options: any = {}): RequestArgs {
            const localVarPath = `/qr/saveItems`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QrcodeApi - functional programming interface
 * @export
 */
export const QrcodeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This method recieves parameters from QR and returns found things from FNS
         * @param {string} t 
         * @param {string} s 
         * @param {string} fn 
         * @param {string} i 
         * @param {string} fp 
         * @param {string} n 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qREndpoint(t: string, s: string, fn: string, i: string, fp: string, n: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CheckItemDTO>> {
            const localVarAxiosArgs = QrcodeApiAxiosParamCreator(configuration).qREndpoint(t, s, fn, i, fp, n, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This method saves items to 1C
         * @param {Array<CheckItemDTO>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qREndpointSaveItems(body?: Array<CheckItemDTO>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = QrcodeApiAxiosParamCreator(configuration).qREndpointSaveItems(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * QrcodeApi - factory interface
 * @export
 */
export const QrcodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This method recieves parameters from QR and returns found things from FNS
         * @param {string} t 
         * @param {string} s 
         * @param {string} fn 
         * @param {string} i 
         * @param {string} fp 
         * @param {string} n 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qREndpoint(t: string, s: string, fn: string, i: string, fp: string, n: string, options?: any): AxiosPromise<Array<CheckItemDTO>> {
            return QrcodeApiFp(configuration).qREndpoint(t, s, fn, i, fp, n, options)(axios, basePath);
        },
        /**
         * This method saves items to 1C
         * @param {Array<CheckItemDTO>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qREndpointSaveItems(body?: Array<CheckItemDTO>, options?: any): AxiosPromise<void> {
            return QrcodeApiFp(configuration).qREndpointSaveItems(body, options)(axios, basePath);
        },
    };
};

/**
 * QrcodeApi - object-oriented interface
 * @export
 * @class QrcodeApi
 * @extends {BaseAPI}
 */
export class QrcodeApi extends BaseAPI {
    /**
     * This method recieves parameters from QR and returns found things from FNS
     * @param {string} t 
     * @param {string} s 
     * @param {string} fn 
     * @param {string} i 
     * @param {string} fp 
     * @param {string} n 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QrcodeApi
     */
    public qREndpoint(t: string, s: string, fn: string, i: string, fp: string, n: string, options?: any) {
        return QrcodeApiFp(this.configuration).qREndpoint(t, s, fn, i, fp, n, options)(this.axios, this.basePath);
    }

    /**
     * This method saves items to 1C
     * @param {Array<CheckItemDTO>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QrcodeApi
     */
    public qREndpointSaveItems(body?: Array<CheckItemDTO>, options?: any) {
        return QrcodeApiFp(this.configuration).qREndpointSaveItems(body, options)(this.axios, this.basePath);
    }

}


/**
 * SandboxApi - axios parameter creator
 * @export
 */
export const SandboxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} clientId 
         * @param {number} catalogItemId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointAddItem(clientId: number, catalogItemId: number, priceId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling sandboxEndpointAddItem.');
            }
            // verify required parameter 'catalogItemId' is not null or undefined
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId','Required parameter catalogItemId was null or undefined when calling sandboxEndpointAddItem.');
            }
            // verify required parameter 'priceId' is not null or undefined
            if (priceId === null || priceId === undefined) {
                throw new RequiredError('priceId','Required parameter priceId was null or undefined when calling sandboxEndpointAddItem.');
            }
            const localVarPath = `/sandbox/item/{clientId}/{catalogItemId}/{priceId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"catalogItemId"}}`, encodeURIComponent(String(catalogItemId)))
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * look must have VIRTUAL status!
         * @param {number} clientId 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointAddVirtualLook(clientId: number, lookId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling sandboxEndpointAddVirtualLook.');
            }
            // verify required parameter 'lookId' is not null or undefined
            if (lookId === null || lookId === undefined) {
                throw new RequiredError('lookId','Required parameter lookId was null or undefined when calling sandboxEndpointAddVirtualLook.');
            }
            const localVarPath = `/sandbox/addVirtualLook/{clientId}/{lookId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"lookId"}}`, encodeURIComponent(String(lookId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointGetItems(clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling sandboxEndpointGetItems.');
            }
            const localVarPath = `/sandbox/items/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} sandBoxLookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveLookToClients(clientId: number, sandBoxLookId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling sandboxEndpointMoveLookToClients.');
            }
            // verify required parameter 'sandBoxLookId' is not null or undefined
            if (sandBoxLookId === null || sandBoxLookId === undefined) {
                throw new RequiredError('sandBoxLookId','Required parameter sandBoxLookId was null or undefined when calling sandboxEndpointMoveLookToClients.');
            }
            const localVarPath = `/sandbox/moveLook/{clientId}/{sandBoxLookId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"sandBoxLookId"}}`, encodeURIComponent(String(sandBoxLookId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {Array<number>} sandBoxLookIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveLooksToClient(clientId: number, sandBoxLookIds: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling sandboxEndpointMoveLooksToClient.');
            }
            // verify required parameter 'sandBoxLookIds' is not null or undefined
            if (sandBoxLookIds === null || sandBoxLookIds === undefined) {
                throw new RequiredError('sandBoxLookIds','Required parameter sandBoxLookIds was null or undefined when calling sandboxEndpointMoveLooksToClient.');
            }
            const localVarPath = `/sandbox/moveLooks/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (sandBoxLookIds) {
                localVarQueryParameter['sandBoxLookIds'] = sandBoxLookIds;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} sandBoxItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveThingToClients(clientId: number, sandBoxItemId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling sandboxEndpointMoveThingToClients.');
            }
            // verify required parameter 'sandBoxItemId' is not null or undefined
            if (sandBoxItemId === null || sandBoxItemId === undefined) {
                throw new RequiredError('sandBoxItemId','Required parameter sandBoxItemId was null or undefined when calling sandboxEndpointMoveThingToClients.');
            }
            const localVarPath = `/sandbox/moveItemToClients/{clientId}/{sandBoxItemId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"sandBoxItemId"}}`, encodeURIComponent(String(sandBoxItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {Array<number>} sandBoxItemIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveThingsToClient(clientId: number, sandBoxItemIds: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling sandboxEndpointMoveThingsToClient.');
            }
            // verify required parameter 'sandBoxItemIds' is not null or undefined
            if (sandBoxItemIds === null || sandBoxItemIds === undefined) {
                throw new RequiredError('sandBoxItemIds','Required parameter sandBoxItemIds was null or undefined when calling sandboxEndpointMoveThingsToClient.');
            }
            const localVarPath = `/sandbox/moveItemsToClient/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (sandBoxItemIds) {
                localVarQueryParameter['sandBoxItemIds'] = sandBoxItemIds;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} catalogItemId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointRemoveItem(clientId: number, catalogItemId: number, priceId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling sandboxEndpointRemoveItem.');
            }
            // verify required parameter 'catalogItemId' is not null or undefined
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId','Required parameter catalogItemId was null or undefined when calling sandboxEndpointRemoveItem.');
            }
            // verify required parameter 'priceId' is not null or undefined
            if (priceId === null || priceId === undefined) {
                throw new RequiredError('priceId','Required parameter priceId was null or undefined when calling sandboxEndpointRemoveItem.');
            }
            const localVarPath = `/sandbox/item/{clientId}/{catalogItemId}/{priceId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"catalogItemId"}}`, encodeURIComponent(String(catalogItemId)))
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {Array<SandboxItemDTO>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointRemoveItems(clientId: number, body: Array<SandboxItemDTO>, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling sandboxEndpointRemoveItems.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sandboxEndpointRemoveItems.');
            }
            const localVarPath = `/sandbox/item/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SandboxApi - functional programming interface
 * @export
 */
export const SandboxApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} clientId 
         * @param {number} catalogItemId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointAddItem(clientId: number, catalogItemId: number, priceId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogItemShortDTO> {
            const localVarAxiosArgs = SandboxApiAxiosParamCreator(configuration).sandboxEndpointAddItem(clientId, catalogItemId, priceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * look must have VIRTUAL status!
         * @param {number} clientId 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointAddVirtualLook(clientId: number, lookId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = SandboxApiAxiosParamCreator(configuration).sandboxEndpointAddVirtualLook(clientId, lookId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointGetItems(clientId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogItemShortDTO>> {
            const localVarAxiosArgs = SandboxApiAxiosParamCreator(configuration).sandboxEndpointGetItems(clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} sandBoxLookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveLookToClients(clientId: number, sandBoxLookId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = SandboxApiAxiosParamCreator(configuration).sandboxEndpointMoveLookToClients(clientId, sandBoxLookId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {Array<number>} sandBoxLookIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveLooksToClient(clientId: number, sandBoxLookIds: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SandboxApiAxiosParamCreator(configuration).sandboxEndpointMoveLooksToClient(clientId, sandBoxLookIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} sandBoxItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveThingToClients(clientId: number, sandBoxItemId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SandboxApiAxiosParamCreator(configuration).sandboxEndpointMoveThingToClients(clientId, sandBoxItemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {Array<number>} sandBoxItemIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveThingsToClient(clientId: number, sandBoxItemIds: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SandboxApiAxiosParamCreator(configuration).sandboxEndpointMoveThingsToClient(clientId, sandBoxItemIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} catalogItemId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointRemoveItem(clientId: number, catalogItemId: number, priceId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = SandboxApiAxiosParamCreator(configuration).sandboxEndpointRemoveItem(clientId, catalogItemId, priceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {Array<SandboxItemDTO>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointRemoveItems(clientId: number, body: Array<SandboxItemDTO>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SandboxApiAxiosParamCreator(configuration).sandboxEndpointRemoveItems(clientId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SandboxApi - factory interface
 * @export
 */
export const SandboxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} clientId 
         * @param {number} catalogItemId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointAddItem(clientId: number, catalogItemId: number, priceId: number, options?: any): AxiosPromise<CatalogItemShortDTO> {
            return SandboxApiFp(configuration).sandboxEndpointAddItem(clientId, catalogItemId, priceId, options)(axios, basePath);
        },
        /**
         * look must have VIRTUAL status!
         * @param {number} clientId 
         * @param {number} lookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointAddVirtualLook(clientId: number, lookId: number, options?: any): AxiosPromise<number> {
            return SandboxApiFp(configuration).sandboxEndpointAddVirtualLook(clientId, lookId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointGetItems(clientId: number, options?: any): AxiosPromise<Array<CatalogItemShortDTO>> {
            return SandboxApiFp(configuration).sandboxEndpointGetItems(clientId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} sandBoxLookId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveLookToClients(clientId: number, sandBoxLookId: number, options?: any): AxiosPromise<number> {
            return SandboxApiFp(configuration).sandboxEndpointMoveLookToClients(clientId, sandBoxLookId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {Array<number>} sandBoxLookIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveLooksToClient(clientId: number, sandBoxLookIds: Array<number>, options?: any): AxiosPromise<void> {
            return SandboxApiFp(configuration).sandboxEndpointMoveLooksToClient(clientId, sandBoxLookIds, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} sandBoxItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveThingToClients(clientId: number, sandBoxItemId: number, options?: any): AxiosPromise<void> {
            return SandboxApiFp(configuration).sandboxEndpointMoveThingToClients(clientId, sandBoxItemId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {Array<number>} sandBoxItemIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointMoveThingsToClient(clientId: number, sandBoxItemIds: Array<number>, options?: any): AxiosPromise<void> {
            return SandboxApiFp(configuration).sandboxEndpointMoveThingsToClient(clientId, sandBoxItemIds, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} catalogItemId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointRemoveItem(clientId: number, catalogItemId: number, priceId: number, options?: any): AxiosPromise<number> {
            return SandboxApiFp(configuration).sandboxEndpointRemoveItem(clientId, catalogItemId, priceId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {Array<SandboxItemDTO>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sandboxEndpointRemoveItems(clientId: number, body: Array<SandboxItemDTO>, options?: any): AxiosPromise<void> {
            return SandboxApiFp(configuration).sandboxEndpointRemoveItems(clientId, body, options)(axios, basePath);
        },
    };
};

/**
 * SandboxApi - object-oriented interface
 * @export
 * @class SandboxApi
 * @extends {BaseAPI}
 */
export class SandboxApi extends BaseAPI {
    /**
     * 
     * @param {number} clientId 
     * @param {number} catalogItemId 
     * @param {number} priceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxApi
     */
    public sandboxEndpointAddItem(clientId: number, catalogItemId: number, priceId: number, options?: any) {
        return SandboxApiFp(this.configuration).sandboxEndpointAddItem(clientId, catalogItemId, priceId, options)(this.axios, this.basePath);
    }

    /**
     * look must have VIRTUAL status!
     * @param {number} clientId 
     * @param {number} lookId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxApi
     */
    public sandboxEndpointAddVirtualLook(clientId: number, lookId: number, options?: any) {
        return SandboxApiFp(this.configuration).sandboxEndpointAddVirtualLook(clientId, lookId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxApi
     */
    public sandboxEndpointGetItems(clientId: number, options?: any) {
        return SandboxApiFp(this.configuration).sandboxEndpointGetItems(clientId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {number} sandBoxLookId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxApi
     */
    public sandboxEndpointMoveLookToClients(clientId: number, sandBoxLookId: number, options?: any) {
        return SandboxApiFp(this.configuration).sandboxEndpointMoveLookToClients(clientId, sandBoxLookId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {Array<number>} sandBoxLookIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxApi
     */
    public sandboxEndpointMoveLooksToClient(clientId: number, sandBoxLookIds: Array<number>, options?: any) {
        return SandboxApiFp(this.configuration).sandboxEndpointMoveLooksToClient(clientId, sandBoxLookIds, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {number} sandBoxItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxApi
     */
    public sandboxEndpointMoveThingToClients(clientId: number, sandBoxItemId: number, options?: any) {
        return SandboxApiFp(this.configuration).sandboxEndpointMoveThingToClients(clientId, sandBoxItemId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {Array<number>} sandBoxItemIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxApi
     */
    public sandboxEndpointMoveThingsToClient(clientId: number, sandBoxItemIds: Array<number>, options?: any) {
        return SandboxApiFp(this.configuration).sandboxEndpointMoveThingsToClient(clientId, sandBoxItemIds, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {number} catalogItemId 
     * @param {number} priceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxApi
     */
    public sandboxEndpointRemoveItem(clientId: number, catalogItemId: number, priceId: number, options?: any) {
        return SandboxApiFp(this.configuration).sandboxEndpointRemoveItem(clientId, catalogItemId, priceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {Array<SandboxItemDTO>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxApi
     */
    public sandboxEndpointRemoveItems(clientId: number, body: Array<SandboxItemDTO>, options?: any) {
        return SandboxApiFp(this.configuration).sandboxEndpointRemoveItems(clientId, body, options)(this.axios, this.basePath);
    }

}


/**
 * ServiceApi - axios parameter creator
 * @export
 */
export const ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * item_id examples: USERS_123 or TSUM_123
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointResetAiImage(itemId: string, options: any = {}): RequestArgs {
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling aIEndpointResetAiImage.');
            }
            const localVarPath = `/orange/resetAiImage/{item_id}`
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [type] 
         * @param {number} [scale] 
         * @param {string} [dimension] 
         * @param {boolean} [winter] 
         * @param {boolean} [colddemi] 
         * @param {boolean} [warmdemi] 
         * @param {boolean} [summer] 
         * @param {Array<string>} [styles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointSetItem(id?: number, type?: string, scale?: number, dimension?: string, winter?: boolean, colddemi?: boolean, warmdemi?: boolean, summer?: boolean, styles?: Array<string>, options: any = {}): RequestArgs {
            const localVarPath = `/orange/aiItem`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (id !== undefined) { 
                localVarFormParams.set('id', id as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.set('type', type as any);
            }
    
            if (scale !== undefined) { 
                localVarFormParams.set('scale', scale as any);
            }
    
            if (dimension !== undefined) { 
                localVarFormParams.set('dimension', dimension as any);
            }
    
            if (winter !== undefined) { 
                localVarFormParams.set('winter', winter as any);
            }
    
            if (colddemi !== undefined) { 
                localVarFormParams.set('colddemi', colddemi as any);
            }
    
            if (warmdemi !== undefined) { 
                localVarFormParams.set('warmdemi', warmdemi as any);
            }
    
            if (summer !== undefined) { 
                localVarFormParams.set('summer', summer as any);
            }
                if (styles) {
            
                localVarFormParams.set('styles', styles.join(COLLECTION_FORMATS.csv));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * id like USERS_123 or TSUM_1234
         * @param {string} [id] 
         * @param {string} [type] 
         * @param {number} [scale] 
         * @param {string} [dimension] 
         * @param {boolean} [winter] 
         * @param {boolean} [colddemi] 
         * @param {boolean} [warmdemi] 
         * @param {boolean} [summer] 
         * @param {Array<string>} [styles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointSetItemCommon(id?: string, type?: string, scale?: number, dimension?: string, winter?: boolean, colddemi?: boolean, warmdemi?: boolean, summer?: boolean, styles?: Array<string>, options: any = {}): RequestArgs {
            const localVarPath = `/orange/aiItemCommon`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (id !== undefined) { 
                localVarFormParams.set('id', id as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.set('type', type as any);
            }
    
            if (scale !== undefined) { 
                localVarFormParams.set('scale', scale as any);
            }
    
            if (dimension !== undefined) { 
                localVarFormParams.set('dimension', dimension as any);
            }
    
            if (winter !== undefined) { 
                localVarFormParams.set('winter', winter as any);
            }
    
            if (colddemi !== undefined) { 
                localVarFormParams.set('colddemi', colddemi as any);
            }
    
            if (warmdemi !== undefined) { 
                localVarFormParams.set('warmdemi', warmdemi as any);
            }
    
            if (summer !== undefined) { 
                localVarFormParams.set('summer', summer as any);
            }
                if (styles) {
            
                localVarFormParams.set('styles', styles.join(COLLECTION_FORMATS.csv));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<AiItemDTO>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointSetItems(body?: Array<AiItemDTO>, options: any = {}): RequestArgs {
            const localVarPath = `/orange/aiItems`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get temperature in the location. If location is null or empty returns by saved client location or Moscow if saved is empty
         * @param {string} city 
         * @param {string} country 
         * @param {string} region 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servceEndpointGetTemperatureInTheLocation(city: string, country: string, region: string, options: any = {}): RequestArgs {
            // verify required parameter 'city' is not null or undefined
            if (city === null || city === undefined) {
                throw new RequiredError('city','Required parameter city was null or undefined when calling servceEndpointGetTemperatureInTheLocation.');
            }
            // verify required parameter 'country' is not null or undefined
            if (country === null || country === undefined) {
                throw new RequiredError('country','Required parameter country was null or undefined when calling servceEndpointGetTemperatureInTheLocation.');
            }
            // verify required parameter 'region' is not null or undefined
            if (region === null || region === undefined) {
                throw new RequiredError('region','Required parameter region was null or undefined when calling servceEndpointGetTemperatureInTheLocation.');
            }
            const localVarPath = `/service/currentTemperature/{city}/{country}/{region}`
                .replace(`{${"city"}}`, encodeURIComponent(String(city)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)))
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get temperature in the location. If location is null or empty returns by saved client location or Moscow if saved is empty
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servceEndpointGetTemperatureInTheUsersLocation(userId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling servceEndpointGetTemperatureInTheUsersLocation.');
            }
            const localVarPath = `/service/userTemperature/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImage(fileName: string, options: any = {}): RequestArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling serviceEndpointImproveImage.');
            }
            const localVarPath = `/service/improveImg/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImageByUrl(url?: string, options: any = {}): RequestArgs {
            const localVarPath = `/service/improveImgByUrl`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (url !== undefined) { 
                localVarFormParams.set('url', url as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fromUrl] 
         * @param {string} [toUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointReplaceImgByUrl(fromUrl?: string, toUrl?: string, options: any = {}): RequestArgs {
            const localVarPath = `/service/replaceImgByUrl`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (fromUrl !== undefined) { 
                localVarFormParams.set('fromUrl', fromUrl as any);
            }
    
            if (toUrl !== undefined) { 
                localVarFormParams.set('toUrl', toUrl as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {string} [pictUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointSetThingPictureFromUrl(thingId: number, pictUrl?: string, options: any = {}): RequestArgs {
            // verify required parameter 'thingId' is not null or undefined
            if (thingId === null || thingId === undefined) {
                throw new RequiredError('thingId','Required parameter thingId was null or undefined when calling serviceEndpointSetThingPictureFromUrl.');
            }
            const localVarPath = `/service/setThingPictureFromUrl/{thingId}`
                .replace(`{${"thingId"}}`, encodeURIComponent(String(thingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (pictUrl !== undefined) { 
                localVarFormParams.set('pictUrl', pictUrl as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceApi - functional programming interface
 * @export
 */
export const ServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * item_id examples: USERS_123 or TSUM_123
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointResetAiImage(itemId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).aIEndpointResetAiImage(itemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [type] 
         * @param {number} [scale] 
         * @param {string} [dimension] 
         * @param {boolean} [winter] 
         * @param {boolean} [colddemi] 
         * @param {boolean} [warmdemi] 
         * @param {boolean} [summer] 
         * @param {Array<string>} [styles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointSetItem(id?: number, type?: string, scale?: number, dimension?: string, winter?: boolean, colddemi?: boolean, warmdemi?: boolean, summer?: boolean, styles?: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).aIEndpointSetItem(id, type, scale, dimension, winter, colddemi, warmdemi, summer, styles, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * id like USERS_123 or TSUM_1234
         * @param {string} [id] 
         * @param {string} [type] 
         * @param {number} [scale] 
         * @param {string} [dimension] 
         * @param {boolean} [winter] 
         * @param {boolean} [colddemi] 
         * @param {boolean} [warmdemi] 
         * @param {boolean} [summer] 
         * @param {Array<string>} [styles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointSetItemCommon(id?: string, type?: string, scale?: number, dimension?: string, winter?: boolean, colddemi?: boolean, warmdemi?: boolean, summer?: boolean, styles?: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).aIEndpointSetItemCommon(id, type, scale, dimension, winter, colddemi, warmdemi, summer, styles, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<AiItemDTO>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointSetItems(body?: Array<AiItemDTO>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).aIEndpointSetItems(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get temperature in the location. If location is null or empty returns by saved client location or Moscow if saved is empty
         * @param {string} city 
         * @param {string} country 
         * @param {string} region 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servceEndpointGetTemperatureInTheLocation(city: string, country: string, region: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemperatureDTO> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).servceEndpointGetTemperatureInTheLocation(city, country, region, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get temperature in the location. If location is null or empty returns by saved client location or Moscow if saved is empty
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servceEndpointGetTemperatureInTheUsersLocation(userId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemperatureDTO> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).servceEndpointGetTemperatureInTheUsersLocation(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImage(fileName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImproveImageDTO> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).serviceEndpointImproveImage(fileName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImageByUrl(url?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImproveImageDTO> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).serviceEndpointImproveImageByUrl(url, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [fromUrl] 
         * @param {string} [toUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointReplaceImgByUrl(fromUrl?: string, toUrl?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).serviceEndpointReplaceImgByUrl(fromUrl, toUrl, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} thingId 
         * @param {string} [pictUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointSetThingPictureFromUrl(thingId: number, pictUrl?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ServiceApiAxiosParamCreator(configuration).serviceEndpointSetThingPictureFromUrl(thingId, pictUrl, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ServiceApi - factory interface
 * @export
 */
export const ServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * item_id examples: USERS_123 or TSUM_123
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointResetAiImage(itemId: string, options?: any): AxiosPromise<string> {
            return ServiceApiFp(configuration).aIEndpointResetAiImage(itemId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [type] 
         * @param {number} [scale] 
         * @param {string} [dimension] 
         * @param {boolean} [winter] 
         * @param {boolean} [colddemi] 
         * @param {boolean} [warmdemi] 
         * @param {boolean} [summer] 
         * @param {Array<string>} [styles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointSetItem(id?: number, type?: string, scale?: number, dimension?: string, winter?: boolean, colddemi?: boolean, warmdemi?: boolean, summer?: boolean, styles?: Array<string>, options?: any): AxiosPromise<string> {
            return ServiceApiFp(configuration).aIEndpointSetItem(id, type, scale, dimension, winter, colddemi, warmdemi, summer, styles, options)(axios, basePath);
        },
        /**
         * id like USERS_123 or TSUM_1234
         * @param {string} [id] 
         * @param {string} [type] 
         * @param {number} [scale] 
         * @param {string} [dimension] 
         * @param {boolean} [winter] 
         * @param {boolean} [colddemi] 
         * @param {boolean} [warmdemi] 
         * @param {boolean} [summer] 
         * @param {Array<string>} [styles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointSetItemCommon(id?: string, type?: string, scale?: number, dimension?: string, winter?: boolean, colddemi?: boolean, warmdemi?: boolean, summer?: boolean, styles?: Array<string>, options?: any): AxiosPromise<string> {
            return ServiceApiFp(configuration).aIEndpointSetItemCommon(id, type, scale, dimension, winter, colddemi, warmdemi, summer, styles, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<AiItemDTO>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIEndpointSetItems(body?: Array<AiItemDTO>, options?: any): AxiosPromise<string> {
            return ServiceApiFp(configuration).aIEndpointSetItems(body, options)(axios, basePath);
        },
        /**
         * Get temperature in the location. If location is null or empty returns by saved client location or Moscow if saved is empty
         * @param {string} city 
         * @param {string} country 
         * @param {string} region 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servceEndpointGetTemperatureInTheLocation(city: string, country: string, region: string, options?: any): AxiosPromise<TemperatureDTO> {
            return ServiceApiFp(configuration).servceEndpointGetTemperatureInTheLocation(city, country, region, options)(axios, basePath);
        },
        /**
         * Get temperature in the location. If location is null or empty returns by saved client location or Moscow if saved is empty
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servceEndpointGetTemperatureInTheUsersLocation(userId: number, options?: any): AxiosPromise<TemperatureDTO> {
            return ServiceApiFp(configuration).servceEndpointGetTemperatureInTheUsersLocation(userId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImage(fileName: string, options?: any): AxiosPromise<ImproveImageDTO> {
            return ServiceApiFp(configuration).serviceEndpointImproveImage(fileName, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointImproveImageByUrl(url?: string, options?: any): AxiosPromise<ImproveImageDTO> {
            return ServiceApiFp(configuration).serviceEndpointImproveImageByUrl(url, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} [fromUrl] 
         * @param {string} [toUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointReplaceImgByUrl(fromUrl?: string, toUrl?: string, options?: any): AxiosPromise<void> {
            return ServiceApiFp(configuration).serviceEndpointReplaceImgByUrl(fromUrl, toUrl, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} thingId 
         * @param {string} [pictUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointSetThingPictureFromUrl(thingId: number, pictUrl?: string, options?: any): AxiosPromise<string> {
            return ServiceApiFp(configuration).serviceEndpointSetThingPictureFromUrl(thingId, pictUrl, options)(axios, basePath);
        },
    };
};

/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
export class ServiceApi extends BaseAPI {
    /**
     * item_id examples: USERS_123 or TSUM_123
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public aIEndpointResetAiImage(itemId: string, options?: any) {
        return ServiceApiFp(this.configuration).aIEndpointResetAiImage(itemId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} [id] 
     * @param {string} [type] 
     * @param {number} [scale] 
     * @param {string} [dimension] 
     * @param {boolean} [winter] 
     * @param {boolean} [colddemi] 
     * @param {boolean} [warmdemi] 
     * @param {boolean} [summer] 
     * @param {Array<string>} [styles] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public aIEndpointSetItem(id?: number, type?: string, scale?: number, dimension?: string, winter?: boolean, colddemi?: boolean, warmdemi?: boolean, summer?: boolean, styles?: Array<string>, options?: any) {
        return ServiceApiFp(this.configuration).aIEndpointSetItem(id, type, scale, dimension, winter, colddemi, warmdemi, summer, styles, options)(this.axios, this.basePath);
    }

    /**
     * id like USERS_123 or TSUM_1234
     * @param {string} [id] 
     * @param {string} [type] 
     * @param {number} [scale] 
     * @param {string} [dimension] 
     * @param {boolean} [winter] 
     * @param {boolean} [colddemi] 
     * @param {boolean} [warmdemi] 
     * @param {boolean} [summer] 
     * @param {Array<string>} [styles] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public aIEndpointSetItemCommon(id?: string, type?: string, scale?: number, dimension?: string, winter?: boolean, colddemi?: boolean, warmdemi?: boolean, summer?: boolean, styles?: Array<string>, options?: any) {
        return ServiceApiFp(this.configuration).aIEndpointSetItemCommon(id, type, scale, dimension, winter, colddemi, warmdemi, summer, styles, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<AiItemDTO>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public aIEndpointSetItems(body?: Array<AiItemDTO>, options?: any) {
        return ServiceApiFp(this.configuration).aIEndpointSetItems(body, options)(this.axios, this.basePath);
    }

    /**
     * Get temperature in the location. If location is null or empty returns by saved client location or Moscow if saved is empty
     * @param {string} city 
     * @param {string} country 
     * @param {string} region 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public servceEndpointGetTemperatureInTheLocation(city: string, country: string, region: string, options?: any) {
        return ServiceApiFp(this.configuration).servceEndpointGetTemperatureInTheLocation(city, country, region, options)(this.axios, this.basePath);
    }

    /**
     * Get temperature in the location. If location is null or empty returns by saved client location or Moscow if saved is empty
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public servceEndpointGetTemperatureInTheUsersLocation(userId: number, options?: any) {
        return ServiceApiFp(this.configuration).servceEndpointGetTemperatureInTheUsersLocation(userId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public serviceEndpointImproveImage(fileName: string, options?: any) {
        return ServiceApiFp(this.configuration).serviceEndpointImproveImage(fileName, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} [url] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public serviceEndpointImproveImageByUrl(url?: string, options?: any) {
        return ServiceApiFp(this.configuration).serviceEndpointImproveImageByUrl(url, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} [fromUrl] 
     * @param {string} [toUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public serviceEndpointReplaceImgByUrl(fromUrl?: string, toUrl?: string, options?: any) {
        return ServiceApiFp(this.configuration).serviceEndpointReplaceImgByUrl(fromUrl, toUrl, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} thingId 
     * @param {string} [pictUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public serviceEndpointSetThingPictureFromUrl(thingId: number, pictUrl?: string, options?: any) {
        return ServiceApiFp(this.configuration).serviceEndpointSetThingPictureFromUrl(thingId, pictUrl, options)(this.axios, this.basePath);
    }

}


/**
 * ShoppingApi - axios parameter creator
 * @export
 */
export const ShoppingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} shoppingId 
         * @param {number} catalogItemId 
         * @param {number} catalogItemPriceId 
         * @param {number} [quantity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointAddCartItem(shoppingId: number, catalogItemId: number, catalogItemPriceId: number, quantity?: number, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingId' is not null or undefined
            if (shoppingId === null || shoppingId === undefined) {
                throw new RequiredError('shoppingId','Required parameter shoppingId was null or undefined when calling shoppingEndpointAddCartItem.');
            }
            // verify required parameter 'catalogItemId' is not null or undefined
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId','Required parameter catalogItemId was null or undefined when calling shoppingEndpointAddCartItem.');
            }
            // verify required parameter 'catalogItemPriceId' is not null or undefined
            if (catalogItemPriceId === null || catalogItemPriceId === undefined) {
                throw new RequiredError('catalogItemPriceId','Required parameter catalogItemPriceId was null or undefined when calling shoppingEndpointAddCartItem.');
            }
            const localVarPath = `/shopping/addItem/{shoppingId}/{catalogItemId}/{catalogItemPriceId}`
                .replace(`{${"shoppingId"}}`, encodeURIComponent(String(shoppingId)))
                .replace(`{${"catalogItemId"}}`, encodeURIComponent(String(catalogItemId)))
                .replace(`{${"catalogItemPriceId"}}`, encodeURIComponent(String(catalogItemPriceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (quantity !== undefined) { 
                localVarFormParams.set('quantity', quantity as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'SAND_BOX' | 'BUYING' | 'FITTING' | 'BOUGHT' | 'REJECTED'} status 
         * @param {Array<number>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointChangeStatusOfShoppingItems(status: 'SAND_BOX' | 'BUYING' | 'FITTING' | 'BOUGHT' | 'REJECTED', body?: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'status' is not null or undefined
            if (status === null || status === undefined) {
                throw new RequiredError('status','Required parameter status was null or undefined when calling shoppingEndpointChangeStatusOfShoppingItems.');
            }
            const localVarPath = `/shopping/changeStatusOfShoppingItems/{status}`
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} shoppingItemIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointDeleteItem(shoppingItemIds: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingItemIds' is not null or undefined
            if (shoppingItemIds === null || shoppingItemIds === undefined) {
                throw new RequiredError('shoppingItemIds','Required parameter shoppingItemIds was null or undefined when calling shoppingEndpointDeleteItem.');
            }
            const localVarPath = `/shopping/removeItems`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (shoppingItemIds) {
            
                localVarFormParams.set('shoppingItemIds', shoppingItemIds.join(COLLECTION_FORMATS.csv));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} shoppingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointDeleteShopping(shoppingId: number, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingId' is not null or undefined
            if (shoppingId === null || shoppingId === undefined) {
                throw new RequiredError('shoppingId','Required parameter shoppingId was null or undefined when calling shoppingEndpointDeleteShopping.');
            }
            const localVarPath = `/shopping/{shoppingId}`
                .replace(`{${"shoppingId"}}`, encodeURIComponent(String(shoppingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CartItemShortDTO>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointEditCartItem(body?: Array<CartItemShortDTO>, options: any = {}): RequestArgs {
            const localVarPath = `/shopping/editItem`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointGetClientShoppings(clientId: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling shoppingEndpointGetClientShoppings.');
            }
            const localVarPath = `/shopping/clientShoppings/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointGetShopping(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling shoppingEndpointGetShopping.');
            }
            const localVarPath = `/shopping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointGetStudioList(options: any = {}): RequestArgs {
            const localVarPath = `/shopping/studiosList`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} title 
         * @param {number} [id] 
         * @param {string} [comments] 
         * @param {string} [status] 
         * @param {number} [shoppingDate] 
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [budget] 
         * @param {number} [studioId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointSaveShopping(clientId: number, title: string, id?: number, comments?: string, status?: string, shoppingDate?: number, timeFrom?: number, timeTo?: number, budget?: number, studioId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'clientId' is not null or undefined
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId','Required parameter clientId was null or undefined when calling shoppingEndpointSaveShopping.');
            }
            // verify required parameter 'title' is not null or undefined
            if (title === null || title === undefined) {
                throw new RequiredError('title','Required parameter title was null or undefined when calling shoppingEndpointSaveShopping.');
            }
            const localVarPath = `/shopping`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (id !== undefined) { 
                localVarFormParams.set('id', id as any);
            }
    
            if (clientId !== undefined) { 
                localVarFormParams.set('clientId', clientId as any);
            }
    
            if (title !== undefined) { 
                localVarFormParams.set('title', title as any);
            }
    
            if (comments !== undefined) { 
                localVarFormParams.set('comments', comments as any);
            }
    
            if (status !== undefined) { 
                localVarFormParams.set('status', status as any);
            }
    
            if (shoppingDate !== undefined) { 
                localVarFormParams.set('shoppingDate', shoppingDate as any);
            }
    
            if (timeFrom !== undefined) { 
                localVarFormParams.set('timeFrom', timeFrom as any);
            }
    
            if (timeTo !== undefined) { 
                localVarFormParams.set('timeTo', timeTo as any);
            }
    
            if (budget !== undefined) { 
                localVarFormParams.set('budget', budget as any);
            }
    
            if (studioId !== undefined) { 
                localVarFormParams.set('studioId', studioId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointShoppingItemStatusLabels(options: any = {}): RequestArgs {
            const localVarPath = `/shopping/shoppingItemStatusLabels`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShoppingApi - functional programming interface
 * @export
 */
export const ShoppingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} shoppingId 
         * @param {number} catalogItemId 
         * @param {number} catalogItemPriceId 
         * @param {number} [quantity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointAddCartItem(shoppingId: number, catalogItemId: number, catalogItemPriceId: number, quantity?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartItemDTO> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointAddCartItem(shoppingId, catalogItemId, catalogItemPriceId, quantity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {'SAND_BOX' | 'BUYING' | 'FITTING' | 'BOUGHT' | 'REJECTED'} status 
         * @param {Array<number>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointChangeStatusOfShoppingItems(status: 'SAND_BOX' | 'BUYING' | 'FITTING' | 'BOUGHT' | 'REJECTED', body?: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointChangeStatusOfShoppingItems(status, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<number>} shoppingItemIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointDeleteItem(shoppingItemIds: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointDeleteItem(shoppingItemIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} shoppingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointDeleteShopping(shoppingId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointDeleteShopping(shoppingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<CartItemShortDTO>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointEditCartItem(body?: Array<CartItemShortDTO>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointEditCartItem(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointGetClientShoppings(clientId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShoppingShortDTO>> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointGetClientShoppings(clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointGetShopping(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingDTO> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointGetShopping(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointGetStudioList(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StudioDTO>> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointGetStudioList(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} title 
         * @param {number} [id] 
         * @param {string} [comments] 
         * @param {string} [status] 
         * @param {number} [shoppingDate] 
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [budget] 
         * @param {number} [studioId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointSaveShopping(clientId: number, title: string, id?: number, comments?: string, status?: string, shoppingDate?: number, timeFrom?: number, timeTo?: number, budget?: number, studioId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingShortDTO> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointSaveShopping(clientId, title, id, comments, status, shoppingDate, timeFrom, timeTo, budget, studioId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointShoppingItemStatusLabels(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }> {
            const localVarAxiosArgs = ShoppingApiAxiosParamCreator(configuration).shoppingEndpointShoppingItemStatusLabels(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ShoppingApi - factory interface
 * @export
 */
export const ShoppingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} shoppingId 
         * @param {number} catalogItemId 
         * @param {number} catalogItemPriceId 
         * @param {number} [quantity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointAddCartItem(shoppingId: number, catalogItemId: number, catalogItemPriceId: number, quantity?: number, options?: any): AxiosPromise<CartItemDTO> {
            return ShoppingApiFp(configuration).shoppingEndpointAddCartItem(shoppingId, catalogItemId, catalogItemPriceId, quantity, options)(axios, basePath);
        },
        /**
         * 
         * @param {'SAND_BOX' | 'BUYING' | 'FITTING' | 'BOUGHT' | 'REJECTED'} status 
         * @param {Array<number>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointChangeStatusOfShoppingItems(status: 'SAND_BOX' | 'BUYING' | 'FITTING' | 'BOUGHT' | 'REJECTED', body?: Array<number>, options?: any): AxiosPromise<number> {
            return ShoppingApiFp(configuration).shoppingEndpointChangeStatusOfShoppingItems(status, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<number>} shoppingItemIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointDeleteItem(shoppingItemIds: Array<number>, options?: any): AxiosPromise<number> {
            return ShoppingApiFp(configuration).shoppingEndpointDeleteItem(shoppingItemIds, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} shoppingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointDeleteShopping(shoppingId: number, options?: any): AxiosPromise<number> {
            return ShoppingApiFp(configuration).shoppingEndpointDeleteShopping(shoppingId, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<CartItemShortDTO>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointEditCartItem(body?: Array<CartItemShortDTO>, options?: any): AxiosPromise<void> {
            return ShoppingApiFp(configuration).shoppingEndpointEditCartItem(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointGetClientShoppings(clientId: number, options?: any): AxiosPromise<Array<ShoppingShortDTO>> {
            return ShoppingApiFp(configuration).shoppingEndpointGetClientShoppings(clientId, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointGetShopping(id: number, options?: any): AxiosPromise<ShoppingDTO> {
            return ShoppingApiFp(configuration).shoppingEndpointGetShopping(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointGetStudioList(options?: any): AxiosPromise<Array<StudioDTO>> {
            return ShoppingApiFp(configuration).shoppingEndpointGetStudioList(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {string} title 
         * @param {number} [id] 
         * @param {string} [comments] 
         * @param {string} [status] 
         * @param {number} [shoppingDate] 
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [budget] 
         * @param {number} [studioId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointSaveShopping(clientId: number, title: string, id?: number, comments?: string, status?: string, shoppingDate?: number, timeFrom?: number, timeTo?: number, budget?: number, studioId?: number, options?: any): AxiosPromise<ShoppingShortDTO> {
            return ShoppingApiFp(configuration).shoppingEndpointSaveShopping(clientId, title, id, comments, status, shoppingDate, timeFrom, timeTo, budget, studioId, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingEndpointShoppingItemStatusLabels(options?: any): AxiosPromise<{ [key: string]: string; }> {
            return ShoppingApiFp(configuration).shoppingEndpointShoppingItemStatusLabels(options)(axios, basePath);
        },
    };
};

/**
 * ShoppingApi - object-oriented interface
 * @export
 * @class ShoppingApi
 * @extends {BaseAPI}
 */
export class ShoppingApi extends BaseAPI {
    /**
     * 
     * @param {number} shoppingId 
     * @param {number} catalogItemId 
     * @param {number} catalogItemPriceId 
     * @param {number} [quantity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointAddCartItem(shoppingId: number, catalogItemId: number, catalogItemPriceId: number, quantity?: number, options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointAddCartItem(shoppingId, catalogItemId, catalogItemPriceId, quantity, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {'SAND_BOX' | 'BUYING' | 'FITTING' | 'BOUGHT' | 'REJECTED'} status 
     * @param {Array<number>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointChangeStatusOfShoppingItems(status: 'SAND_BOX' | 'BUYING' | 'FITTING' | 'BOUGHT' | 'REJECTED', body?: Array<number>, options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointChangeStatusOfShoppingItems(status, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} shoppingItemIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointDeleteItem(shoppingItemIds: Array<number>, options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointDeleteItem(shoppingItemIds, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} shoppingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointDeleteShopping(shoppingId: number, options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointDeleteShopping(shoppingId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<CartItemShortDTO>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointEditCartItem(body?: Array<CartItemShortDTO>, options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointEditCartItem(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointGetClientShoppings(clientId: number, options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointGetClientShoppings(clientId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointGetShopping(id: number, options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointGetShopping(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointGetStudioList(options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointGetStudioList(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} clientId 
     * @param {string} title 
     * @param {number} [id] 
     * @param {string} [comments] 
     * @param {string} [status] 
     * @param {number} [shoppingDate] 
     * @param {number} [timeFrom] 
     * @param {number} [timeTo] 
     * @param {number} [budget] 
     * @param {number} [studioId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointSaveShopping(clientId: number, title: string, id?: number, comments?: string, status?: string, shoppingDate?: number, timeFrom?: number, timeTo?: number, budget?: number, studioId?: number, options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointSaveShopping(clientId, title, id, comments, status, shoppingDate, timeFrom, timeTo, budget, studioId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingApi
     */
    public shoppingEndpointShoppingItemStatusLabels(options?: any) {
        return ShoppingApiFp(this.configuration).shoppingEndpointShoppingItemStatusLabels(options)(this.axios, this.basePath);
    }

}


/**
 * StoriesApi - axios parameter creator
 * @export
 */
export const StoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} storyId 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointDeletePage(storyId: number, page: number, options: any = {}): RequestArgs {
            // verify required parameter 'storyId' is not null or undefined
            if (storyId === null || storyId === undefined) {
                throw new RequiredError('storyId','Required parameter storyId was null or undefined when calling storiesEndpointDeletePage.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling storiesEndpointDeletePage.');
            }
            const localVarPath = `/story/page/{storyId}/{page}`
                .replace(`{${"storyId"}}`, encodeURIComponent(String(storyId)))
                .replace(`{${"page"}}`, encodeURIComponent(String(page)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointDeleteStory(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling storiesEndpointDeleteStory.');
            }
            const localVarPath = `/story/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointGetStories(options: any = {}): RequestArgs {
            const localVarPath = `/story`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointGetStory(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling storiesEndpointGetStory.');
            }
            const localVarPath = `/story/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} page 
         * @param {string} html 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointStoreHtml(id: number, page: number, html: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling storiesEndpointStoreHtml.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling storiesEndpointStoreHtml.');
            }
            // verify required parameter 'html' is not null or undefined
            if (html === null || html === undefined) {
                throw new RequiredError('html','Required parameter html was null or undefined when calling storiesEndpointStoreHtml.');
            }
            const localVarPath = `/story/{id}/{page}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"page"}}`, encodeURIComponent(String(page)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (html !== undefined) { 
                localVarFormParams.set('html', html as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns story id
         * @param {number} [id] 
         * @param {'DRAFT' | 'ACTIVE' | 'CLOSED'} [status] 
         * @param {string} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointStoreStory(id?: number, status?: 'DRAFT' | 'ACTIVE' | 'CLOSED', title?: string, options: any = {}): RequestArgs {
            const localVarPath = `/story/store`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns pict path
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointUploadBackground(fileName: string, options: any = {}): RequestArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling storiesEndpointUploadBackground.');
            }
            const localVarPath = `/story/uploadBackground/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoriesApi - functional programming interface
 * @export
 */
export const StoriesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} storyId 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointDeletePage(storyId: number, page: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = StoriesApiAxiosParamCreator(configuration).storiesEndpointDeletePage(storyId, page, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointDeleteStory(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = StoriesApiAxiosParamCreator(configuration).storiesEndpointDeleteStory(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointGetStories(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoryAdminDTO>> {
            const localVarAxiosArgs = StoriesApiAxiosParamCreator(configuration).storiesEndpointGetStories(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointGetStory(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoryPagesDTO> {
            const localVarAxiosArgs = StoriesApiAxiosParamCreator(configuration).storiesEndpointGetStory(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} page 
         * @param {string} html 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointStoreHtml(id: number, page: number, html: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = StoriesApiAxiosParamCreator(configuration).storiesEndpointStoreHtml(id, page, html, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns story id
         * @param {number} [id] 
         * @param {'DRAFT' | 'ACTIVE' | 'CLOSED'} [status] 
         * @param {string} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointStoreStory(id?: number, status?: 'DRAFT' | 'ACTIVE' | 'CLOSED', title?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = StoriesApiAxiosParamCreator(configuration).storiesEndpointStoreStory(id, status, title, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns pict path
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointUploadBackground(fileName: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = StoriesApiAxiosParamCreator(configuration).storiesEndpointUploadBackground(fileName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StoriesApi - factory interface
 * @export
 */
export const StoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} storyId 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointDeletePage(storyId: number, page: number, options?: any): AxiosPromise<number> {
            return StoriesApiFp(configuration).storiesEndpointDeletePage(storyId, page, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointDeleteStory(id: number, options?: any): AxiosPromise<number> {
            return StoriesApiFp(configuration).storiesEndpointDeleteStory(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointGetStories(options?: any): AxiosPromise<Array<StoryAdminDTO>> {
            return StoriesApiFp(configuration).storiesEndpointGetStories(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointGetStory(id: number, options?: any): AxiosPromise<StoryPagesDTO> {
            return StoriesApiFp(configuration).storiesEndpointGetStory(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} page 
         * @param {string} html 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointStoreHtml(id: number, page: number, html: string, options?: any): AxiosPromise<number> {
            return StoriesApiFp(configuration).storiesEndpointStoreHtml(id, page, html, options)(axios, basePath);
        },
        /**
         * returns story id
         * @param {number} [id] 
         * @param {'DRAFT' | 'ACTIVE' | 'CLOSED'} [status] 
         * @param {string} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointStoreStory(id?: number, status?: 'DRAFT' | 'ACTIVE' | 'CLOSED', title?: string, options?: any): AxiosPromise<number> {
            return StoriesApiFp(configuration).storiesEndpointStoreStory(id, status, title, options)(axios, basePath);
        },
        /**
         * returns pict path
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storiesEndpointUploadBackground(fileName: string, options?: any): AxiosPromise<string> {
            return StoriesApiFp(configuration).storiesEndpointUploadBackground(fileName, options)(axios, basePath);
        },
    };
};

/**
 * StoriesApi - object-oriented interface
 * @export
 * @class StoriesApi
 * @extends {BaseAPI}
 */
export class StoriesApi extends BaseAPI {
    /**
     * 
     * @param {number} storyId 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoriesApi
     */
    public storiesEndpointDeletePage(storyId: number, page: number, options?: any) {
        return StoriesApiFp(this.configuration).storiesEndpointDeletePage(storyId, page, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoriesApi
     */
    public storiesEndpointDeleteStory(id: number, options?: any) {
        return StoriesApiFp(this.configuration).storiesEndpointDeleteStory(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoriesApi
     */
    public storiesEndpointGetStories(options?: any) {
        return StoriesApiFp(this.configuration).storiesEndpointGetStories(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoriesApi
     */
    public storiesEndpointGetStory(id: number, options?: any) {
        return StoriesApiFp(this.configuration).storiesEndpointGetStory(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {number} page 
     * @param {string} html 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoriesApi
     */
    public storiesEndpointStoreHtml(id: number, page: number, html: string, options?: any) {
        return StoriesApiFp(this.configuration).storiesEndpointStoreHtml(id, page, html, options)(this.axios, this.basePath);
    }

    /**
     * returns story id
     * @param {number} [id] 
     * @param {'DRAFT' | 'ACTIVE' | 'CLOSED'} [status] 
     * @param {string} [title] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoriesApi
     */
    public storiesEndpointStoreStory(id?: number, status?: 'DRAFT' | 'ACTIVE' | 'CLOSED', title?: string, options?: any) {
        return StoriesApiFp(this.configuration).storiesEndpointStoreStory(id, status, title, options)(this.axios, this.basePath);
    }

    /**
     * returns pict path
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoriesApi
     */
    public storiesEndpointUploadBackground(fileName: string, options?: any) {
        return StoriesApiFp(this.configuration).storiesEndpointUploadBackground(fileName, options)(this.axios, this.basePath);
    }

}


/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointChangeSubscriptionStatus(subscriptionId: number, status: 'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED', options: any = {}): RequestArgs {
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new RequiredError('subscriptionId','Required parameter subscriptionId was null or undefined when calling clientEndpointChangeSubscriptionStatus.');
            }
            // verify required parameter 'status' is not null or undefined
            if (status === null || status === undefined) {
                throw new RequiredError('status','Required parameter status was null or undefined when calling clientEndpointChangeSubscriptionStatus.');
            }
            const localVarPath = `/clients/changeSubscriptionStatus/{subscriptionId}/{status}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} productId 
         * @param {number} [price] 
         * @param {number} [finishAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointCreateClientSubscription(userId: number, productId: number, price?: number, finishAt?: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling clientEndpointCreateClientSubscription.');
            }
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling clientEndpointCreateClientSubscription.');
            }
            const localVarPath = `/clients/createClientSubscription`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (userId !== undefined) { 
                localVarFormParams.set('userId', userId as any);
            }
    
            if (productId !== undefined) { 
                localVarFormParams.set('productId', productId as any);
            }
    
            if (price !== undefined) { 
                localVarFormParams.set('price', price as any);
            }
    
            if (finishAt !== undefined) { 
                localVarFormParams.set('finishAt', finishAt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClientSubscription(userId: number, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling clientEndpointGetClientSubscription.');
            }
            const localVarPath = `/clients/getClientSubscription/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetProducts(options: any = {}): RequestArgs {
            const localVarPath = `/clients/getProducts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointChangeSubscriptionStatus(subscriptionId: number, status: 'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SubscriptionApiAxiosParamCreator(configuration).clientEndpointChangeSubscriptionStatus(subscriptionId, status, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} productId 
         * @param {number} [price] 
         * @param {number} [finishAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointCreateClientSubscription(userId: number, productId: number, price?: number, finishAt?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = SubscriptionApiAxiosParamCreator(configuration).clientEndpointCreateClientSubscription(userId, productId, price, finishAt, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClientSubscription(userId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientSubscriptionDTO>> {
            const localVarAxiosArgs = SubscriptionApiAxiosParamCreator(configuration).clientEndpointGetClientSubscription(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetProducts(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDTO>> {
            const localVarAxiosArgs = SubscriptionApiAxiosParamCreator(configuration).clientEndpointGetProducts(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} subscriptionId 
         * @param {'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointChangeSubscriptionStatus(subscriptionId: number, status: 'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED', options?: any): AxiosPromise<void> {
            return SubscriptionApiFp(configuration).clientEndpointChangeSubscriptionStatus(subscriptionId, status, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} productId 
         * @param {number} [price] 
         * @param {number} [finishAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointCreateClientSubscription(userId: number, productId: number, price?: number, finishAt?: number, options?: any): AxiosPromise<number> {
            return SubscriptionApiFp(configuration).clientEndpointCreateClientSubscription(userId, productId, price, finishAt, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetClientSubscription(userId: number, options?: any): AxiosPromise<Array<ClientSubscriptionDTO>> {
            return SubscriptionApiFp(configuration).clientEndpointGetClientSubscription(userId, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEndpointGetProducts(options?: any): AxiosPromise<Array<ProductDTO>> {
            return SubscriptionApiFp(configuration).clientEndpointGetProducts(options)(axios, basePath);
        },
    };
};

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
    /**
     * 
     * @param {number} subscriptionId 
     * @param {'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED'} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public clientEndpointChangeSubscriptionStatus(subscriptionId: number, status: 'CREATED' | 'BILL_SENT' | 'PAID' | 'CONFIRMED', options?: any) {
        return SubscriptionApiFp(this.configuration).clientEndpointChangeSubscriptionStatus(subscriptionId, status, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {number} productId 
     * @param {number} [price] 
     * @param {number} [finishAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public clientEndpointCreateClientSubscription(userId: number, productId: number, price?: number, finishAt?: number, options?: any) {
        return SubscriptionApiFp(this.configuration).clientEndpointCreateClientSubscription(userId, productId, price, finishAt, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public clientEndpointGetClientSubscription(userId: number, options?: any) {
        return SubscriptionApiFp(this.configuration).clientEndpointGetClientSubscription(userId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public clientEndpointGetProducts(options?: any) {
        return SubscriptionApiFp(this.configuration).clientEndpointGetProducts(options)(this.axios, this.basePath);
    }

}


/**
 * SupplierApi - axios parameter creator
 * @export
 */
export const SupplierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointListItems(options: any = {}): RequestArgs {
            const localVarPath = `/supplier/list`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} price 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointNewPrice(id: number, price: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling supplierEndpointNewPrice.');
            }
            // verify required parameter 'price' is not null or undefined
            if (price === null || price === undefined) {
                throw new RequiredError('price','Required parameter price was null or undefined when calling supplierEndpointNewPrice.');
            }
            const localVarPath = `/supplier/newPrice/{id}/{price}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"price"}}`, encodeURIComponent(String(price)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [replacementLink] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointOutOfStock(id: number, replacementLink?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling supplierEndpointOutOfStock.');
            }
            const localVarPath = `/supplier/outOfStock/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (replacementLink !== undefined) {
                localVarQueryParameter['replacementLink'] = replacementLink;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointSetReadyForDelivery(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling supplierEndpointSetReadyForDelivery.');
            }
            const localVarPath = `/supplier/readyForDelivery/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointSetReserved(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling supplierEndpointSetReserved.');
            }
            const localVarPath = `/supplier/reserved/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierApi - functional programming interface
 * @export
 */
export const SupplierApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointListItems(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupplierItemDTO>> {
            const localVarAxiosArgs = SupplierApiAxiosParamCreator(configuration).supplierEndpointListItems(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} price 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointNewPrice(id: number, price: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SupplierApiAxiosParamCreator(configuration).supplierEndpointNewPrice(id, price, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [replacementLink] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointOutOfStock(id: number, replacementLink?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SupplierApiAxiosParamCreator(configuration).supplierEndpointOutOfStock(id, replacementLink, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointSetReadyForDelivery(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SupplierApiAxiosParamCreator(configuration).supplierEndpointSetReadyForDelivery(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointSetReserved(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SupplierApiAxiosParamCreator(configuration).supplierEndpointSetReserved(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SupplierApi - factory interface
 * @export
 */
export const SupplierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointListItems(options?: any): AxiosPromise<Array<SupplierItemDTO>> {
            return SupplierApiFp(configuration).supplierEndpointListItems(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} price 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointNewPrice(id: number, price: number, options?: any): AxiosPromise<void> {
            return SupplierApiFp(configuration).supplierEndpointNewPrice(id, price, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [replacementLink] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointOutOfStock(id: number, replacementLink?: string, options?: any): AxiosPromise<void> {
            return SupplierApiFp(configuration).supplierEndpointOutOfStock(id, replacementLink, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointSetReadyForDelivery(id: number, options?: any): AxiosPromise<void> {
            return SupplierApiFp(configuration).supplierEndpointSetReadyForDelivery(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierEndpointSetReserved(id: number, options?: any): AxiosPromise<void> {
            return SupplierApiFp(configuration).supplierEndpointSetReserved(id, options)(axios, basePath);
        },
    };
};

/**
 * SupplierApi - object-oriented interface
 * @export
 * @class SupplierApi
 * @extends {BaseAPI}
 */
export class SupplierApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierApi
     */
    public supplierEndpointListItems(options?: any) {
        return SupplierApiFp(this.configuration).supplierEndpointListItems(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {number} price 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierApi
     */
    public supplierEndpointNewPrice(id: number, price: number, options?: any) {
        return SupplierApiFp(this.configuration).supplierEndpointNewPrice(id, price, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [replacementLink] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierApi
     */
    public supplierEndpointOutOfStock(id: number, replacementLink?: string, options?: any) {
        return SupplierApiFp(this.configuration).supplierEndpointOutOfStock(id, replacementLink, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierApi
     */
    public supplierEndpointSetReadyForDelivery(id: number, options?: any) {
        return SupplierApiFp(this.configuration).supplierEndpointSetReadyForDelivery(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierApi
     */
    public supplierEndpointSetReserved(id: number, options?: any) {
        return SupplierApiFp(this.configuration).supplierEndpointSetReserved(id, options)(this.axios, this.basePath);
    }

}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary login
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointExternalLogin(body?: string, options: any = {}): RequestArgs {
            const localVarPath = `/user/externalLogin`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method gets username and password and returns a unique token that identifies the user for subsequent interactions.
         * @summary login
         * @param {string} login 
         * @param {string} password 
         * @param {string} [captchaToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointLogin(login: string, password: string, captchaToken?: string, options: any = {}): RequestArgs {
            // verify required parameter 'login' is not null or undefined
            if (login === null || login === undefined) {
                throw new RequiredError('login','Required parameter login was null or undefined when calling loginEndpointLogin.');
            }
            // verify required parameter 'password' is not null or undefined
            if (password === null || password === undefined) {
                throw new RequiredError('password','Required parameter password was null or undefined when calling loginEndpointLogin.');
            }
            const localVarPath = `/user/login`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (login !== undefined) { 
                localVarFormParams.set('login', login as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (captchaToken !== undefined) { 
                localVarFormParams.set('captchaToken', captchaToken as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method gets phone number and sms code and returns a unique token that identifies the user for subsequent interactions.
         * @summary loginSms
         * @param {string} phoneNumber 
         * @param {string} smsCode 
         * @param {string} [captchaToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointLoginSms(phoneNumber: string, smsCode: string, captchaToken?: string, options: any = {}): RequestArgs {
            // verify required parameter 'phoneNumber' is not null or undefined
            if (phoneNumber === null || phoneNumber === undefined) {
                throw new RequiredError('phoneNumber','Required parameter phoneNumber was null or undefined when calling loginEndpointLoginSms.');
            }
            // verify required parameter 'smsCode' is not null or undefined
            if (smsCode === null || smsCode === undefined) {
                throw new RequiredError('smsCode','Required parameter smsCode was null or undefined when calling loginEndpointLoginSms.');
            }
            const localVarPath = `/user/loginSms`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (phoneNumber !== undefined) { 
                localVarFormParams.set('phoneNumber', phoneNumber as any);
            }
    
            if (smsCode !== undefined) { 
                localVarFormParams.set('smsCode', smsCode as any);
            }
    
            if (captchaToken !== undefined) { 
                localVarFormParams.set('captchaToken', captchaToken as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointLogout(options: any = {}): RequestArgs {
            const localVarPath = `/user/logout`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        test1(options: any = {}): RequestArgs {
            const localVarPath = `/user/test`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointChangePassword(newPassword: string, options: any = {}): RequestArgs {
            // verify required parameter 'newPassword' is not null or undefined
            if (newPassword === null || newPassword === undefined) {
                throw new RequiredError('newPassword','Required parameter newPassword was null or undefined when calling userEndpointChangePassword.');
            }
            const localVarPath = `/user/changePassword`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (newPassword !== undefined) {
                localVarQueryParameter['newPassword'] = newPassword;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetAllPermissions(options: any = {}): RequestArgs {
            const localVarPath = `/user/getAllPermissions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetAllRoles(options: any = {}): RequestArgs {
            const localVarPath = `/user/getAllRoles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetAllUser(options: any = {}): RequestArgs {
            const localVarPath = `/user/all`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetCurrentUser(options: any = {}): RequestArgs {
            const localVarPath = `/user/current`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetRoles(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userEndpointGetRoles.');
            }
            const localVarPath = `/user/{id}/roles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSecurityData(options: any = {}): RequestArgs {
            const localVarPath = `/user/securityData`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetUserCredentials(options: any = {}): RequestArgs {
            const localVarPath = `/user/currentUserCredentials`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointReadUser(id?: number, login?: string, options: any = {}): RequestArgs {
            const localVarPath = `/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (login !== undefined) {
                localVarQueryParameter['login'] = login;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRemoveUser(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userEndpointRemoveUser.');
            }
            const localVarPath = `/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRemoveUsers(id: Array<number>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userEndpointRemoveUsers.');
            }
            const localVarPath = `/user/remove`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id) {
            
                localVarFormParams.set('id', id.join(COLLECTION_FORMATS.csv));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method checks phone existing in the db and sends sms to user with 4 digit code if exists or throws USER_NOT_FOUND error otherwise. Number format should be international without leading plus (+), for example: 79111233445
         * @summary sendSms
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointSendSms(phoneNumber: string, options: any = {}): RequestArgs {
            // verify required parameter 'phoneNumber' is not null or undefined
            if (phoneNumber === null || phoneNumber === undefined) {
                throw new RequiredError('phoneNumber','Required parameter phoneNumber was null or undefined when calling userEndpointSendSms.');
            }
            const localVarPath = `/user/sendSms`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (phoneNumber !== undefined) { 
                localVarFormParams.set('phoneNumber', phoneNumber as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * set permissions to roles. Full replace (delete previous and set new list)
         * @param {number} roleId 
         * @param {Array<string>} permissionNames 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointSetRolePermissions(roleId: number, permissionNames: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new RequiredError('roleId','Required parameter roleId was null or undefined when calling userEndpointSetRolePermissions.');
            }
            // verify required parameter 'permissionNames' is not null or undefined
            if (permissionNames === null || permissionNames === undefined) {
                throw new RequiredError('permissionNames','Required parameter permissionNames was null or undefined when calling userEndpointSetRolePermissions.');
            }
            const localVarPath = `/user/setRolePermissions/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (permissionNames) {
                localVarQueryParameter['permissionNames'] = permissionNames;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserSaveDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointStoreUser(body?: UserSaveDTO, options: any = {}): RequestArgs {
            const localVarPath = `/user/store`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [email] 
         * @param {string} [password] 
         * @param {string} [firstName] 
         * @param {string} [surname] 
         * @param {string} [phone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointUpdateUser(id: number, email?: string, password?: string, firstName?: string, surname?: string, phone?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userEndpointUpdateUser.');
            }
            const localVarPath = `/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (id !== undefined) { 
                localVarFormParams.set('id', id as any);
            }
    
            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (firstName !== undefined) { 
                localVarFormParams.set('firstName', firstName as any);
            }
    
            if (surname !== undefined) { 
                localVarFormParams.set('surname', surname as any);
            }
    
            if (phone !== undefined) { 
                localVarFormParams.set('phone', phone as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary login
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointExternalLogin(body?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDTO> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).loginEndpointExternalLogin(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This method gets username and password and returns a unique token that identifies the user for subsequent interactions.
         * @summary login
         * @param {string} login 
         * @param {string} password 
         * @param {string} [captchaToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointLogin(login: string, password: string, captchaToken?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDTO> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).loginEndpointLogin(login, password, captchaToken, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This method gets phone number and sms code and returns a unique token that identifies the user for subsequent interactions.
         * @summary loginSms
         * @param {string} phoneNumber 
         * @param {string} smsCode 
         * @param {string} [captchaToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointLoginSms(phoneNumber: string, smsCode: string, captchaToken?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDTO> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).loginEndpointLoginSms(phoneNumber, smsCode, captchaToken, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointLogout(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).loginEndpointLogout(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        test1(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).test1(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} newPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointChangePassword(newPassword: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointChangePassword(newPassword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetAllPermissions(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionDTO>> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointGetAllPermissions(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetAllRoles(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDTO>> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointGetAllRoles(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetAllUser(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDTO>> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointGetAllUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetCurrentUser(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointGetCurrentUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetRoles(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDTO>> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointGetRoles(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSecurityData(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDTO>> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointGetSecurityData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetUserCredentials(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDTO>> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointGetUserCredentials(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointReadUser(id?: number, login?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointReadUser(id, login, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRemoveUser(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointRemoveUser(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<number>} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRemoveUsers(id: Array<number>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointRemoveUsers(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This method checks phone existing in the db and sends sms to user with 4 digit code if exists or throws USER_NOT_FOUND error otherwise. Number format should be international without leading plus (+), for example: 79111233445
         * @summary sendSms
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointSendSms(phoneNumber: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointSendSms(phoneNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * set permissions to roles. Full replace (delete previous and set new list)
         * @param {number} roleId 
         * @param {Array<string>} permissionNames 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointSetRolePermissions(roleId: number, permissionNames: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointSetRolePermissions(roleId, permissionNames, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {UserSaveDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointStoreUser(body?: UserSaveDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointStoreUser(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [email] 
         * @param {string} [password] 
         * @param {string} [firstName] 
         * @param {string} [surname] 
         * @param {string} [phone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointUpdateUser(id: number, email?: string, password?: string, firstName?: string, surname?: string, phone?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).userEndpointUpdateUser(id, email, password, firstName, surname, phone, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary login
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointExternalLogin(body?: string, options?: any): AxiosPromise<LoginResponseDTO> {
            return UserApiFp(configuration).loginEndpointExternalLogin(body, options)(axios, basePath);
        },
        /**
         * This method gets username and password and returns a unique token that identifies the user for subsequent interactions.
         * @summary login
         * @param {string} login 
         * @param {string} password 
         * @param {string} [captchaToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointLogin(login: string, password: string, captchaToken?: string, options?: any): AxiosPromise<LoginResponseDTO> {
            return UserApiFp(configuration).loginEndpointLogin(login, password, captchaToken, options)(axios, basePath);
        },
        /**
         * This method gets phone number and sms code and returns a unique token that identifies the user for subsequent interactions.
         * @summary loginSms
         * @param {string} phoneNumber 
         * @param {string} smsCode 
         * @param {string} [captchaToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointLoginSms(phoneNumber: string, smsCode: string, captchaToken?: string, options?: any): AxiosPromise<LoginResponseDTO> {
            return UserApiFp(configuration).loginEndpointLoginSms(phoneNumber, smsCode, captchaToken, options)(axios, basePath);
        },
        /**
         * 
         * @summary logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEndpointLogout(options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).loginEndpointLogout(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        test1(options?: any): AxiosPromise<UserDTO> {
            return UserApiFp(configuration).test1(options)(axios, basePath);
        },
        /**
         * 
         * @param {string} newPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointChangePassword(newPassword: string, options?: any): AxiosPromise<string> {
            return UserApiFp(configuration).userEndpointChangePassword(newPassword, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetAllPermissions(options?: any): AxiosPromise<Array<PermissionDTO>> {
            return UserApiFp(configuration).userEndpointGetAllPermissions(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetAllRoles(options?: any): AxiosPromise<Array<RoleDTO>> {
            return UserApiFp(configuration).userEndpointGetAllRoles(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetAllUser(options?: any): AxiosPromise<Array<UserDTO>> {
            return UserApiFp(configuration).userEndpointGetAllUser(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetCurrentUser(options?: any): AxiosPromise<UserDTO> {
            return UserApiFp(configuration).userEndpointGetCurrentUser(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetRoles(id: number, options?: any): AxiosPromise<Array<RoleDTO>> {
            return UserApiFp(configuration).userEndpointGetRoles(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSecurityData(options?: any): AxiosPromise<Array<RoleDTO>> {
            return UserApiFp(configuration).userEndpointGetSecurityData(options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetUserCredentials(options?: any): AxiosPromise<Array<RoleDTO>> {
            return UserApiFp(configuration).userEndpointGetUserCredentials(options)(axios, basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {string} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointReadUser(id?: number, login?: string, options?: any): AxiosPromise<UserDTO> {
            return UserApiFp(configuration).userEndpointReadUser(id, login, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRemoveUser(id: number, options?: any): AxiosPromise<boolean> {
            return UserApiFp(configuration).userEndpointRemoveUser(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<number>} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRemoveUsers(id: Array<number>, options?: any): AxiosPromise<{ [key: string]: boolean; }> {
            return UserApiFp(configuration).userEndpointRemoveUsers(id, options)(axios, basePath);
        },
        /**
         * This method checks phone existing in the db and sends sms to user with 4 digit code if exists or throws USER_NOT_FOUND error otherwise. Number format should be international without leading plus (+), for example: 79111233445
         * @summary sendSms
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointSendSms(phoneNumber: string, options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).userEndpointSendSms(phoneNumber, options)(axios, basePath);
        },
        /**
         * set permissions to roles. Full replace (delete previous and set new list)
         * @param {number} roleId 
         * @param {Array<string>} permissionNames 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointSetRolePermissions(roleId: number, permissionNames: Array<string>, options?: any): AxiosPromise<boolean> {
            return UserApiFp(configuration).userEndpointSetRolePermissions(roleId, permissionNames, options)(axios, basePath);
        },
        /**
         * 
         * @param {UserSaveDTO} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointStoreUser(body?: UserSaveDTO, options?: any): AxiosPromise<number> {
            return UserApiFp(configuration).userEndpointStoreUser(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [email] 
         * @param {string} [password] 
         * @param {string} [firstName] 
         * @param {string} [surname] 
         * @param {string} [phone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointUpdateUser(id: number, email?: string, password?: string, firstName?: string, surname?: string, phone?: string, options?: any): AxiosPromise<boolean> {
            return UserApiFp(configuration).userEndpointUpdateUser(id, email, password, firstName, surname, phone, options)(axios, basePath);
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary login
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public loginEndpointExternalLogin(body?: string, options?: any) {
        return UserApiFp(this.configuration).loginEndpointExternalLogin(body, options)(this.axios, this.basePath);
    }

    /**
     * This method gets username and password and returns a unique token that identifies the user for subsequent interactions.
     * @summary login
     * @param {string} login 
     * @param {string} password 
     * @param {string} [captchaToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public loginEndpointLogin(login: string, password: string, captchaToken?: string, options?: any) {
        return UserApiFp(this.configuration).loginEndpointLogin(login, password, captchaToken, options)(this.axios, this.basePath);
    }

    /**
     * This method gets phone number and sms code and returns a unique token that identifies the user for subsequent interactions.
     * @summary loginSms
     * @param {string} phoneNumber 
     * @param {string} smsCode 
     * @param {string} [captchaToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public loginEndpointLoginSms(phoneNumber: string, smsCode: string, captchaToken?: string, options?: any) {
        return UserApiFp(this.configuration).loginEndpointLoginSms(phoneNumber, smsCode, captchaToken, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public loginEndpointLogout(options?: any) {
        return UserApiFp(this.configuration).loginEndpointLogout(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public test1(options?: any) {
        return UserApiFp(this.configuration).test1(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} newPassword 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointChangePassword(newPassword: string, options?: any) {
        return UserApiFp(this.configuration).userEndpointChangePassword(newPassword, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointGetAllPermissions(options?: any) {
        return UserApiFp(this.configuration).userEndpointGetAllPermissions(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointGetAllRoles(options?: any) {
        return UserApiFp(this.configuration).userEndpointGetAllRoles(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointGetAllUser(options?: any) {
        return UserApiFp(this.configuration).userEndpointGetAllUser(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointGetCurrentUser(options?: any) {
        return UserApiFp(this.configuration).userEndpointGetCurrentUser(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointGetRoles(id: number, options?: any) {
        return UserApiFp(this.configuration).userEndpointGetRoles(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointGetSecurityData(options?: any) {
        return UserApiFp(this.configuration).userEndpointGetSecurityData(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointGetUserCredentials(options?: any) {
        return UserApiFp(this.configuration).userEndpointGetUserCredentials(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} [id] 
     * @param {string} [login] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointReadUser(id?: number, login?: string, options?: any) {
        return UserApiFp(this.configuration).userEndpointReadUser(id, login, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointRemoveUser(id: number, options?: any) {
        return UserApiFp(this.configuration).userEndpointRemoveUser(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointRemoveUsers(id: Array<number>, options?: any) {
        return UserApiFp(this.configuration).userEndpointRemoveUsers(id, options)(this.axios, this.basePath);
    }

    /**
     * This method checks phone existing in the db and sends sms to user with 4 digit code if exists or throws USER_NOT_FOUND error otherwise. Number format should be international without leading plus (+), for example: 79111233445
     * @summary sendSms
     * @param {string} phoneNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointSendSms(phoneNumber: string, options?: any) {
        return UserApiFp(this.configuration).userEndpointSendSms(phoneNumber, options)(this.axios, this.basePath);
    }

    /**
     * set permissions to roles. Full replace (delete previous and set new list)
     * @param {number} roleId 
     * @param {Array<string>} permissionNames 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointSetRolePermissions(roleId: number, permissionNames: Array<string>, options?: any) {
        return UserApiFp(this.configuration).userEndpointSetRolePermissions(roleId, permissionNames, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {UserSaveDTO} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointStoreUser(body?: UserSaveDTO, options?: any) {
        return UserApiFp(this.configuration).userEndpointStoreUser(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [email] 
     * @param {string} [password] 
     * @param {string} [firstName] 
     * @param {string} [surname] 
     * @param {string} [phone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userEndpointUpdateUser(id: number, email?: string, password?: string, firstName?: string, surname?: string, phone?: string, options?: any) {
        return UserApiFp(this.configuration).userEndpointUpdateUser(id, email, password, firstName, surname, phone, options)(this.axios, this.basePath);
    }

}


